/* eslint-disable */
// THIS FILE WAS GENERATED
// ALL CHANGES WILL BE OVERWRITTEN

// INFRASTRUCTURE START
  export type StandardError = globalThis.Error;
  export type Error500s = 501 | 502 | 503 | 504 | 505 | 506 | 507 | 508 | 510 | 511;
  export type ErrorStatuses = 0 | Error500s;
  export type ErrorResponse = FetchResponse<unknown, ErrorStatuses>;

  export type FetchResponseOfError = {
    data: null;
    error: StandardError;
    status: ErrorStatuses;
    args: FetchArgs;
  };

  export type FetchResponseOfSuccess<TData, TStatus extends number = 0> = 
  {
    data: TData;
    error: null;
    status: TStatus;
    args: FetchArgs;
    responseHeaders: Headers;
  };

  export type FetchResponse<TData, TStatus extends number = 0> = 
    TStatus extends ErrorStatuses ? FetchResponseOfError: FetchResponseOfSuccess<TData, TStatus>;

  export type TerminateRequest = null;
  export type TerminateResponse = null;

  export type Configuration = {
    apiUrl: string | (() => string);
    jwtKey: string | undefined | (() => string | null | undefined);
    requestMiddlewares?: Array<{
      name: string;
      fn: (request: FetchArgs) => FetchArgs | TerminateRequest;
    }>;
    responseMiddlewares?: Array<{
      name: string;
      fn: <TData, TStatus extends number>(
        response: FetchResponse<TData, TStatus>,
      ) => FetchResponse<TData, TStatus> | TerminateResponse;
    }>;
  };

  let CONFIG: Configuration = {
    apiUrl: () => "",
    jwtKey: undefined,
    requestMiddlewares: [],
    responseMiddlewares: [],
  };

  export function setupClient(configuration: Configuration) {
    const uniqMiddlewares = <
      T extends
        | Configuration["requestMiddlewares"]
        | Configuration["responseMiddlewares"],
    >(
      oldMiddlewares: T,
      newMiddlewares: T,
    ): T => {
      return [
        ...(oldMiddlewares?.filter(
          middleware => !newMiddlewares?.some(m => m.name === middleware.name),
        ) ?? []),
        ...(newMiddlewares ?? []),
      ] as T;
    };
  
    CONFIG = {
      ...CONFIG,
      ...configuration,
      requestMiddlewares: uniqMiddlewares(CONFIG.requestMiddlewares, configuration.requestMiddlewares),
      responseMiddlewares: uniqMiddlewares(CONFIG.responseMiddlewares, configuration.responseMiddlewares),
    };
  }

  export function getApiUrl() {
    if (typeof CONFIG.apiUrl === "function") {
      return CONFIG.apiUrl();
    }
    return CONFIG.apiUrl;
  }

  export type Termination = {
    termination: {
      name: string;
    };
  };

  export function processRequestWithMiddlewares(
    request: FetchArgs
  ): FetchArgs | Termination {
    for (const middleware of CONFIG.requestMiddlewares || []) {
      try {
        const middlewareResponse = middleware.fn(request);
        if (middlewareResponse === null) {
          return { termination: { name: middleware.name } };
        }
        request = middlewareResponse;
      } catch (e) {
        console.error("Request middleware error", e);
      }
    }
    return request;
  }

  export function processResponseWithMiddlewares<TData, TStatus extends number>(
    response: FetchResponse<TData, TStatus>,
  ): FetchResponse<TData, TStatus | 0> {
    for (const middleware of CONFIG.responseMiddlewares || []) {
      try {
        const middlewareResponse = middleware.fn(response);
        if (middlewareResponse === null) {
          return {
            status: 0,
            args: response.args,
            data: null,
            error: new Error(
              `Response terminated by middleware: ${middleware.name}`
            ),
          } satisfies FetchResponseOfError;
        }
        response = middlewareResponse;
      } catch (e) {
        console.error("Response middleware error", e);
      }
    }
    return response;
  }

  export type FetchArgsOptions = Omit<RequestInit, "method" | "redirect" | "body">;

  export type FetchArgs = {
    url: string;
    options: RequestInit;
  }

  export type UriComponent = string | number | boolean;
  export type ParamsObject = {
    [key: string]: UriComponent | UriComponent[] | undefined | null;
  };

  export async function fetchJson<TData>(args: FetchArgs): Promise<FetchResponse<TData, number> | FetchResponseOfError> {
    const errorResponse = (error: StandardError, status: number, args: FetchArgs) => {  
      const errorResponse = {
        status: status as ErrorStatuses,
        args,
        data: null,
        error,
      } satisfies FetchResponseOfError;

      return processResponseWithMiddlewares(errorResponse);
    };

    const errorStatus = (args: FetchArgs) => {
      const errorResponse = {
        status: 0,
        args,
        data: null,
        error: new Error("Network error"),
      } satisfies FetchResponseOfError;

      return processResponseWithMiddlewares(errorResponse);
    };

    try {
      const fetchRequest = processRequestWithMiddlewares(args);

      if ("termination" in fetchRequest) {
        const terminationResponse = {
          status: 0,
          args,
          data: null,
          error: new Error(
            `Request terminated by middleware: ${fetchRequest.termination.name}`
          ),
        } satisfies FetchResponseOfError;

        return processResponseWithMiddlewares(terminationResponse);
      }

      const fetchResponse: Response = await fetch(fetchRequest.url, fetchRequest.options);
      const status = fetchResponse.status;
      try {
        const json = await fetchResponse.json();
        const response = {
          data: json,
          status: fetchResponse.status,
          args,
          error: null,
          responseHeaders: fetchResponse.headers,
        };
        return processResponseWithMiddlewares(response);
      } catch (error) {
        return errorResponse(error as StandardError, status, args);
      }
    } catch {
      return errorStatus(args);
    }
  }

  export function getJwtKey(): string | null | undefined {
    if (typeof CONFIG.jwtKey === "function") {
      return CONFIG.jwtKey();
    }

    if (typeof CONFIG.jwtKey === "string") {
      return localStorage.getItem(CONFIG.jwtKey);
    }

    return undefined;
  } 
  
  
 function getApiRequestData<Type extends any>(
    requestContract: Type | undefined,
    isFormData: boolean = false
  ): FormData | Type | {} {
  
    if (!isFormData) {
      return requestContract !== undefined ? requestContract : {};
    }
  
    //multipart/form-data
    const formData = new FormData();
  
     if (requestContract) {
      Object.keys(requestContract).forEach(key => {
        const value = requestContract[key as keyof Type];
        const isKeyArrayAndValueIterable = key.endsWith('[]') && typeof (value as any)[Symbol.iterator] === 'function';
        const values = isKeyArrayAndValueIterable ? Array.from(value as Iterable<any>) : [value];
          for (const val of values) {
              if (val === undefined) {
                  continue;
              }
              if (val === null) {
                  formData.append(key, '');
              } else if (val instanceof File) {
                  formData.append(key, val);
              } else if (typeof val === 'object' && val !== null) {
                  formData.append(key, JSON.stringify(val));
              } else {
                  formData.append(key, val);
              }
          }
      });
    }
  
    return formData;
  }

  
function updateHeaders(headers: HeadersInit) {
  const token = getJwtKey();
  if (headers instanceof Headers) {
    if (!headers.has("Content-Type")) {
      headers.append("Content-Type", "application/json");
    }
    if (!headers.has("Authorization") && !!token) {
      headers.append("Authorization", token);
    }
    return;
  }

  if (Array.isArray(headers)) {
    if (!headers.find(([key]) => key === "Content-Type")) {
      headers.push(["Content-Type", "application/json"]);
    }
    if (!headers.find(([key]) => key === "Authorization") && !!token) {
      headers.push(["Authorization", token]);
    }
    return;
  }

  if (!headers["Content-Type"]) {
    headers["Content-Type"] = "application/json";
  }
  if (!headers.Authorization && !!token) {
    headers.Authorization = token;
  }
}

function removeContentTypeHeader(headers: HeadersInit) {
  if (headers instanceof Headers) {
    headers.delete("Content-Type");
    return;
  }

  if (Array.isArray(headers)) {
    return headers.filter(([key]) => key !== "Content-Type");
  }

  delete headers["Content-Type"];
}

export function createRequest<TRequest>(
  method: string,
  request: TRequest | undefined,
  options: FetchArgsOptions | undefined,
  url: string,
  paramsObject: ParamsObject = {},
) {
  const fetchOptions = options ?? {};

  if (!fetchOptions.headers) {
    fetchOptions.headers = new Headers();
  }

  updateHeaders(fetchOptions.headers);
  if (request instanceof FormData) {
    removeContentTypeHeader(fetchOptions.headers);
  }

  const body = (request instanceof FormData) ? request : JSON.stringify(request);
  const maybeQueryString = getQueryParamsString(paramsObject);

  const requestOptions: RequestInit = {
    ...fetchOptions,
    method,
    body,
    redirect: "follow",
  };

  return { options: requestOptions, url: `${url}${maybeQueryString}` } as FetchArgs;
}

export function getQueryParamsString(paramsObject: ParamsObject = {}) {
	const queryString = Object.entries(paramsObject)
    .map(([key, value]) => {
      if (Array.isArray(value)) {
        return value
          .map(val => `${encodeURIComponent(key)}=${encodeURIComponent(
            val,
          )}`)
          .join('&');
      }
      // Handling non-array parameters
      return value !== undefined && value !== null 
        ? `${encodeURIComponent(key)}=${encodeURIComponent(value)}` 
        : '';
    })
    .filter(part => part !== '')
    .join("&");

	return queryString.length > 0 ? `?${queryString}` : '';
}

export function apiPost<TResponse extends FetchResponse<unknown, number>, TRequest>(
  url: string,
  request: TRequest,
  options: FetchArgsOptions | undefined,
  paramsObject: ParamsObject = {}
) {
  return fetchJson<TResponse>(createRequest("POST", request, options, url, paramsObject));
}

export function apiGet<TResponse extends FetchResponse<unknown, number>>(
  url: string,
  options: FetchArgsOptions | undefined,
  paramsObject: ParamsObject = {}
) {
  return fetchJson<TResponse>(createRequest("GET", undefined, options, url, paramsObject));
}

export function apiPut<TResponse extends FetchResponse<unknown, number>, TRequest>(
  url: string,
  request: TRequest,
  options: FetchArgsOptions | undefined,
  paramsObject: ParamsObject = {}
) {
  return fetchJson<TResponse>(createRequest("PUT", request, options, url, paramsObject));
}

export function apiDelete<TResponse extends FetchResponse<unknown, number>>(
  url: string,
  options: FetchArgsOptions | undefined,
  paramsObject: ParamsObject = {}
) {
  return fetchJson<TResponse>(createRequest("DELETE", undefined, options, url, paramsObject));
}

export function apiPatch<TResponse extends FetchResponse<unknown, number>, TRequest>(
  url: string,
  request: TRequest,
  options: FetchArgsOptions | undefined,
  paramsObject: ParamsObject = {}
) {
  return fetchJson<TResponse>(createRequest("PATCH", request, options, url, paramsObject));
}
// INFRASTRUCTURE END

export type ActivityDetailResponseDTO = {
	id?: number | null;
	type: ClientActivityTypeEnum;
	date: string;
	timeFrom?: string | null;
	timeTo?: string | null;
	place?: string | null;
	title?: string | null;
	solved: boolean;
	creator: AgentSimpleResponseDTO;
	author: AgentSimpleResponseDTO;
};

export type ActivityListItemResponseDTO = {
	id?: number | null;
	type: ClientActivityTypeEnum;
	date: string;
	timeFrom?: string | null;
	timeTo?: string | null;
	place?: string | null;
	title?: string | null;
	solved?: boolean | null;
	author: AgentSimpleResponseDTO;
	discriminator: DashboardEventType;
};

export type AgentDetailResponseDTO = {
	id: number;
	uid: string;
	name?: string | null;
	email: string;
	phone?: string | null;
	conversationId?: number | null;
	conversationTitle?: string | null;
	hasSharedData: boolean;
};

export type AgentAssignedListItemResponseDTO = {
	id: number;
	uid: string;
	name: string;
	type: UserTypeEnum;
};

export type AgentSimpleResponseDTO = {
	id: number;
	name: string;
	type: UserTypeEnum;
};

export type AppConfigResponseDTO = {
	activeColor?: string | null;
	hspName?: string | null;
};

export type MortgageRateResponseDTO = {
	bankId: number;
	ltvFrom: number;
	ltvTo: number;
	amountFrom: number;
	amountTo?: number | null;
	maturityFrom: number;
	maturityTo: number;
	rate: number;
};

export type ClientFinancialPlanSaveExpenseRequestDTO = {
	id?: number | null;
	name: ClientFinancialPlanExpenseNameEnum;
	type: ClientFinancialPlanExpenseTypeEnum;
	monthlyPayment: number;
	sustainableAmount: number;
};

export type ClientFinancialPlanUpdateRequestDTO = {
	incomes?: ClientFinancialPlanIncomeSaveRequestDTO[] | null;
	expenses?: ClientFinancialPlanSaveExpenseRequestDTO[] | null;
};

export type ClientProfileAddressResponseDTO = {
	title?: string | null;
	street?: string | null;
	descriptiveNumber?: string | null;
	city?: string | null;
	zip?: string | null;
	country?: string | null;
	ruian?: string | null;
	gpsLat?: string | null;
	gpsLon?: string | null;
};

export type ClientProfileDataResponseDTO = {
	degreeBefore?: string | null;
	degreeAfter?: string | null;
	firstName?: string | null;
	lastName?: string | null;
	maritalStatus?: string | null;
	healthInsurance?: string | null;
	bornPlace?: string | null;
	bornDate?: string | null;
	identificationNumber?: string | null;
};

export type ClientProfileIdentificationDocumentResponseDTO = {
	id?: number | null;
	type?: ClientIdentificationDocumentTypeEnum | null;
	number?: string | null;
	issuer?: string | null;
	validToDate?: string | null;
};

export type ClientProfileResponseDTO = {
	data?: ClientProfileDataResponseDTO | null;
	contactPhone?: string | null;
	contactEmail?: string | null;
	addresses: ClientProfileAddressResponseDTO[];
	identificationDocuments: ClientProfileIdentificationDocumentResponseDTO[];
	photo?: string | null;
};

export type ClientActionRequest = {
	id: number;
	status: ClientActionRequestStatusEnum;
	completedAt?: string | null;
};

export type CreateClientActionRequestResponse = {
	id: number;
};

export type ImportClientActionRequest = {
	type: ClientActionRequestTypeEnum;
	clientUid: string;
	agentUid: string;
	data: unknown;
	deadlineAt?: string | null;
};

export enum ClientActionRequestStatusEnum {
	InProgress = "InProgress",
	Completed = "Completed",
	Cancelled = "Cancelled"
};

export enum ClientActionRequestTypeEnum {
	MeetingRecordSignature = "MeetingRecordSignature",
	InvestmentQuestionnaire = "InvestmentQuestionnaire"
};

export enum ArchivedFilterEnum {
	Active = "Active",
	Archived = "Archived",
	All = "All"
};

export enum SortDirectionEnum {
	Asc = "Asc",
	Desc = "Desc"
};

export type DashboardEventListItemResponseDTO = {
	identifier: string;
	type?: ClientActivityTypeEnum | null;
	eventType: DashboardEventType;
	title?: string | null;
	time?: string | null;
	timeTo?: string | null;
	date: string;
	solved: boolean;
	author: AgentSimpleResponseDTO;
};

export enum DashboardEventType {
	Activity = "Activity",
	Task = "Task"
};

export type DocumentDTO = {
	id: number;
	title: string;
	filename: string;
	createdAt: string;
	documentDate?: string | null;
	fileSize?: number | null;
	mimeType: string;
	type: DocumentLocalTypeEnum;
	documentType?: DocumentTypeEnum | null;
};

export type DocumentListResponseDTO = {
	documents: DocumentDTO[];
	tags: DocumentTagResponseDTO[];
};

export type DocumentEditRequestDTO = {
	title?: string | null;
	tags?: string[] | null;
};

export type DocumentUploadRequestDTO = {
	title?: string | null;
	tags?: string[] | null;
	file: File;
};

export type DocumentTagDeleteRequestDTO = {
	title: string;
};

export type DocumentTagEditRequestDTO = {
	titleToEdit: string;
	title: string;
};

export type DocumentTagResponseDTO = {
	title: string;
	documentCount?: number | null;
};

export enum DocumentLocalTypeEnum {
	Local = "Local",
	Remote = "Remote"
};

export enum DocumentTypeEnum {
	Portfolio = "Portfolio",
	Form = "Form",
	Sab = "Sab"
};

export type FuturePortfolioCreateRequestDTO = {
	goalId: number;
	name: string;
	type: FuturePortfolioTypeEnum;
	startAt: string;
	oneTimeDeposit?: number | null;
	monthlyAmount?: number | null;
	note?: string | null;
};

export type FuturePortfolioPartialUpdateRequestDTO = {
	name?: string | null;
	type?: FuturePortfolioTypeEnum | null;
	startAt?: string | null;
	oneTimeDeposit?: number | null;
	monthlyAmount?: number | null;
	note?: string | null;
};

export type CreateGoalRequestDTO = {
	name: string;
	investmentPlanCategoryType: GoalCategoryTypeEnum;
	currencyCode: string;
	investmentHorizonStartDate?: string | null;
	investmentHorizonEndDate: string;
	oneTimePayment?: number | null;
	periodicPayment?: number | null;
	loanAmount: number;
	ownFunds: number;
	monthlyRent?: number | null;
	rentYears?: number | null;
	statePension?: number | null;
	inspirationType?: InspirationTypeEnum | null;
};

export type GoalPortfolioRequestDTO = {
	portfolioId: number;
	usagePercent: number;
	type: GoalPortfolioTypeEnum;
};

export type UpdateGoalRequestDTO = {
	name?: string | null;
	investmentHorizonEndDate?: string | null;
	investmentHorizonStartDate?: string | null;
	currencyCode?: string | null;
	oneTimePayment?: number | null;
	periodicPayment?: number | null;
	loanAmount?: number | null;
	ownFunds?: number | null;
	monthlyRent?: number | null;
	rentYears?: number | null;
	statePension?: number | null;
	portfolios?: GoalPortfolioRequestDTO[] | null;
};

export type UpdateGoalStateRequestDTO = {
	state: GoalCompletionStateEnum;
};

export type GoalAttachedGoalResponseDTO = {
	name?: string | null;
	usagePercent: number;
};

export type GoalDetailResponseDTO = {
	id?: number | null;
	name?: string | null;
	investmentPlanCategoryType: GoalCategoryTypeEnum;
	targetAmount?: number | null;
	targetDate?: string | null;
	currencyCode?: CurrencyEnum | null;
	periodicPayment?: number | null;
	oneTimePayment?: number | null;
	loanAmount: number;
	ownFunds: number;
	monthlyRent?: number | null;
	rentYears?: number | null;
	statePension?: number | null;
	rentMode: boolean;
	allowEditByClient: boolean;
	state: GoalStateEnum;
	source?: GoalSourceEnum | null;
	coveredState?: GoalCoveredStateEnum | null;
	coveredAmount: number;
	fromAgent?: GoalFromAgentResponseDTO | null;
	portfolios: GoalPortfolioResponseDTO[];
	futurePortfolios: GoalFuturePortfolioResponseDTO[];
};

export type GoalFromAgentResponseDTO = {
	id: number;
	name: string;
};

export type GoalFuturePortfolioResponseDTO = {
	id: number;
	name: string;
	type: FuturePortfolioTypeEnum;
	oneTimeDeposit?: number | null;
	monthlyAmount?: number | null;
	currency: string;
	startAt: string;
	note?: string | null;
	state?: FuturePortfolioStateEnum | null;
	createdAt: string;
	portfolioValue: number;
	expectedCoverage: number;
};

export type GoalListItemResponseDTO = {
	id: number;
	name?: string | null;
	investmentPlanCategoryType: GoalCategoryTypeEnum;
	targetAmount?: number | null;
	targetDate?: string | null;
	currencyCode?: CurrencyEnum | null;
	periodicPayment?: number | null;
	coveredState?: GoalCoveredStateEnum | null;
	coveredAmount: number;
	state: GoalStateEnum;
};

export type GoalPortfolioListItemResponseDTO = {
	id: number;
	fromAgent: GoalFromAgentResponseDTO;
	title?: string | null;
	producer?: string | null;
	domain?: ClientPortfolioDomainEnum | null;
	portfolioValue?: number | null;
	usagePercent: number;
	attachedToGoals: GoalAttachedGoalResponseDTO[];
};

export type GoalPortfolioResponseDTO = {
	portfolioId: number;
	usagePercent: number;
	type: GoalPortfolioTypeEnum;
	name?: string | null;
	producer?: string | null;
	product?: string | null;
	domain?: ClientPortfolioDomainEnum | null;
	portfolioValue?: number | null;
	usageValue?: number | null;
	expectedCoverage?: number | null;
};

export enum GoalCompletionStateEnum {
	Completed = "Completed",
	NotCompleted = "NotCompleted"
};

export enum GoalStateEnum {
	Created = "Created",
	Active = "Active",
	Completed = "Completed"
};

export enum InspirationTypeEnum {
	OwnHome = "OwnHome",
	EarlyFreedom = "EarlyFreedom",
	Retirement = "Retirement"
};

export type CreateIdentificationDocumentRequestDTO = {
	documentType: ClientIdentificationDocumentTypeEnum;
	name?: string | null;
	number?: string | null;
	validTo?: string | null;
};

export type UpdateIdentificationDocumentRequestDTO = {
	documentType: ClientIdentificationDocumentTypeEnum;
	name?: string | null;
	number?: string | null;
	validTo?: string | null;
};

export type IdentificationDocumentDetailResponseDTO = {
	id: number;
	documentType: ClientIdentificationDocumentTypeEnum;
	name?: string | null;
	number?: string | null;
	validFrom?: string | null;
	validTo?: string | null;
	archivedAt?: string | null;
};

export type IdentificationDocumentListItemResponseDTO = {
	id: number;
	documentType: ClientIdentificationDocumentTypeEnum;
	name?: string | null;
	number?: string | null;
	validTo?: string | null;
	archivedAt?: string | null;
};

export type IdentificationDocumentResponseDTO = {
	id: number;
	documentType: ClientIdentificationDocumentTypeEnum;
	name?: string | null;
	number?: string | null;
	validTo?: string | null;
};

export type IdentificationDocumentSyncRetryResponseDTO = {
	published: number;
	skipped: number;
	batchLimited: boolean;
};

export enum IdentificationDocumentStateEnum {
	Active = "Active",
	Archived = "Archived"
};

export type AgentClientRequestDTO = {
	agentUid: string;
	clientUid: string;
};

export type GenerateAgentReadOnlyTokenRequest = {
	identifier: string;
	agentUid: string;
	clientUid: string;
};

export type ImportActivitySendRequestDTO = {
	clientUid: string;
	agentUid: string;
	type: NotificationActivityTypeEnum;
	activityName: string;
	activityIdentifier: string;
	mydockSubdomain: string;
	activityType: string;
	term?: string | null;
	fromTerm?: string | null;
	toTerm?: string | null;
	activityDescription?: string | null;
	activityTimeFrom?: string | null;
	activityTimeTo?: string | null;
};

export type ImportActivitySynchronizeRequestDTO = {
	clientUids?: string[] | null;
	agentUid: string;
	creatorUid: string;
	mydockActivityId: number;
	mydockSubdomain: string;
	agentName: string;
	title?: string | null;
	solved: boolean;
	myplannShared: boolean;
	place?: string | null;
	type: ClientActivityTypeEnum;
	date: string;
	timeFrom?: string | null;
	timeTo?: string | null;
	groupId: number;
};

export type ImportGoalSynchronizeRequestDTO = {
	clientUid: string;
	agentUid: string;
	creatorUid: string;
	sharedId: string;
	mydockSubdomain: string;
	groupId: number;
	date: string;
	deleted: boolean;
	investmentPlanCategoryType: GoalCategoryTypeEnum;
	name?: string | null;
	investmentFundingType?: GoalFundingTypeEnum | null;
	targetAmount?: number | null;
	targetDate?: string | null;
	currencyCode?: CurrencyEnum | null;
	oneTimePayment?: number | null;
	periodicPayment?: number | null;
	state: GoalStateEnum;
};

export type ImportInvestmentQuestionnaireNotificationRequestDTO = {
	clientUid: string;
	identificationNumber: string;
	clientType: NsureClientTypeEnum;
};

export type ImportPortfolioReportingEventRequestDTO = {
	type: ImportPortfolioReportingEventTypeEnum;
};

export type ImportTaskSendRequestDTO = {
	clientUid: string;
	agentUid: string;
	type: NotificationTaskTypeEnum;
	taskIdentifier: string;
	mydockSubdomain: string;
	taskTitle: string;
	taskDueDate?: string | null;
	taskDueDateFrom?: string | null;
	taskTime?: string | null;
};

export type ImportTaskSynchronizeRequestDTO = {
	clientUids?: string[] | null;
	agentUid: string;
	creatorUid: string;
	assignAgentUid?: string | null;
	taskerPublicId: string;
	mydockSubdomain: string;
	title: string;
	myplannShared: boolean;
	date?: string | null;
	groupId: number;
	solvedAt?: string | null;
};

export type NotificationSendPushSummaryRequestDTO = any;

export type GenerateAgentReadOnlyTokenResponse = {
	token: string;
	tokenVerify: string;
	validTill: string;
	identifier: string;
};

export type ImportGoalSynchronizeResponseDTO = {
	id?: number | null;
};

export enum ImportPortfolioReportingEventTypeEnum {
	Recalculated = "Recalculated"
};

export type CreateInsuranceClaimRequestDTO = {
	type: InsuranceClaimTypeEnum;
	eventDate: string;
	description: string;
	agentId: number;
	portfolioIds?: number[] | null;
	propertyIds?: number[] | null;
	countryCode?: string | null;
	location?: string | null;
	attachments: File[];
};

export type InsuranceClaimAttachmentUploadRequestDTO = {
	file: File;
};

export type UpdateInsuranceClaimRequestDTO = {
	type: InsuranceClaimTypeEnum;
	eventDate: string;
	description: string;
	agentId: number;
	portfolioIds?: number[] | null;
	propertyIds?: number[] | null;
	countryCode?: string | null;
	location?: string | null;
	state?: InsuranceClaimStateEnum | null;
};

export type InsuranceClaimAgentResponseDTO = {
	id: number;
	name: string;
};

export type InsuranceClaimAttachmentResponseDTO = {
	id: number;
	originalName: string;
	mimeType?: string | null;
	fileSize?: number | null;
	createdAt: string;
};

export type InsuranceClaimDetailResponseDTO = {
	id: number;
	type: InsuranceClaimTypeEnum;
	state: InsuranceClaimStateEnum;
	eventDate: string;
	description: string;
	agent: InsuranceClaimAgentResponseDTO;
	portfolioIds: number[];
	propertyIds: number[];
	countryCode?: string | null;
	location?: string | null;
	createdAt: string;
	resolvedAt?: string | null;
	attachments: InsuranceClaimAttachmentResponseDTO[];
};

export type InsuranceClaimListItemResponseDTO = {
	id: number;
	type: InsuranceClaimTypeEnum;
	state: InsuranceClaimStateEnum;
	eventDate: string;
	description: string;
	attachmentCount: number;
	createdAt: string;
	resolvedAt?: string | null;
};

export enum InsuranceClaimStateEnum {
	Reported = "Reported",
	InProgress = "InProgress",
	Resolved = "Resolved",
	Cancelled = "Cancelled"
};

export enum InsuranceClaimTypeEnum {
	CarAccident = "CarAccident",
	PropertyDamage = "PropertyDamage",
	Injury = "Injury",
	TravelInsurance = "TravelInsurance",
	Liability = "Liability",
	Other = "Other"
};

export type AlertBoxLeadRequestDTO = {
	eventType: PortfolioEventTypeEnum;
	eventDate: string;
};

export type FinancialBalanceLeadRequestDTO = {
	income: number;
	expense: number;
};

export enum CalculatorTypeEnum {
	FinancialBalance = "FinancialBalance"
};

export type MarkNotificationsAsReadRequestDTO = {
	notificationIds: number[];
};

export type NotificationPushTokenSyncRequestDTO = {
	pushToken: string;
	enabled: boolean;
};

export type NotificationCountResponseDTO = {
	count: number;
	countByTypes: { [key: string | number]: number };
	chatCount: number;
};

export type NotificationDeleteResponseDTO = {
	unreadCount: number;
};

export type NotificationListItemResponseDTO = {
	id: number;
	type: NotificationTypeEnum;
	group: NotificationGroupEnum;
	title: string;
	content: string;
	customContent?: { [key: string | number]: boolean | string | number } | null;
	createdAt: string;
	readAt?: string | null;
	sourceId?: string | null;
	subContent?: string | null;
};

export type NotificationListMetaResponseDTO = {
	unreadCount: number;
	unreadCountByTypes: { [key: string | number]: number };
	totalCount: number;
	lastNotificationId?: number | null;
	limit?: number | null;
	offset?: number | null;
};

export type NotificationListResponseDTO = {
	data: NotificationListItemResponseDTO[];
	meta: NotificationListMetaResponseDTO;
};

export type NotificationReadResponseDTO = {
	unreadCount: number;
};

export enum NotificationActivityTypeEnum {
	ActivityShared = "ActivityShared",
	ActivityEditTerm = "ActivityEditTerm",
	ActivityEditDescription = "ActivityEditDescription",
	ActivityEditNote = "ActivityEditNote",
	ActivityTerm = "ActivityTerm",
	ActivityTermNotice = "ActivityTermNotice"
};

export enum NotificationGroupEnum {
	NewEvent = "NewEvent",
	Activity = "Activity",
	ActivityTerm = "ActivityTerm",
	ActivityTermNotice = "ActivityTermNotice",
	Task = "Task",
	TaskTerm = "TaskTerm",
	TaskTermNotice = "TaskTermNotice",
	Reminder = "Reminder",
	InvestmentQuestionnaire = "InvestmentQuestionnaire",
	Silent = "Silent",
	Old = "Old",
	Portfolio = "Portfolio",
	IdentificationDocument = "IdentificationDocument"
};

export enum NotificationPushTokenTypeEnum {
	Firebase = "Firebase"
};

export enum NotificationSourceEnum {
	MyDock = "MyDock",
	Tasker = "Tasker"
};

export enum NotificationTaskTypeEnum {
	TaskShared = "TaskShared",
	TaskEditTerm = "TaskEditTerm",
	TaskEditDescription = "TaskEditDescription",
	TaskAddWorkflow = "TaskAddWorkflow",
	TaskEditWorkflow = "TaskEditWorkflow",
	TaskDeleteWorkflow = "TaskDeleteWorkflow",
	TaskAddWorkflowItem = "TaskAddWorkflowItem",
	TaskEditWorkflowItem = "TaskEditWorkflowItem",
	TaskDeleteWorkflowItem = "TaskDeleteWorkflowItem",
	TaskResolveWorkflotItem = "TaskResolveWorkflotItem",
	TaskTermNotice = "TaskTermNotice",
	TaskTerm = "TaskTerm"
};

export enum NotificationTypeEnum {
	MeetingRecord = "MeetingRecord",
	DocumentExpires = "DocumentExpires",
	SetAdvisor = "SetAdvisor",
	TaskTerm = "TaskTerm",
	TaskShared = "TaskShared",
	TaskEditTerm = "TaskEditTerm",
	TaskEditDescription = "TaskEditDescription",
	TaskAddWorkflow = "TaskAddWorkflow",
	TaskEditWorkflow = "TaskEditWorkflow",
	TaskDeleteWorkflow = "TaskDeleteWorkflow",
	TaskAddWorkflowItem = "TaskAddWorkflowItem",
	TaskEditWorkflowItem = "TaskEditWorkflowItem",
	TaskDeleteWorkflowItem = "TaskDeleteWorkflowItem",
	TaskResolveWorkflotItem = "TaskResolveWorkflotItem",
	TaskTermNotice = "TaskTermNotice",
	ActivityShared = "ActivityShared",
	ActivityEditTerm = "ActivityEditTerm",
	ActivityEditDescription = "ActivityEditDescription",
	ActivityEditNote = "ActivityEditNote",
	ActivityTerm = "ActivityTerm",
	ActivityTermNotice = "ActivityTermNotice",
	InvestmentQuestionnaire = "InvestmentQuestionnaire",
	TaskGroup = "TaskGroup",
	ActivityGroup = "ActivityGroup",
	PortfolioEnd = "PortfolioEnd",
	PortfolioAnniversary = "PortfolioAnniversary",
	PortfolioFixationEnd = "PortfolioFixationEnd",
	ReminderTerm = "ReminderTerm",
	IdentificationDocumentExpiry = "IdentificationDocumentExpiry",
	Silent = "Silent"
};

export type RecordPortfolioAlertBoxActionRequestDTO = {
	eventType: PortfolioEventTypeEnum;
	eventDate: string;
	action: AlertBoxActionEnum;
	state: AlertBoxActionStateEnum;
};

export type SettingsUpdateRequestDTO = {
	contractEnd: boolean;
	fixationEnd: boolean;
	contractAnniversary: boolean;
	shortTermContracts: boolean;
};

export type UpdatePortfolioAlertBoxDismissalRequestDTO = {
	eventType: PortfolioEventTypeEnum;
	eventDate: string;
	dismissed: boolean;
	mode?: AlertBoxDismissModeEnum | null;
};

export type DashboardResponseDTO = {
	resolvingNow: TimelineResponseDTO;
	upcoming: TimelineResponseDTO;
	recent: TimelineResponseDTO;
};

export type PilotStatusResponseDTO = {
	pilotEnabled: boolean;
};

export type PortfolioAlertBoxDTO = {
	eventType: PortfolioEventTypeEnum;
	eventDate: string;
	primaryAction: AlertBoxActionEnum;
	secondaryAction?: AlertBoxActionEnum | null;
	dismissMode?: AlertBoxDismissModeEnum | null;
	performedActions: PortfolioAlertBoxPerformedActionDTO[];
};

export type PortfolioAlertBoxListResponseDTO = {
	alerts: PortfolioAlertBoxDTO[];
};

export type PortfolioAlertBoxPerformedActionDTO = {
	action: AlertBoxActionEnum;
	state: AlertBoxActionStateEnum;
	performedAt: string;
};

export type SettingsItemResponseDTO = {
	available: boolean;
	enabled: boolean;
};

export type SettingsResponseDTO = {
	contractEnd: SettingsItemResponseDTO;
	fixationEnd: SettingsItemResponseDTO;
	contractAnniversary: SettingsItemResponseDTO;
	shortTermContracts: SettingsItemResponseDTO;
};

export type TimelineActivityDataDTO = {
	timeTo?: string | null;
};

export type TimelineContractEventDataDTO = {
	portfolioId?: string | null;
	eventType: PortfolioEventTypeEnum;
	eventDate?: string | null;
	notificationId?: number | null;
};

export type TimelineIdentificationDocumentDataDTO = {
	identificationDocumentId?: number | null;
	thresholdDays?: number | null;
	validTo?: string | null;
	notificationId?: number | null;
};

export type TimelineInvestmentQuestionnaireDataDTO = {
	clientType?: string | null;
	identificationNumber?: string | null;
	notificationId?: number | null;
};

export type TimelineItemResponseDTO = {
	id: string;
	category: TimelineItemCategoryEnum;
	subcategory?: TimelineItemSubcategoryEnum | null;
	date: string;
	time?: string | null;
	title: string;
	content: string;
	subContent?: string | null;
	entityId: string;
	isResolved: boolean;
	isRead: boolean;
	isGroup: boolean;
	notificationIds?: number[] | null;
	data?: TimelineContractEventDataDTO | TimelineMeetingRecordDataDTO | TimelineInvestmentQuestionnaireDataDTO | TimelineReminderDataDTO | TimelineIdentificationDocumentDataDTO | TimelineNotificationDataDTO | TimelineActivityDataDTO | TimelineTaskDataDTO | null;
};

export type TimelineMeetingRecordDataDTO = {
	clientActionRequestId?: number | null;
	status: ClientActionRequestStatusEnum;
	url?: string | null;
	token?: string | null;
	notificationId?: number | null;
};

export type TimelineMetaResponseDTO = {
	hasMore: boolean;
	limit: number;
	offset: number;
};

export type TimelineNotificationDataDTO = {
	notificationId: number;
};

export type TimelineReminderDataDTO = {
	entityId?: number | null;
	entityType?: ReminderEntityTypeEnum | null;
	reminderId?: number | null;
	notificationId?: number | null;
};

export type TimelineResponseDTO = {
	items: TimelineItemResponseDTO[];
	meta: TimelineMetaResponseDTO;
};

export type TimelineTaskDataDTO = {
	title: string;
};

export enum AlertBoxActionEnum {
	TalkToAgent = "TalkToAgent",
	CompareRates = "CompareRates",
	CheckConditions = "CheckConditions",
	RenewInsurance = "RenewInsurance",
	RecalculateInsurance = "RecalculateInsurance",
	SignNewTravelInsurance = "SignNewTravelInsurance"
};

export enum AlertBoxActionStateEnum {
	Sent = "Sent",
	Opened = "Opened"
};

export enum AlertBoxDismissModeEnum {
	Temporary = "Temporary",
	Permanent = "Permanent"
};

export enum PortfolioEventTypeEnum {
	End = "End",
	Anniversary = "Anniversary",
	FixationEnd = "FixationEnd"
};

export enum RecentTimelineItemTypeFilterEnum {
	All = "All",
	Activities = "Activities",
	Events = "Events",
	Notifications = "Notifications"
};

export enum TimelineHorizonEnum {
	Month = "Month",
	HalfYear = "HalfYear",
	Year = "Year"
};

export enum TimelineItemCategoryEnum {
	Contract = "Contract",
	Activity = "Activity",
	IdentificationDocument = "IdentificationDocument",
	Reminder = "Reminder",
	Task = "Task",
	ClientAction = "ClientAction",
	Notification = "Notification"
};

export enum TimelineItemSubcategoryEnum {
	ContractEnd = "ContractEnd",
	ContractAnniversary = "ContractAnniversary",
	ContractFixationEnd = "ContractFixationEnd",
	ClientActionMeetingRecord = "ClientActionMeetingRecord",
	ClientActionInvestmentQuestionnaire = "ClientActionInvestmentQuestionnaire",
	IdentificationDocumentExpiring = "IdentificationDocumentExpiring",
	IdentificationDocumentExpired = "IdentificationDocumentExpired",
	ReminderPortfolio = "ReminderPortfolio",
	ReminderProperty = "ReminderProperty",
	ReminderIdentificationDocument = "ReminderIdentificationDocument",
	ReminderTerm = "ReminderTerm",
	NotificationTask = "NotificationTask",
	NotificationActivity = "NotificationActivity",
	IdentificationDocumentExpiry = "IdentificationDocumentExpiry"
};

export enum UpcomingTimelineItemTypeFilterEnum {
	All = "All",
	Activities = "Activities",
	Events = "Events"
};

export type NsureQuestionnaireAccessRequestDTO = {
	identificationNumber: string;
	clientType: NsureClientTypeEnum;
};

export type NsureQuestionnaireAccessResponseDTO = {
	url: string;
	accessToken: string;
};

export enum NsureClientTypeEnum {
	PhysicalPerson = "PhysicalPerson",
	LegalEntity = "LegalEntity"
};

export type PortfolioDocumentListItemDTO = {
	id: number;
	title: string;
	filename: string;
	documentType: DocumentTypeEnum;
	mime: string;
};

export type BankProductDetailDataDTO = any;

export type CommodityDetailDataDTO = any;

export type BuildingSavingsDetailDataDTO = {
	payment?: number | null;
	paymentFrequency?: ClientPortfolioPaymentFrequencyEnum | null;
	targetAmount?: number | null;
	appreciation?: number | null;
	stateContribution?: boolean | null;
};

export type CryptocurrencyDetailDataDTO = any;

export type PortfolioDetailGraphDataDTO = {
	daysData: PortfolioDetailGraphDayDataDTO[];
	totalValue: number;
	totalInvestedValue: number;
};

export type PortfolioDetailGraphDayDataDTO = {
	date: string;
	total: PortfolioDetailGraphDayValuesDTO;
};

export type PortfolioDetailGraphDayValuesDTO = {
	value: number;
	investedValue: number;
	enterFee: number;
};

export type InvestmentDetailDataDTO = {
	graphData?: PortfolioDetailGraphDataDTO | null;
};

export type LeasingDetailDataDTO = {
	originalObligationAmount?: number | null;
	installment?: number | null;
	interestRate?: number | null;
	coDebtors: ClientPortfolioDetailCoDebtorResponseDTO[];
	fixationEndDate?: string | null;
	paymentFrequency?: ClientPortfolioPaymentFrequencyEnum | null;
};

export enum ClientPortfolioInsuredPersonRiskEnum {
	Death = "Death",
	DeathByAccident = "DeathByAccident",
	Invalidity1 = "Invalidity1",
	Invalidity2 = "Invalidity2",
	Invalidity3 = "Invalidity3",
	Invalidity4 = "Invalidity4",
	SeriousIllness = "SeriousIllness",
	CancerFighting = "CancerFighting",
	ForWoman = "ForWoman",
	LoanPackage = "LoanPackage",
	PermanentConsequencesOfInjuryFrom05Percent = "PermanentConsequencesOfInjuryFrom05Percent",
	PermanentConsequencesOfInjuryFrom10Percent = "PermanentConsequencesOfInjuryFrom10Percent",
	BodilyDamageInjury = "BodilyDamageInjury",
	IncapacityForWork = "IncapacityForWork",
	DailyCompensationForInjury = "DailyCompensationForInjury",
	Hospitalization = "Hospitalization"
};

export type InsuredPersonDTO = {
	firstname: string;
	lastname: string;
	identificationNumber: string;
	risks: InsuredPersonRiskDTO[];
};

export type InsuredPersonRiskDTO = {
	risk: ClientPortfolioInsuredPersonRiskEnum;
	value?: string | null;
	toAge?: number | null;
	variant: RiskVariantEnum;
};

export type LifeInsuranceDetailDataDTO = {
	insurance?: number | null;
	insurancePeriod?: number | null;
	paymentFrequency?: ClientPortfolioPaymentFrequencyEnum | null;
	employerContribution?: number | null;
	insuredPersons?: InsuredPersonDTO[] | null;
};

export enum RiskVariantEnum {
	Constant = "Constant",
	Decreasing = "Decreasing",
	Annuities = "Annuities",
	Retroactively = "Retroactively",
	NonRetroactively = "NonRetroactively",
	Progression = "Progression",
	Empty = "Empty"
};

export type LoanDetailDataDTO = {
	originalObligationAmount?: number | null;
	installment?: number | null;
	interestRate?: number | null;
	paymentFrequency?: ClientPortfolioPaymentFrequencyEnum | null;
	coDebtors: ClientPortfolioDetailCoDebtorResponseDTO[];
	fixationEndDate?: string | null;
	dataChanges: ClientPortfolioDetailDataChangeResponseDTO[];
};

export type LoanForBusinessDetailDataDTO = {
	originalObligationAmount?: number | null;
	installment?: number | null;
	interestRate?: number | null;
	fixationEndDate?: string | null;
	paymentFrequency?: ClientPortfolioPaymentFrequencyEnum | null;
	coDebtors: ClientPortfolioDetailCoDebtorResponseDTO[];
};

export type PropertyInsuranceDetailDataDTO = {
	insurance?: number | null;
	insurancePeriod?: number | null;
	paymentFrequency?: ClientPortfolioPaymentFrequencyEnum | null;
};

export type PaidAdvisoryDetailDataDTO = {
	fixedPriceByFrequency?: number | null;
	paymentFrequency?: ClientPortfolioPaymentFrequencyEnum | null;
};

export type PensionProductsDetailDataDTO = {
	payment?: number | null;
	paymentFrequency?: ClientPortfolioPaymentFrequencyEnum | null;
	employerContribution?: number | null;
	ageLimit?: number | null;
	appreciation?: number | null;
	stateContribution?: boolean | null;
};

export type PortfolioDetailResponseDTO = {
	id: number;
	name?: string | null;
	clientName?: string | null;
	product?: string | null;
	productCategoryId?: number | null;
	contractNumber?: string | null;
	producer?: string | null;
	signedAt?: string | null;
	startAt?: string | null;
	endAt?: string | null;
	portfolioValueDate?: string | null;
	currency: CurrencyEnum;
	currencySign?: string | null;
	domain?: ClientPortfolioDomainEnum | null;
	maturityLengthMonths?: number | null;
	source?: string | null;
	related: ClientPortfolioDetailRelatedResponseDTO[];
	valueType?: string | null;
	modeTool?: boolean | null;
	modeFillup?: boolean | null;
	tools?: ClientPortfolioDetailToolsResponseDTO | null;
	producerInstruments?: ClientPortfolioProducerInstrumentResponseDTO[] | null;
	bankInstructionMonthlyPayment?: number | null;
	data?: LifeInsuranceDetailDataDTO | PropertyInsuranceDetailDataDTO | PensionProductsDetailDataDTO | BuildingSavingsDetailDataDTO | InvestmentDetailDataDTO | LoanForBusinessDetailDataDTO | LoanDetailDataDTO | LeasingDetailDataDTO | CommodityDetailDataDTO | BankProductDetailDataDTO | CryptocurrencyDetailDataDTO | ServiceDetailDataDTO | PaidAdvisoryDetailDataDTO | null;
};

export type ServiceDetailDataDTO = {
	depositAmount?: number | null;
	tariff?: string | null;
	commodityService?: ClientPortfolioDataCommodityServiceEnum | null;
	unitOfMeasurement?: string | null;
	pricePerUnit?: number | null;
	fixedPriceByFrequency?: number | null;
	paymentFrequency?: ClientPortfolioPaymentFrequencyEnum | null;
};

export type PortfolioListItemResponseDTO = {
	id: number;
	name?: string | null;
	icon?: string | null;
	iconText?: string | null;
	producer?: string | null;
	product?: string | null;
	contractNumber?: string | null;
	domain?: ClientPortfolioDomainEnum | null;
	domainColor?: string | null;
	currencySign?: string | null;
	startAt?: string | null;
	endAt?: string | null;
	payment?: number | null;
	installment?: number | null;
	paymentFrequency?: ClientPortfolioPaymentFrequencyEnum | null;
	archived: boolean;
};

export type PortfolioReportingEntryResponseDTO = {
	date: string;
	items: PortfolioReportingItemResponseDTO[];
};

export type PortfolioReportingItemResponseDTO = {
	identification: string;
	type: ClientPortfolioReportingTypeEnum;
	count: number;
	value: number;
	invested?: number | null;
	currency: number;
	entryFee: number;
	totalEntryFee: number;
	date: string;
	payment: number;
	totalStateContribution: number;
	targetAmount: number;
	monthRate: number;
	change: number;
	transitionAmount: number;
	evaluation: number;
	interest: number;
	withdrawal: number;
	movementAmount: number;
	totalWithdrawals: number;
	totalDeposit: number;
	totalWithdrawal: number;
	cleanDeposit: number;
	totalExtraFee: number;
	feeCancelled: number;
	extraFee: number;
	fee: number;
	totalFee: number;
	deposit: number;
	withdrawn: number;
	name?: string | null;
	frequency?: ClientPortfolioDataMovementsFrequencyEnum | null;
	investmentType?: ClientPortfolioInvestmentTypeEnum | null;
};

export type PortfolioReportingResponseDTO = {
	reportingData: PortfolioReportingEntryResponseDTO[];
	summary?: ClientPortfolioReportingSummaryResponseDTO | null;
	toolsSummary: ClientPortfolioToolReportingSummaryResponseDTO[];
	calculatedAt: string;
	failed: boolean;
};

export type PortfolioListReportingSummaryResponseDTO = {
	id: number;
	calculatedAt: string;
	summary?: ClientPortfolioReportingSummaryResponseDTO | null;
};

export type ProducerResponseDTO = {
	id: number;
	name: string;
};

export type ProductCategoryResponseDTO = {
	id: number;
	name: string;
};

export type ProductResponseDTO = {
	id: number;
	name: string;
	productCategoryId?: number | null;
};

export enum ClientPortfolioDomainEnum {
	LifeInsurance = "LifeInsurance",
	Loans = "Loans",
	PensionProducts = "PensionProducts",
	BuildingSavings = "BuildingSavings",
	Investments = "Investments",
	BankingProducts = "BankingProducts",
	BusinessLoans = "BusinessLoans",
	Commodities = "Commodities",
	Services = "Services",
	PropertyInsurance = "PropertyInsurance",
	Leasing = "Leasing",
	Cryptocurrencies = "Cryptocurrencies",
	PaidAdvisory = "PaidAdvisory"
};

export enum ClientPortfolioReportingTypeEnum {
	Change = "Change",
	Movement = "Movement",
	MovementNull = "MovementNull",
	Total = "Total"
};

export enum InsurancePeriodEnum {
	Annually = "Annually",
	SemiAnnually = "SemiAnnually",
	Quarterly = "Quarterly",
	Monthly = "Monthly",
	Once = "Once"
};

export enum PortfolioDomainEnum {
	LifeInsurance = "LifeInsurance",
	Loans = "Loans",
	PensionProducts = "PensionProducts",
	BuildingSavings = "BuildingSavings",
	Investments = "Investments",
	BankingProducts = "BankingProducts",
	BusinessLoans = "BusinessLoans",
	Commodities = "Commodities",
	Services = "Services",
	PropertyInsurance = "PropertyInsurance",
	Leasing = "Leasing",
	Cryptocurrencies = "Cryptocurrencies",
	PaidAdvisory = "PaidAdvisory"
};

export enum PortfolioReportingOverviewTypeEnum {
	Total = "Total",
	Cash = "Cash",
	Investment = "Investment",
	InvestmentProperty = "InvestmentProperty",
	Liabilities = "Liabilities",
	Other = "Other"
};

export enum ProductCategoryEnum {
	LifeInsuranceWithoutReserve = "LifeInsuranceWithoutReserve",
	LifeInsuranceWithReserve = "LifeInsuranceWithReserve",
	LifeInsuranceCombinedReserve = "LifeInsuranceCombinedReserve",
	ConsumerLoans = "ConsumerLoans",
	HousingLoans = "HousingLoans",
	BuildingSavingsLoan = "BuildingSavingsLoan",
	OtherLoans = "OtherLoans",
	PensionTransformedFund = "PensionTransformedFund",
	PensionSupplementarySavings = "PensionSupplementarySavings",
	PensionInsurance = "PensionInsurance",
	BuildingSavings = "BuildingSavings",
	InvestmentFunds = "InvestmentFunds",
	InvestmentBonds = "InvestmentBonds",
	InvestmentCombined = "InvestmentCombined",
	TrustManagement = "TrustManagement",
	CurrencyExchange = "CurrencyExchange",
	CurrentAndSavingsAccounts = "CurrentAndSavingsAccounts",
	TermDeposit = "TermDeposit",
	CreditCard = "CreditCard",
	BusinessLoans = "BusinessLoans",
	RealEstate = "RealEstate",
	CommoditiesOneTime = "CommoditiesOneTime",
	CommoditiesRegular = "CommoditiesRegular",
	Energy = "Energy",
	VehicleInsurance = "VehicleInsurance",
	PropertyAndLiabilityInsurance = "PropertyAndLiabilityInsurance",
	BusinessPropertyAndLiabilityInsurance = "BusinessPropertyAndLiabilityInsurance",
	TravelInsurance = "TravelInsurance",
	AccidentInsurance = "AccidentInsurance",
	HealthInsuranceForeigners = "HealthInsuranceForeigners",
	FleetInsurance = "FleetInsurance",
	Leasing = "Leasing",
	Cryptocurrencies = "Cryptocurrencies"
};

export enum PropertySubTypeEnum {
	CarMoto = "CarMoto",
	Flat = "Flat",
	House = "House",
	Cottage = "Cottage",
	Land = "Land",
	Art = "Art",
	Commodity = "Commodity"
};

export type CreateReminderRequestDTO = {
	typeKey: string;
	date: string;
	recurrence: RecurrenceEnum;
	title?: string | null;
};

export type ReminderListResponseDTO = {
	reminders: ReminderResponseDTO[];
};

export type ReminderResponseDTO = {
	id: number;
	typeKey: string;
	title: string;
	date: string;
	recurrence: RecurrenceEnum;
	snoozedUntil?: string | null;
	solvedAt?: string | null;
	status: ReminderStatusEnum;
};

export type ReminderSyncRetryResponseDTO = {
	published: number;
	skipped: number;
	batchLimited: boolean;
};

export type ReminderTypeListResponseDTO = {
	types: ReminderTypeResponseDTO[];
};

export type ReminderTypeResponseDTO = {
	typeKey: string;
	defaultRecurrence: RecurrenceEnum;
	isCustom: boolean;
};

export type UpdateReminderRequestDTO = {
	typeKey?: string | null;
	title?: string | null;
	date?: string | null;
	recurrence?: RecurrenceEnum | null;
	snoozedUntil?: string | null;
	solvedAt?: string | null;
};

export type UpdateReminderResponseDTO = {
	reminder: ReminderResponseDTO;
	nextOccurrence?: ReminderResponseDTO | null;
};

export enum IdentificationDocumentReminderType {
	OneMonthBefore = "OneMonthBefore",
	ThreeMonthsBefore = "ThreeMonthsBefore",
	OnExpiry = "OnExpiry"
};

export enum PortfolioReminderType {
	Custom = "Custom"
};

export enum PropertyReminderType {
	ChimneyInspection = "ChimneyInspection",
	GasInspection = "GasInspection",
	ElectricalInspection = "ElectricalInspection",
	FireExtinguisher = "FireExtinguisher",
	PropertyTax = "PropertyTax",
	Insurance = "Insurance",
	Custom = "Custom"
};

export enum RecurrenceEnum {
	Once = "Once",
	Yearly = "Yearly",
	Every2Years = "Every2Years",
	Every3Years = "Every3Years",
	Every4Years = "Every4Years"
};

export enum ReminderEntityTypeEnum {
	Portfolio = "Portfolio",
	Property = "Property",
	IdentificationDocument = "IdentificationDocument"
};

export enum ReminderSortFieldEnum {
	Date = "Date",
	CreatedAt = "CreatedAt"
};

export enum ReminderStatusEnum {
	Active = "Active",
	Soon = "Soon",
	Overdue = "Overdue",
	Snoozed = "Snoozed",
	Solved = "Solved"
};

export enum VehicleReminderType {
	Stk = "Stk",
	Service = "Service",
	Insurance = "Insurance",
	HighwayVignette = "HighwayVignette",
	EmissionCheck = "EmissionCheck",
	Custom = "Custom"
};

export type RightsResponseDTO = {
	pilotGoal: boolean;
	pilotNotificationCenter: boolean;
	pilotMyplannPortfolio: boolean;
	pilotMyplannReminders: boolean;
};

export type TaskDetailResponse = {
	taskID: number;
	taskPublicID: string;
	name: string;
	description?: string | null;
	statusId?: number | null;
	statusName?: string | null;
	statusColor?: string | null;
	taskGroupID?: number | null;
	taskGroupName?: string | null;
	taskGroupPublicID?: string | null;
	taskGroupUserID?: number | null;
	assignedToUserFullName?: string | null;
	assignedToUserExternalID?: string | null;
	assignedToUserID?: number | null;
	dueDate?: string | null;
	isFavorite: boolean;
	archivationStatus: TaskArchivationStatusEnum;
	firstClientName?: string | null;
	isCompleted: boolean;
	isSharedWithMe: boolean;
	canArchive: boolean;
	canRestore: boolean;
	canUpdateComplete: boolean;
	canChangeTaskGroup: boolean;
	unreadCommentCount: number;
	isWatchedByCurrentUser: boolean;
	clients: GetTaskClientsListItemResponse[];
	users: GetTaskUsersListItemResponse[];
	author: AgentSimpleResponseDTO;
	assignedTo?: AgentSimpleResponseDTO | null;
};

export type TaskListItemResponseDTO = {
	id: number;
	title: string;
	date?: string | null;
	time?: string | null;
	solved: boolean;
	author: AgentSimpleResponseDTO;
	assignedTo?: AgentSimpleResponseDTO | null;
	discriminator: DashboardEventType;
};

export type UserLanguageUpdateRequestDTO = {
	language: string;
};

export type UserLanguageResponseDTO = {
	language: string;
};

export enum MobileMyplannNotificationModeEnum {
	Allow = "Allow",
	DisableNotifications = "DisableNotifications",
	DisableAll = "DisableAll"
};

export enum UserAgentStatusEnum {
	PendingClient = "PendingClient",
	PendingAgent = "PendingAgent",
	Connected = "Connected"
};

export enum UserTokenTypeEnum {
	Access = "Access",
	ForgottenPassword = "ForgottenPassword",
	Registration = "Registration",
	TwoFa = "TwoFa",
	AgentReadOnly = "AgentReadOnly"
};

export enum UserTypeEnum {
	Client = "Client",
	Agent = "Agent",
	Assistant = "Assistant"
};

export type DefaultListMetaDTO = {
	totalCount: number;
	limit?: number | null;
	offset?: number | null;
};

export type ErrorDetailDTO = {
	code: string;
	message: string;
};

export type ExceptionDTO = {
	errors?: { [key: string | number]: ErrorDetailDTO[] } | null;
	type?: string | null;
	title?: string | null;
	status?: number | null;
	detail?: string | null;
	instance?: string | null;
	portalStackTrace?: { [key: string | number]: ExceptionStackTraceItemDTO[] } | null;
	stackTrace?: { [key: string | number]: ExceptionStackTraceItemDTO[] } | null;
};

export type ExceptionStackTraceItemDTO = {
	file?: string | null;
	line?: number | null;
	function?: string | null;
	class?: string | null;
	type?: string | null;
};

export enum AuthExternalEnum {
	PaidAdvisory = "PaidAdvisory",
	Tasker = "Tasker",
	NsureInvestmentNew = "NsureInvestmentNew",
	NsureInvestmentOverview = "NsureInvestmentOverview",
	NsureNonLifeAutoMotoCalculation = "NsureNonLifeAutoMotoCalculation",
	NsureNonLifePropertyCalculation = "NsureNonLifePropertyCalculation",
	SabExternalApi = "SabExternalApi",
	Portal = "Portal"
};

export type AuthTokenExternalTokenResponseDTO = {
	token: string;
	type: string;
	expiresIn: number;
};

export enum ApiUserEnum {
	SAB = "SAB",
	MyPLANN = "MyPLANN"
};

export enum ClientActivityEventDataItemActionEnum {
	Created = "Created",
	Updated = "Updated"
};

export enum ClientActivityTypeEnum {
	Meeting = "Meeting",
	Call = "Call",
	Administration = "Administration",
	Other = "Other"
};

export enum ClientAgreementIdentificationDocumentEnum {
	IdentityCard = "IdentityCard",
	Passport = "Passport",
	Other = "Other",
	None = "None"
};

export enum ClientBondInterestTypeEnum {
	Nullable = "Nullable",
	Fixed = "Fixed",
	Variable = "Variable"
};

export enum ClientCarBodyTypeEnum {
	Hatchback = "Hatchback",
	Combi = "Combi",
	Coupe = "Coupe",
	PickUp = "PickUp",
	Roadster = "Roadster",
	Suv = "Suv",
	Van = "Van",
	Cabriolet = "Cabriolet",
	Mpv = "Mpv",
	Sedan = "Sedan",
	Limousine = "Limousine",
	liftback = "liftback",
	OffRoad = "OffRoad",
	Other = "Other",
	None = "None",
	DEPRECATED_EMPTY = "DEPRECATED_EMPTY"
};

export enum ClientCarFuelEnum {
	Petrol = "Petrol",
	Diesel = "Diesel",
	Lpg = "Lpg",
	Cng = "Cng",
	Electricity = "Electricity",
	HybridDiesel = "HybridDiesel",
	HybridPetrol = "HybridPetrol",
	PetrolLpg = "PetrolLpg",
	DieselLpg = "DieselLpg",
	PetrolCng = "PetrolCng",
	DieselCng = "DieselCng",
	Other = "Other",
	None = "None"
};

export enum ClientChangedPropertyEnum {
	Type = "Type",
	PersonType = "PersonType",
	Rating = "Rating",
	CompanyName = "CompanyName",
	CompanyNumber = "CompanyNumber",
	CompanyVatNumber = "CompanyVatNumber",
	ResponsiblePersonFirstname = "ResponsiblePersonFirstname",
	ResponsiblePersonLastname = "ResponsiblePersonLastname",
	ResponsiblePersonPosition = "ResponsiblePersonPosition",
	Firstname = "Firstname",
	Lastname = "Lastname",
	DegreeBefore = "DegreeBefore",
	DegreeAfter = "DegreeAfter",
	BirthNumber = "BirthNumber",
	BirthDate = "BirthDate",
	BirthPlace = "BirthPlace",
	MaritalStatus = "MaritalStatus",
	HealthInsurance = "HealthInsurance",
	Profession = "Profession",
	Company = "Company",
	IncomeSource = "IncomeSource",
	RecommendationFrom = "RecommendationFrom",
	Email = "Email",
	Website = "Website",
	Skype = "Skype",
	Phone = "Phone",
	Landline = "Landline",
	IdentityDocument = "IdentityDocument",
	BankAccount = "BankAccount",
	Address = "Address",
	Group = "Group",
	Note = "Note"
};

export enum ClientConstructionTypeEnum {
	Garage = "Garage",
	FarmBuilding = "FarmBuilding",
	CustomBuilding = "CustomBuilding",
	None = "None"
};

export enum ClientContactTypeEnum {
	Phone = "Phone",
	Landline = "Landline",
	Email = "Email",
	Skype = "Skype",
	Website = "Website"
};

export enum ClientDocumentTypeEnum {
	Form = "Form",
	Portfolio = "Portfolio",
	SAB = "SAB",
	MyPlann = "MyPlann"
};

export enum ClientEventTypeEnum {
	Activity = "Activity",
	ClientCreated = "ClientCreated",
	ClientUpdates = "ClientUpdates",
	ClientShared = "ClientShared",
	ClientUnshared = "ClientUnshared",
	ClientCampaignAssigned = "ClientCampaignAssigned",
	ClientCampaignUnassigned = "ClientCampaignUnassigned",
	ClientBlueAgreementSent = "ClientBlueAgreementSent",
	ClientGoldAgreementSent = "ClientGoldAgreementSent",
	ClientGoldAgreementSigned = "ClientGoldAgreementSigned",
	ZZJCreated = "ZZJCreated",
	ZZJSent = "ZZJSent",
	ZZJSigned = "ZZJSigned",
	AMLCreated = "AMLCreated",
	AMLSent = "AMLSent",
	InterventionCreated = "InterventionCreated",
	InterventionResolved = "InterventionResolved",
	FinancialPlanUpdate = "FinancialPlanUpdate",
	PortfolioCreated = "PortfolioCreated",
	PortfolioUpdated = "PortfolioUpdated",
	PortfolioArchived = "PortfolioArchived",
	PortfolioRestored = "PortfolioRestored",
	PortfolioDeleted = "PortfolioDeleted",
	DocumentCreated = "DocumentCreated",
	DocumentArchived = "DocumentArchived",
	DocumentRestored = "DocumentRestored",
	DocumentDeleted = "DocumentDeleted",
	ModelationCreated = "ModelationCreated",
	ModelationUpdated = "ModelationUpdated",
	ModelationDeleted = "ModelationDeleted",
	MyPLANNCreated = "MyPLANNCreated",
	MyPLANNDeleted = "MyPLANNDeleted",
	MyPLANNConnected = "MyPLANNConnected",
	MyPLANNDocumentShared = "MyPLANNDocumentShared",
	MyPLANNDocumentUnshared = "MyPLANNDocumentUnshared",
	MyPLANNPortfolioShared = "MyPLANNPortfolioShared",
	MyPLANNPortfolioUnshared = "MyPLANNPortfolioUnshared",
	MyPLANNPortfolioSigned = "MyPLANNPortfolioSigned",
	MyPLANNLead = "MyPLANNLead",
	TaskOld = "TaskOld",
	Task = "Task",
	PaidAdvisory = "PaidAdvisory"
};

export enum ClientEventTypeGroupEnum {
	Activity = "Activity",
	Task = "Task",
	Client = "Client",
	Portfolio = "Portfolio",
	PaidAdvisory = "PaidAdvisory",
	Document = "Document",
	FinancialPlan = "FinancialPlan",
	Modelation = "Modelation",
	Legislation = "Legislation",
	MyPLANN = "MyPLANN",
	Birthday = "Birthday"
};

export enum ClientFinancialPlanChangedPropertyEnum {
	Name = "Name",
	Amount = "Amount",
	MonthlyPayment = "MonthlyPayment",
	SustainableSpending = "SustainableSpending"
};

export enum ClientFinancialPlanExpenseNameEnum {
	Total = "Total",
	Rent = "Rent",
	EnergyBills = "EnergyBills",
	Fees = "Fees",
	OtherHousing = "OtherHousing",
	Leasing = "Leasing",
	TollFees = "TollFees",
	CarInsurance = "CarInsurance",
	FuelExpenses = "FuelExpenses",
	Maintenance = "Maintenance",
	Fares = "Fares",
	BuildingSavings = "BuildingSavings",
	PensionProducts = "PensionProducts",
	Investments = "Investments",
	LifeInsurance = "LifeInsurance",
	HouseholdInsurance = "HouseholdInsurance",
	Responsibility = "Responsibility",
	FoodExpenses = "FoodExpenses",
	PocketMoney = "PocketMoney",
	Hairdressing = "Hairdressing",
	Clothing = "Clothing",
	Sport = "Sport",
	Culture = "Culture",
	Restaurants = "Restaurants",
	Pets = "Pets",
	Books = "Books",
	MobilePhone = "MobilePhone",
	TuitionFees = "TuitionFees",
	Gifts = "Gifts",
	Vacation = "Vacation",
	SocialTax = "SocialTax",
	IncomeTax = "IncomeTax",
	PropertyTax = "PropertyTax",
	CharityContributions = "CharityContributions",
	RegularCleaning = "RegularCleaning",
	AlimonyPayments = "AlimonyPayments",
	Babysitter = "Babysitter",
	Other = "Other",
	Loans = "Loans",
	Cigarettes = "Cigarettes",
	Subscription = "Subscription"
};

export enum ClientFinancialPlanExpenseTypeEnum {
	Housing = "Housing",
	Traffic = "Traffic",
	Saving = "Saving",
	Insurance = "Insurance",
	Household = "Household",
	Taxes = "Taxes",
	Other = "Other"
};

export enum ClientIdentificationDocumentTypeEnum {
	IdentityCard = "IdentityCard",
	Passport = "Passport",
	DrivingLicense = "DrivingLicense",
	ResidencePermit = "ResidencePermit",
	ShipLicense = "ShipLicense",
	PilotLicense = "PilotLicense",
	WeaponLicense = "WeaponLicense",
	ISIC = "ISIC",
	TravelLicense = "TravelLicense",
	STK = "STK",
	InsuranceCard = "InsuranceCard",
	FishingLicense = "FishingLicense",
	HuntingLicense = "HuntingLicense",
	Other = "Other"
};

export enum ClientOutcomeSubTypeEnum {
	Total = "Total",
	Rent = "Rent",
	EnergyBills = "EnergyBills",
	Fees = "Fees",
	OtherHousing = "OtherHousing",
	Leasing = "Leasing",
	TollFees = "TollFees",
	CarInsurance = "CarInsurance",
	FuelExpenses = "FuelExpenses",
	Maintenance = "Maintenance",
	Fares = "Fares",
	BuildingSavings = "BuildingSavings",
	PensionProducts = "PensionProducts",
	Investments = "Investments",
	LifeInsurance = "LifeInsurance",
	HouseholdInsurance = "HouseholdInsurance",
	Responsibility = "Responsibility",
	FoodExpenses = "FoodExpenses",
	PocketMoney = "PocketMoney",
	Hairdressing = "Hairdressing",
	Clothing = "Clothing",
	Sport = "Sport",
	Culture = "Culture",
	Restaurants = "Restaurants",
	Pets = "Pets",
	Books = "Books",
	MobilePhone = "MobilePhone",
	TuitionFees = "TuitionFees",
	Gifts = "Gifts",
	Vacation = "Vacation",
	SocialTax = "SocialTax",
	IncomeTax = "IncomeTax",
	PropertyTax = "PropertyTax",
	CharityContributions = "CharityContributions",
	RegularCleaning = "RegularCleaning",
	AlimonyPayments = "AlimonyPayments",
	Babysitter = "Babysitter",
	Other = "Other",
	Loans = "Loans",
	Cigarettes = "Cigarettes",
	Subscription = "Subscription"
};

export enum ClientOutcomeTypeEnum {
	Housing = "Housing",
	Traffic = "Traffic",
	Savings = "Savings",
	Insurance = "Insurance",
	Household = "Household",
	Taxes = "Taxes",
	Other = "Other"
};

export enum ClientPortfolioDataChangeChangeTypeEnum {
	EMPTY = "EMPTY",
	TEMPLATE = "TEMPLATE",
	EXTRAORDINARY_PAYMENT = "EXTRAORDINARY_PAYMENT",
	RATE_CHANGE = "RATE_CHANGE",
	MISSED_PAYMENT = "MISSED_PAYMENT",
	LOAN_INCREASE = "LOAN_INCREASE",
	OWN_CHANGE = "OWN_CHANGE"
};

export enum ClientPortfolioDataChangeTypeSupplementEnum {
	EMPTY = "EMPTY",
	TEMPLATE = "TEMPLATE",
	KEEP_MATURITY = "KEEP_MATURITY",
	KEEP_INSTALLMENT = "KEEP_INSTALLMENT"
};

export enum ClientPortfolioDataMovementsFrequencyEnum {
	Zero = "Zero",
	One = "One",
	Two = "Two",
	Four = "Four",
	Twelve = "Twelve"
};

export enum ClientPortfolioInstructionHoldingTypeEnum {
	OwnWallet = "OwnWallet",
	InAdministration = "InAdministration"
};

export enum ClientPortfolioInvestmentEnterFeeAmountTypeEnum {
	Amount = "Amount",
	Percent = "Percent"
};

export enum ClientPortfolioInvestmentEnterFeeApplyingEnum {
	ChargedFeeFromInvestment = "ChargedFeeFromInvestment",
	PaidExtra = "PaidExtra"
};

export enum ClientPortfolioInvestmentEnterFeeTypeEnum {
	Once = "Once",
	FromFirstPayments = "FromFirstPayments",
	FromEveryPayment = "FromEveryPayment"
};

export enum ClientPortfolioInvestmentFrequencyEnum {
	Monthly = "Monthly",
	EveryTwoMonths = "EveryTwoMonths",
	Quarter = "Quarter",
	SemiYearly = "SemiYearly",
	Yearly = "Yearly",
	Once = "Once",
	None = "None"
};

export enum ClientPortfolioInvestmentTransactionEnum {
	Trade = "Trade",
	FundTransfer = "FundTransfer"
};

export enum ClientPortfolioInvestmentTypeEnum {
	Buy = "Buy",
	Sell = "Sell",
	Empty = "Empty"
};

export enum ClientPortfolioLoanTermUnitEnum {
	Months = "Months",
	Years = "Years"
};

export enum ClientPortfolioToolCommodityIdentificationEnum {
	Gold = "Gold",
	Silver = "Silver",
	Platinum = "Platinum",
	Palladium = "Palladium"
};

export enum ClientPortfolioToolIdentificationTypeEnum {
	Isin = "Isin",
	Other = "Other",
	Crypto = "Crypto",
	Null = "Null",
	BankProduct = "BankProduct",
	None = "None"
};

export enum ClientPortfolioToolTypeEnum {
	Fund = "Fund",
	Bond = "Bond",
	Other = "Other",
	Commodity = "Commodity",
	Crypto = "Crypto",
	BankProduct = "BankProduct",
	Share = "Share"
};

export enum ClientPortfolioTypeEnum {
	Portfolio = "Portfolio",
	Property = "Property"
};

export enum ClientPortfolioValueTypeEnum {
	PRODUCER = "PRODUCER",
	MANUAL = "MANUAL",
	MANUAL_CZ = "MANUAL_CZ",
	MANUFACTURER = "MANUFACTURER",
	ESTIMATE = "ESTIMATE"
};

export enum ClientPropertyBuildingDispositionEnum {
	None = "None",
	OnePlusKK = "OnePlusKK",
	OnePlusOne = "OnePlusOne",
	TwoPlusKK = "TwoPlusKK",
	TwoPlusOne = "TwoPlusOne",
	ThreePlusKK = "ThreePlusKK",
	ThreePlusOne = "ThreePlusOne",
	FourPlusKK = "FourPlusKK",
	FourPlusOne = "FourPlusOne",
	FivePlusKK = "FivePlusKK",
	FivePlusOne = "FivePlusOne",
	SixPlusKK = "SixPlusKK",
	SixPlusOne = "SixPlusOne",
	SevenPlusKK = "SevenPlusKK",
	SevenPlusOne = "SevenPlusOne",
	Atypical = "Atypical",
	StudioApartment = "StudioApartment",
	Custom = "Custom"
};

export enum ClientPropertyBuildingMaterialEnum {
	Panel = "Panel",
	Brick = "Brick",
	Stone = "Stone",
	Wood = "Wood",
	ReinforcedConcrete = "ReinforcedConcrete",
	Skeletal = "Skeletal",
	Mixed = "Mixed",
	Custom = "Custom",
	None = "None",
	Empty = "Empty"
};

export enum ClientPropertyCarAnnualMileageEnum {
	NotSpecified = "NotSpecified",
	UpTo1000 = "UpTo1000",
	UpTo2000 = "UpTo2000",
	UpTo3000 = "UpTo3000",
	UpTo4000 = "UpTo4000",
	UpTo5000 = "UpTo5000",
	UpTo6000 = "UpTo6000",
	UpTo7000 = "UpTo7000",
	UpTo7500 = "UpTo7500",
	UpTo8000 = "UpTo8000",
	UpTo9000 = "UpTo9000",
	UpTo10000 = "UpTo10000",
	UpTo11000 = "UpTo11000",
	UpTo12000 = "UpTo12000",
	UpTo12500 = "UpTo12500",
	UpTo13000 = "UpTo13000",
	UpTo14000 = "UpTo14000",
	UpTo15000 = "UpTo15000",
	UpTo16000 = "UpTo16000",
	UpTo17000 = "UpTo17000",
	UpTo18000 = "UpTo18000",
	UpTo19000 = "UpTo19000",
	UpTo20000 = "UpTo20000",
	UpTo21000 = "UpTo21000",
	UpTo22000 = "UpTo22000",
	UpTo23000 = "UpTo23000",
	UpTo24000 = "UpTo24000",
	UpTo25000 = "UpTo25000",
	UpTo30000 = "UpTo30000",
	UpTo40000 = "UpTo40000",
	UpTo50000 = "UpTo50000",
	Over50000 = "Over50000",
	None = "None",
	DEPRECATED_EMPTY = "DEPRECATED_EMPTY"
};

export enum ClientPropertyCarUsageEnum {
	NormalOperation = "NormalOperation",
	CarRental = "CarRental",
	Taxi = "Taxi",
	PriorityVehicle = "PriorityVehicle",
	Ambulance = "Ambulance",
	InternationalTransport = "InternationalTransport",
	DrivingSchool = "DrivingSchool",
	HistoricVehicle = "HistoricVehicle",
	DangerousGoodsTransport = "DangerousGoodsTransport",
	CompetitiveUse = "CompetitiveUse",
	CompanyVehicle = "CompanyVehicle",
	CourierService = "CourierService",
	OtherUse = "OtherUse",
	None = "None",
	DEPRECATED_EMPTY = "DEPRECATED_EMPTY"
};

export enum ClientPropertyCarVehicleTypeEnum {
	ElectricScooter = "ElectricScooter",
	Segway = "Segway",
	GardenTractor = "GardenTractor",
	GolfCart = "GolfCart",
	Kart = "Kart",
	Other = "Other",
	None = "None",
	Empty = "Empty"
};

export enum ClientPropertyCategoryEnum {
	Apartment = "Apartment",
	OnKey = "OnKey",
	LowEnergy = "LowEnergy",
	Family = "Family",
	Villa = "Villa",
	Garage = "Garage",
	HistoricalObject = "HistoricalObject",
	Cottage = "Cottage",
	CivicAmenityBuilding = "CivicAmenityBuilding",
	Pond = "Pond",
	Farmstead = "Farmstead",
	OtherBuliding = "OtherBuliding",
	Livving = "Livving",
	CommercialBuilding = "CommercialBuilding",
	Garden = "Garden",
	PermanentGrassGrowth = "PermanentGrassGrowth",
	Forest = "Forest",
	AgriculturalLand = "AgriculturalLand",
	OtherLand_ = "OtherLand_",
	None = "None"
};

export enum ClientPropertyHouseTypeEnum {
	Storey = "Storey",
	SingleStorey = "SingleStorey",
	None = "None"
};

export enum ClientPropertyOwnershipEnum {
	Personal = "Personal",
	Cooperative = "Cooperative",
	National = "National",
	NationalMunicipal = "NationalMunicipal",
	Other = "Other",
	None = "None",
	DEPRECATED_EMPTY = "DEPRECATED_EMPTY"
};

export enum ClientPropertyRenovationEnum {
	None = "None",
	Continuous = "Continuous",
	Total = "Total",
	InProgress = "InProgress",
	Null = "Null",
	DEPRECATED_EMPTY = "DEPRECATED_EMPTY"
};

export enum ClientPropertyTypeEnum {
	AutoMoto = "AutoMoto",
	Flat = "Flat",
	House = "House",
	Cottage = "Cottage",
	Land = "Land",
	Art = "Art",
	Commodity = "Commodity"
};

export enum ClientPropertyVehicleTypeEnum {
	CarUpTo3_5t = "CarUpTo3_5t",
	Motorcycle = "Motorcycle",
	Bus = "Bus",
	UtilityCar = "UtilityCar",
	Tractor = "Tractor",
	Motorhome = "Motorhome",
	Truck = "Truck",
	WorkMachine = "WorkMachine",
	Trailer = "Trailer",
	OtherElectro = "OtherElectro",
	OtherVehicles = "OtherVehicles",
	None = "None"
};

export enum ClientRatingEnum {
	VIP = "VIP",
	A = "A",
	B = "B",
	C = "C",
	D = "D",
	E = "E",
	F = "F",
	None = "None",
	NoneOld = "NoneOld"
};

export enum ClientTaskEventDataItemActionEnum {
	Created = "Created",
	Updated = "Updated",
	Deleted = "Deleted",
	Archived = "Archived",
	Unarchived = "Unarchived",
	Solved = "Solved",
	Unsolved = "Unsolved"
};

export type ClientTypeResponseDTO = {
	id: number;
	name: string;
};

export enum CurrencyEnum {
	CZK = "CZK",
	USD = "USD",
	EUR = "EUR",
	GBP = "GBP",
	JPY = "JPY",
	AUD = "AUD",
	SGD = "SGD",
	CHF = "CHF",
	HUF = "HUF",
	PLN = "PLN",
	NOK = "NOK",
	RON = "RON",
	HKD = "HKD",
	DKK = "DKK",
	CAD = "CAD",
	CNY = "CNY",
	NZD = "NZD",
	SEK = "SEK",
	TRY = "TRY",
	UNKNOWN = "UNKNOWN",
	Empty = "Empty"
};

export type AbstractClientPortfolioCreateRequestDTO = {
	name?: string | null;
	contractNumber?: string | null;
	producer?: string | null;
	product?: string | null;
	signedAt?: string | null;
	startAt?: string | null;
	endAt?: string | null;
	productCategoryId?: number | null;
};

export type AbstractClientPortfolioEditRequestDTO = {
	name?: string | null;
	contractNumber?: string | null;
	producer?: string | null;
	product?: string | null;
	signedAt?: string | null;
	startAt?: string | null;
	endAt?: string | null;
	productCategoryId?: number | null;
};

export type ClientFinancialPlanExpenseCreateRequestDTO = {
	name: ClientFinancialPlanExpenseNameEnum;
	type: ClientFinancialPlanExpenseTypeEnum;
	monthlyPayment: number;
	sustainableAmount: number;
};

export type ClientFinancialPlanExpenseUpdateRequestDTO = {
	monthlyPayment: number;
	sustainableAmount: number;
};

export type ClientFinancialPlanIncomeSaveRequestDTO = {
	id?: number | null;
	name: string;
	amount: number;
};

export type ClientFuturePortfolioCreateRequestDTO = {
	sharedId: string;
	name: string;
	type: FuturePortfolioTypeEnum;
	startAt: string;
	oneTimeDeposit?: number | null;
	monthlyAmount?: number | null;
	note?: string | null;
};

export type ClientFuturePortfolioDeleteRequestDTO = {
	mydockFuturePortfolioId: number;
};

export type ClientFuturePortfolioPartialUpdateRequestDTO = {
	mydockFuturePortfolioId: number;
	name?: string | null;
	type?: FuturePortfolioTypeEnum | null;
	startAt?: string | null;
	oneTimeDeposit?: number | null;
	monthlyAmount?: number | null;
	note?: string | null;
};

export type ClientPortfolioBankProductCreateRequestDTO = {
	name?: string | null;
	contractNumber?: string | null;
	producer?: string | null;
	product?: string | null;
	signedAt?: string | null;
	startAt?: string | null;
	endAt?: string | null;
	productCategoryId?: number | null;
	tools?: ClientPortfolioToolsRequestDTO | null;
};

export type ClientPortfolioBankProductEditRequestDTO = {
	name?: string | null;
	contractNumber?: string | null;
	producer?: string | null;
	product?: string | null;
	signedAt?: string | null;
	startAt?: string | null;
	endAt?: string | null;
	productCategoryId?: number | null;
	tools?: ClientPortfolioToolsRequestDTO | null;
};

export type ClientPortfolioBankProductInstructionRequestDTO = {
	id?: number | null;
	startAt?: string | null;
	endAt?: string | null;
	investmentType?: ClientPortfolioInvestmentTypeEnum | null;
	amount?: number | null;
	currency?: CurrencyEnum | null;
	frequency?: ClientPortfolioInvestmentFrequencyEnum | null;
	interestRate?: number | null;
};

export type ClientPortfolioBankProductToolRequestDTO = {
	identification?: string | null;
	name?: string | null;
	instructions?: ClientPortfolioBankProductInstructionRequestDTO[] | null;
};

export type ClientPortfolioBondInstructionRequestDTO = {
	id?: number | null;
	issueDate?: string | null;
	maturityDate?: string | null;
	price?: number | null;
	currency?: CurrencyEnum | null;
	count?: number | null;
	yield?: number | null;
	tax?: number | null;
	fee?: number | null;
	interestType?: ClientBondInterestTypeEnum | null;
	frequency?: ClientPortfolioInvestmentFrequencyEnum | null;
	rates?: ClientPortfolioBondRateRequestDTO[] | null;
	enterFee?: ClientPortfolioInvestmentEnterFeeRequestDTO | null;
};

export type ClientPortfolioBondRateRequestDTO = {
	date?: string | null;
	yield?: number | null;
};

export type ClientPortfolioBuildingSavingsCreateRequestDTO = {
	name?: string | null;
	contractNumber?: string | null;
	producer?: string | null;
	product?: string | null;
	signedAt?: string | null;
	startAt?: string | null;
	endAt?: string | null;
	productCategoryId?: number | null;
	payment?: number | null;
	paymentFrequency?: ClientPortfolioPaymentFrequencyEnum | null;
	appreciation?: number | null;
	stateContribution?: "Yes" | "No" | null;
	targetAmount?: number | null;
};

export type ClientPortfolioBuildingSavingsEditRequestDTO = {
	name?: string | null;
	contractNumber?: string | null;
	producer?: string | null;
	product?: string | null;
	signedAt?: string | null;
	startAt?: string | null;
	endAt?: string | null;
	productCategoryId?: number | null;
	payment?: number | null;
	paymentFrequency?: ClientPortfolioPaymentFrequencyEnum | null;
	appreciation?: number | null;
	stateContribution?: "Yes" | "No" | null;
	targetAmount?: number | null;
};

export type ClientPortfolioCommoditiesCommodityRequestDTO = {
	id?: number | null;
	startAt?: string | null;
	endAt?: string | null;
	investmentType?: ClientPortfolioInvestmentTypeEnum | null;
	amount?: number | null;
	currency?: CurrencyEnum | null;
	frequency?: ClientPortfolioInvestmentFrequencyEnum | null;
	spread?: number | null;
	enterFee?: ClientPortfolioInvestmentEnterFeeRequestDTO | null;
};

export type ClientPortfolioCommoditiesCreateRequestDTO = {
	name?: string | null;
	contractNumber?: string | null;
	producer?: string | null;
	product?: string | null;
	signedAt?: string | null;
	startAt?: string | null;
	endAt?: string | null;
	productCategoryId?: number | null;
	tools?: ClientPortfolioToolsRequestDTO | null;
};

export type ClientPortfolioCommoditiesEditRequestDTO = {
	name?: string | null;
	contractNumber?: string | null;
	producer?: string | null;
	product?: string | null;
	signedAt?: string | null;
	startAt?: string | null;
	endAt?: string | null;
	productCategoryId?: number | null;
	tools?: ClientPortfolioToolsRequestDTO | null;
};

export type ClientPortfolioCommoditiesToolRequestDTO = {
	identification?: ClientPortfolioToolCommodityIdentificationEnum | null;
	name?: string | null;
	commodities?: ClientPortfolioCommoditiesCommodityRequestDTO[] | null;
};

export type ClientPortfolioCryptocurrenciesCreateRequestDTO = {
	name?: string | null;
	contractNumber?: string | null;
	producer?: string | null;
	product?: string | null;
	signedAt?: string | null;
	startAt?: string | null;
	endAt?: string | null;
	productCategoryId?: number | null;
	tools?: ClientPortfolioToolsRequestDTO | null;
};

export type ClientPortfolioCryptocurrenciesEditRequestDTO = {
	name?: string | null;
	contractNumber?: string | null;
	producer?: string | null;
	product?: string | null;
	signedAt?: string | null;
	startAt?: string | null;
	endAt?: string | null;
	productCategoryId?: number | null;
	tools?: ClientPortfolioToolsRequestDTO | null;
};

export type ClientPortfolioCryptocurrenciesInstructionRequestDTO = {
	id?: number | null;
	investmentType?: ClientPortfolioInvestmentTypeEnum | null;
	holdingType?: ClientPortfolioInstructionHoldingTypeEnum | null;
	currencyFrom?: string | null;
	currencyTo?: string | null;
	countFrom?: number | null;
	countTo?: number | null;
	frequency?: ClientPortfolioInvestmentFrequencyEnum | null;
	date?: string | null;
	endedAt?: string | null;
	enterFee?: ClientPortfolioInvestmentEnterFeeRequestDTO | null;
};

export type ClientPortfolioCryptocurrenciesToolRequestDTO = {
	identification?: string | null;
	name?: string | null;
	cryptocurrencyInstructions?: ClientPortfolioCryptocurrenciesInstructionRequestDTO[] | null;
};

export type ClientPortfolioInvestmentBondToolRequestDTO = {
	type?: ClientPortfolioToolTypeEnum | null;
	identificationType?: ClientPortfolioToolIdentificationTypeEnum | null;
	identification?: string | null;
	name?: string | null;
	evaluation?: number | null;
	instructions?: ClientPortfolioBondInstructionRequestDTO[] | null;
};

export type ClientPortfolioInvestmentCreateRequestDTO = {
	name?: string | null;
	contractNumber?: string | null;
	producer?: string | null;
	product?: string | null;
	signedAt?: string | null;
	startAt?: string | null;
	endAt?: string | null;
	productCategoryId?: number | null;
	tools?: ClientPortfolioToolsRequestDTO | null;
};

export type ClientPortfolioInvestmentEditRequestDTO = {
	name?: string | null;
	contractNumber?: string | null;
	producer?: string | null;
	product?: string | null;
	signedAt?: string | null;
	startAt?: string | null;
	endAt?: string | null;
	productCategoryId?: number | null;
	tools?: ClientPortfolioToolsRequestDTO | null;
};

export type ClientPortfolioInvestmentEnterFeeRequestDTO = {
	amountType?: ClientPortfolioInvestmentEnterFeeAmountTypeEnum | null;
	type?: ClientPortfolioInvestmentEnterFeeTypeEnum | null;
	amount?: number | null;
	chargedFeeFromFirstPayments?: number | null;
	applying?: ClientPortfolioInvestmentEnterFeeApplyingEnum | null;
};

export type ClientPortfolioInvestmentFundToolRequestDTO = {
	type?: ClientPortfolioToolTypeEnum | null;
	identificationType?: ClientPortfolioToolIdentificationTypeEnum | null;
	identification?: string | null;
	name?: string | null;
	evaluation?: number | null;
	instructions?: ClientPortfolioInvestmentInstructionRequestDTO[] | null;
};

export type ClientPortfolioInvestmentInstructionRequestDTO = {
	id?: number | null;
	startAt?: string | null;
	endAt?: string | null;
	investmentType?: ClientPortfolioInvestmentTypeEnum | null;
	amount?: number | null;
	currency?: CurrencyEnum | null;
	frequency?: ClientPortfolioInvestmentFrequencyEnum | null;
	transactionType?: ClientPortfolioInvestmentTransactionEnum | null;
	enterFee?: ClientPortfolioInvestmentEnterFeeRequestDTO | null;
};

export type ClientPortfolioLeasingCreateRequestDTO = {
	name?: string | null;
	contractNumber?: string | null;
	producer?: string | null;
	product?: string | null;
	signedAt?: string | null;
	startAt?: string | null;
	endAt?: string | null;
	productCategoryId?: number | null;
	originalObligationAmount?: number | null;
	installment?: number | null;
	interestRate?: number | null;
	fixationEndDate?: string | null;
	paymentFrequency?: ClientPortfolioPaymentFrequencyEnum | null;
};

export type ClientPortfolioLeasingEditRequestDTO = {
	name?: string | null;
	contractNumber?: string | null;
	producer?: string | null;
	product?: string | null;
	signedAt?: string | null;
	startAt?: string | null;
	endAt?: string | null;
	productCategoryId?: number | null;
	originalObligationAmount?: number | null;
	installment?: number | null;
	interestRate?: number | null;
	fixationEndDate?: string | null;
	paymentFrequency?: ClientPortfolioPaymentFrequencyEnum | null;
};

export type ClientPortfolioLifeInsuranceCreateRequestDTO = {
	name?: string | null;
	contractNumber?: string | null;
	producer?: string | null;
	product?: string | null;
	insurance?: number | null;
	insurancePeriod?: number | null;
	paymentFrequency?: ClientPortfolioPaymentFrequencyEnum | null;
	payment?: number | null;
	employerContribution?: number | null;
	ageLimit?: number | null;
	lifeComponent?: number | null;
	riskComponent?: number | null;
	signedAt?: string | null;
	startAt?: string | null;
	endAt?: string | null;
	productCategoryId?: number | null;
	tools?: ClientPortfolioToolsRequestDTO | null;
};

export type ClientPortfolioLifeInsuranceEditRequestDTO = {
	name?: string | null;
	contractNumber?: string | null;
	producer?: string | null;
	product?: string | null;
	insurance?: number | null;
	insurancePeriod?: number | null;
	paymentFrequency?: ClientPortfolioPaymentFrequencyEnum | null;
	payment?: number | null;
	employerContribution?: number | null;
	ageLimit?: number | null;
	lifeComponent?: number | null;
	riskComponent?: number | null;
	signedAt?: string | null;
	startAt?: string | null;
	endAt?: string | null;
	productCategoryId?: number | null;
	tools?: ClientPortfolioToolsRequestDTO | null;
};

export type ClientPortfolioLoanChangeRequestDTO = {
	changeDate?: string | null;
	changeType?: ClientPortfolioDataChangeChangeTypeEnum | null;
	changeTypeSupplement?: ClientPortfolioDataChangeTypeSupplementEnum | null;
	originalObligationAmount?: number | null;
	installment?: number | null;
	interestRate?: number | null;
	fixationEndDate?: string | null;
	paymentFrequency?: ClientPortfolioPaymentFrequencyEnum | null;
	loanTerm?: number | null;
	loanTermUnit?: ClientPortfolioLoanTermUnitEnum | null;
};

export type ClientPortfolioLoanCoDebtorRequestDTO = {
	id?: number | null;
	firstname?: string | null;
	lastname?: string | null;
	identification?: string | null;
};

export type ClientPortfolioLoansCreateRequestDTO = {
	name?: string | null;
	contractNumber?: string | null;
	producer?: string | null;
	product?: string | null;
	signedAt?: string | null;
	startAt?: string | null;
	endAt?: string | null;
	productCategoryId?: number | null;
	initialChange?: ClientPortfolioLoanChangeRequestDTO | null;
	coDebtors?: ClientPortfolioLoanCoDebtorRequestDTO[] | null;
};

export type ClientPortfolioLoansEditRequestDTO = {
	name?: string | null;
	contractNumber?: string | null;
	producer?: string | null;
	product?: string | null;
	signedAt?: string | null;
	startAt?: string | null;
	endAt?: string | null;
	productCategoryId?: number | null;
	coDebtors?: ClientPortfolioLoanCoDebtorRequestDTO[] | null;
	change?: ClientPortfolioLoanChangeRequestDTO | null;
	changesToDelete?: number[] | null;
};

export type ClientPortfolioManualValueSaveRequestDTO = {
	value: number;
	invested?: number | null;
	date?: string | null;
};

export type ClientPortfolioNonLifeInsuranceCreateRequestDTO = {
	name?: string | null;
	contractNumber?: string | null;
	producer?: string | null;
	product?: string | null;
	insurance?: number | null;
	insurancePeriod?: number | null;
	paymentFrequency?: ClientPortfolioPaymentFrequencyEnum | null;
	signedAt?: string | null;
	startAt?: string | null;
	endAt?: string | null;
	productCategoryId?: number | null;
};

export type ClientPortfolioNonLifeInsuranceEditRequestDTO = {
	name?: string | null;
	contractNumber?: string | null;
	producer?: string | null;
	product?: string | null;
	insurance?: number | null;
	insurancePeriod?: number | null;
	paymentFrequency?: ClientPortfolioPaymentFrequencyEnum | null;
	signedAt?: string | null;
	startAt?: string | null;
	endAt?: string | null;
	productCategoryId?: number | null;
};

export type ClientPortfolioPensionProductsCreateRequestDTO = {
	name?: string | null;
	contractNumber?: string | null;
	producer?: string | null;
	product?: string | null;
	signedAt?: string | null;
	startAt?: string | null;
	endAt?: string | null;
	productCategoryId?: number | null;
	payment?: number | null;
	paymentFrequency?: ClientPortfolioPaymentFrequencyEnum | null;
	appreciation?: number | null;
	stateContribution?: "Yes" | "No" | null;
	employerContribution?: number | null;
	ageLimit?: number | null;
};

export type ClientPortfolioPensionProductsEditRequestDTO = {
	name?: string | null;
	contractNumber?: string | null;
	producer?: string | null;
	product?: string | null;
	signedAt?: string | null;
	startAt?: string | null;
	endAt?: string | null;
	productCategoryId?: number | null;
	payment?: number | null;
	paymentFrequency?: ClientPortfolioPaymentFrequencyEnum | null;
	appreciation?: number | null;
	stateContribution?: "Yes" | "No" | null;
	employerContribution?: number | null;
	ageLimit?: number | null;
};

export type ClientPortfolioServicesCreateRequestDTO = {
	name?: string | null;
	contractNumber?: string | null;
	producer?: string | null;
	product?: string | null;
	signedAt?: string | null;
	startAt?: string | null;
	endAt?: string | null;
	productCategoryId?: number | null;
	depositAmount?: number | null;
	tariff?: string | null;
	commodityService?: ClientPortfolioDataCommodityServiceEnum | null;
	unitOfMeasurement?: string | null;
	pricePerUnit?: number | null;
	fixedPriceByFrequency?: number | null;
	paymentFrequency?: ClientPortfolioPaymentFrequencyEnum | null;
};

export type ClientPortfolioServicesEditRequestDTO = {
	name?: string | null;
	contractNumber?: string | null;
	producer?: string | null;
	product?: string | null;
	signedAt?: string | null;
	startAt?: string | null;
	endAt?: string | null;
	productCategoryId?: number | null;
	depositAmount?: number | null;
	tariff?: string | null;
	commodityService?: ClientPortfolioDataCommodityServiceEnum | null;
	unitOfMeasurement?: string | null;
	pricePerUnit?: number | null;
	fixedPriceByFrequency?: number | null;
	paymentFrequency?: ClientPortfolioPaymentFrequencyEnum | null;
};

export type ClientPortfolioToolsRequestDTO = {
	funds?: ClientPortfolioInvestmentFundToolRequestDTO[] | null;
	bonds?: ClientPortfolioInvestmentBondToolRequestDTO[] | null;
	commodities?: ClientPortfolioCommoditiesToolRequestDTO[] | null;
	cryptocurrencies?: ClientPortfolioCryptocurrenciesToolRequestDTO[] | null;
	bankProducts?: ClientPortfolioBankProductToolRequestDTO[] | null;
};

export type ClientPropertyArtCreateRequestDTO = {
	propertyType?: string | null;
	customDisposition?: string | null;
	purchaseDate?: string | null;
	description?: string | null;
	value?: number | null;
	forInvestments?: boolean | null;
};

export type ClientPropertyArtEditRequestDTO = {
	propertyType?: string | null;
	customDisposition?: string | null;
	purchaseDate?: string | null;
	description?: string | null;
	value?: number | null;
	forInvestments?: boolean | null;
};

export type ClientPropertyCottageCreateRequestDTO = {
	name?: string | null;
	propertyCategory?: ClientPropertyCategoryEnum | null;
	ownership?: ClientPropertyOwnershipEnum | null;
	location?: string | null;
	locationMunicipality?: string | null;
	locationDistrict?: string | null;
	locationZipCode?: string | null;
	usableArea?: number | null;
	floorArea?: number | null;
	disposition?: ClientPropertyBuildingDispositionEnum | null;
	customDisposition?: string | null;
	buildingMaterial?: ClientPropertyBuildingMaterialEnum | null;
	customBuildingMaterial?: string | null;
	numberOfFloors?: number | null;
	terrace?: boolean | null;
	loggia?: boolean | null;
	balcony?: boolean | null;
	garage?: boolean | null;
	cellar?: boolean | null;
	elevator?: boolean | null;
	barrierFree?: boolean | null;
	swimmingPool?: boolean | null;
	parkingSpace?: boolean | null;
	furnished?: boolean | null;
	marketValue?: number | null;
	reproductionValue?: number | null;
	interiorValue?: number | null;
	renovation?: ClientPropertyRenovationEnum | null;
	yearOfRenovation?: number | null;
	yearOfCompletion?: number | null;
	purchaseDate?: string | null;
	description?: string | null;
	forInvestments?: boolean | null;
	isMyplannShared?: boolean | null;
};

export type ClientPropertyCottageEditRequestDTO = {
	name?: string | null;
	propertyCategory?: ClientPropertyCategoryEnum | null;
	ownership?: ClientPropertyOwnershipEnum | null;
	location?: string | null;
	locationMunicipality?: string | null;
	locationDistrict?: string | null;
	locationZipCode?: string | null;
	usableArea?: number | null;
	floorArea?: number | null;
	disposition?: ClientPropertyBuildingDispositionEnum | null;
	customDisposition?: string | null;
	buildingMaterial?: ClientPropertyBuildingMaterialEnum | null;
	customBuildingMaterial?: string | null;
	numberOfFloors?: number | null;
	terrace?: boolean | null;
	loggia?: boolean | null;
	balcony?: boolean | null;
	garage?: boolean | null;
	cellar?: boolean | null;
	elevator?: boolean | null;
	barrierFree?: boolean | null;
	swimmingPool?: boolean | null;
	parkingSpace?: boolean | null;
	furnished?: boolean | null;
	marketValue?: number | null;
	reproductionValue?: number | null;
	interiorValue?: number | null;
	renovation?: ClientPropertyRenovationEnum | null;
	yearOfRenovation?: number | null;
	yearOfCompletion?: number | null;
	purchaseDate?: string | null;
	description?: string | null;
	forInvestments?: boolean | null;
};

export type ClientPropertyFlatCreateRequestDTO = {
	name?: string | null;
	propertyCategory?: ClientPropertyCategoryEnum | null;
	ownership?: ClientPropertyOwnershipEnum | null;
	location?: string | null;
	locationMunicipality?: string | null;
	locationDistrict?: string | null;
	locationZipCode?: string | null;
	usableArea?: number | null;
	floorArea?: number | null;
	disposition?: ClientPropertyBuildingDispositionEnum | null;
	customDisposition?: string | null;
	buildingMaterial?: ClientPropertyBuildingMaterialEnum | null;
	customBuildingMaterial?: string | null;
	numberOfFloors?: number | null;
	terrace?: boolean | null;
	loggia?: boolean | null;
	balcony?: boolean | null;
	garage?: boolean | null;
	cellar?: boolean | null;
	elevator?: boolean | null;
	barrierFree?: boolean | null;
	swimmingPool?: boolean | null;
	parkingSpace?: boolean | null;
	furnished?: boolean | null;
	marketValue?: number | null;
	reproductionValue?: number | null;
	interiorValue?: number | null;
	renovation?: ClientPropertyRenovationEnum | null;
	yearOfRenovation?: number | null;
	yearOfCompletion?: number | null;
	purchaseDate?: string | null;
	description?: string | null;
	forInvestments?: boolean | null;
	isMyplannShared?: boolean | null;
};

export type ClientPropertyFlatEditRequestDTO = {
	name?: string | null;
	propertyCategory?: ClientPropertyCategoryEnum | null;
	ownership?: ClientPropertyOwnershipEnum | null;
	location?: string | null;
	locationMunicipality?: string | null;
	locationDistrict?: string | null;
	locationZipCode?: string | null;
	usableArea?: number | null;
	floorArea?: number | null;
	disposition?: ClientPropertyBuildingDispositionEnum | null;
	customDisposition?: string | null;
	buildingMaterial?: ClientPropertyBuildingMaterialEnum | null;
	customBuildingMaterial?: string | null;
	numberOfFloors?: number | null;
	terrace?: boolean | null;
	loggia?: boolean | null;
	balcony?: boolean | null;
	garage?: boolean | null;
	cellar?: boolean | null;
	elevator?: boolean | null;
	barrierFree?: boolean | null;
	swimmingPool?: boolean | null;
	parkingSpace?: boolean | null;
	furnished?: boolean | null;
	marketValue?: number | null;
	reproductionValue?: number | null;
	interiorValue?: number | null;
	renovation?: ClientPropertyRenovationEnum | null;
	yearOfRenovation?: number | null;
	yearOfCompletion?: number | null;
	purchaseDate?: string | null;
	description?: string | null;
	forInvestments?: boolean | null;
};

export type ClientPropertyHouseCreateRequestDTO = {
	name?: string | null;
	propertyCategory?: ClientPropertyCategoryEnum | null;
	ownership?: ClientPropertyOwnershipEnum | null;
	location?: string | null;
	locationMunicipality?: string | null;
	locationDistrict?: string | null;
	locationZipCode?: string | null;
	usableArea?: number | null;
	floorArea?: number | null;
	disposition?: ClientPropertyBuildingDispositionEnum | null;
	customDisposition?: string | null;
	buildingMaterial?: ClientPropertyBuildingMaterialEnum | null;
	customBuildingMaterial?: string | null;
	numberOfFloors?: number | null;
	terrace?: boolean | null;
	loggia?: boolean | null;
	balcony?: boolean | null;
	garage?: boolean | null;
	cellar?: boolean | null;
	elevator?: boolean | null;
	barrierFree?: boolean | null;
	swimmingPool?: boolean | null;
	parkingSpace?: boolean | null;
	furnished?: boolean | null;
	marketValue?: number | null;
	reproductionValue?: number | null;
	interiorValue?: number | null;
	renovation?: ClientPropertyRenovationEnum | null;
	yearOfRenovation?: number | null;
	yearOfCompletion?: number | null;
	purchaseDate?: string | null;
	description?: string | null;
	forInvestments?: boolean | null;
	isMyplannShared?: boolean | null;
};

export type ClientPropertyHouseEditRequestDTO = {
	name?: string | null;
	propertyCategory?: ClientPropertyCategoryEnum | null;
	ownership?: ClientPropertyOwnershipEnum | null;
	location?: string | null;
	locationMunicipality?: string | null;
	locationDistrict?: string | null;
	locationZipCode?: string | null;
	usableArea?: number | null;
	floorArea?: number | null;
	disposition?: ClientPropertyBuildingDispositionEnum | null;
	customDisposition?: string | null;
	buildingMaterial?: ClientPropertyBuildingMaterialEnum | null;
	customBuildingMaterial?: string | null;
	numberOfFloors?: number | null;
	terrace?: boolean | null;
	loggia?: boolean | null;
	balcony?: boolean | null;
	garage?: boolean | null;
	cellar?: boolean | null;
	elevator?: boolean | null;
	barrierFree?: boolean | null;
	swimmingPool?: boolean | null;
	parkingSpace?: boolean | null;
	furnished?: boolean | null;
	marketValue?: number | null;
	reproductionValue?: number | null;
	interiorValue?: number | null;
	renovation?: ClientPropertyRenovationEnum | null;
	yearOfRenovation?: number | null;
	yearOfCompletion?: number | null;
	purchaseDate?: string | null;
	description?: string | null;
	forInvestments?: boolean | null;
};

export type ClientPropertyLandCreateRequestDTO = {
	name?: string | null;
	propertyCategory?: ClientPropertyCategoryEnum | null;
	ownership?: ClientPropertyOwnershipEnum | null;
	location?: string | null;
	locationMunicipality?: string | null;
	locationZipCode?: string | null;
	parcelNumber?: string | null;
	landSize?: number | null;
	landValue?: number | null;
	reproductionValue?: number | null;
	purchaseDate?: string | null;
	description?: string | null;
	forInvestments?: boolean | null;
	isMyplannShared?: boolean | null;
};

export type ClientPropertyLandEditRequestDTO = {
	name?: string | null;
	propertyCategory?: ClientPropertyCategoryEnum | null;
	ownership?: ClientPropertyOwnershipEnum | null;
	location?: string | null;
	locationMunicipality?: string | null;
	locationZipCode?: string | null;
	parcelNumber?: string | null;
	landSize?: number | null;
	landValue?: number | null;
	reproductionValue?: number | null;
	purchaseDate?: string | null;
	description?: string | null;
	forInvestments?: boolean | null;
};

export type ClientPropertyVehicleCreateRequestDTO = {
	name?: string | null;
	propertyType?: ClientPropertyVehicleTypeEnum | null;
	carVehicleType?: ClientPropertyCarVehicleTypeEnum | null;
	carBrand?: string | null;
	carModel?: string | null;
	carVin?: string | null;
	carLicensePlate?: string | null;
	carVolume?: number | null;
	carPower?: number | null;
	carFuel?: ClientCarFuelEnum | null;
	carBodyType?: ClientCarBodyTypeEnum | null;
	carWeight?: number | null;
	carSeatCount?: number | null;
	carManufactureMonthYear?: string | null;
	carPurchaseDate?: string | null;
	carRegistration?: string | null;
	carPutIntoService?: string | null;
	value?: number | null;
	description?: string | null;
	carMechanicalSecurity?: boolean | null;
	carAlarmSecurity?: boolean | null;
	carPassiveTrackingSecurity?: boolean | null;
	carImmobilizerSecurity?: boolean | null;
	carActiveTrackingSecurity?: boolean | null;
	carGlassEtchingSecurity?: boolean | null;
	carSpecialEquipment44?: boolean | null;
	carSpecialEquipmentAudiovisualSystem?: boolean | null;
	carSpecialEquipmentLeatherUpholstery?: boolean | null;
	carSpecialEquipmentPanoramicRoof?: boolean | null;
	carSpecialEquipmentParkingAssistant?: boolean | null;
	carLeasingOrLoan?: boolean | null;
	carDamage?: boolean | null;
	carIsNew?: boolean | null;
	carUsage?: ClientPropertyCarUsageEnum | null;
	carMileage?: string | null;
	carAnnualMileage?: ClientPropertyCarAnnualMileageEnum | null;
	carRegisteredInCR?: boolean | null;
	carFirstRegistrationOutsideCR?: boolean | null;
	carFirstOwner?: boolean | null;
	forInvestments?: boolean | null;
	isMyplannShared?: boolean | null;
};

export type ClientPropertyVehicleEditRequestDTO = {
	name?: string | null;
	propertyType?: ClientPropertyVehicleTypeEnum | null;
	carVehicleType?: ClientPropertyCarVehicleTypeEnum | null;
	carBrand?: string | null;
	carModel?: string | null;
	carVin?: string | null;
	carLicensePlate?: string | null;
	carVolume?: number | null;
	carPower?: number | null;
	carFuel?: ClientCarFuelEnum | null;
	carBodyType?: ClientCarBodyTypeEnum | null;
	carWeight?: number | null;
	carSeatCount?: number | null;
	carManufactureMonthYear?: string | null;
	carPurchaseDate?: string | null;
	carRegistration?: string | null;
	carPutIntoService?: string | null;
	value?: number | null;
	description?: string | null;
	carMechanicalSecurity?: boolean | null;
	carAlarmSecurity?: boolean | null;
	carPassiveTrackingSecurity?: boolean | null;
	carImmobilizerSecurity?: boolean | null;
	carActiveTrackingSecurity?: boolean | null;
	carGlassEtchingSecurity?: boolean | null;
	carSpecialEquipment44?: boolean | null;
	carSpecialEquipmentAudiovisualSystem?: boolean | null;
	carSpecialEquipmentLeatherUpholstery?: boolean | null;
	carSpecialEquipmentPanoramicRoof?: boolean | null;
	carSpecialEquipmentParkingAssistant?: boolean | null;
	carLeasingOrLoan?: boolean | null;
	carDamage?: boolean | null;
	carIsNew?: boolean | null;
	carUsage?: ClientPropertyCarUsageEnum | null;
	carMileage?: string | null;
	carAnnualMileage?: ClientPropertyCarAnnualMileageEnum | null;
	carRegisteredInCR?: boolean | null;
	carFirstRegistrationOutsideCR?: boolean | null;
	carFirstOwner?: boolean | null;
	forInvestments?: boolean | null;
};

export type ClientRelatedPinRequestDTO = {
	targetPortfolioId?: number | null;
	targetPropertyId?: number | null;
	note?: string | null;
};

export type FinancialPlanIncomeSaveRequestDTO = {
	id?: number | null;
	name: string;
	amount: number;
};

export type FinancialPlanSaveExpenseRequestDTO = {
	id?: number | null;
	name: ClientFinancialPlanExpenseNameEnum;
	type: ClientFinancialPlanExpenseTypeEnum;
	monthlyPayment: number;
	sustainableAmount: number;
};

export type FinancialPlanUpdateRequestDTO = {
	incomes: FinancialPlanIncomeSaveRequestDTO[];
	expenses: FinancialPlanSaveExpenseRequestDTO[];
};

export type ClientActivityAgentItemResponseDTO = {
	clientActivityAgentId: number;
	username?: string | null;
	name?: string | null;
	isAssistant?: boolean | null;
	uid?: string | null;
};

export type ClientActivityNoteItemResponseDTO = {
	id: number;
	title?: string | null;
	text?: string | null;
};

export type ClientActivityParticipantItemResponseDTO = {
	id: number;
	clientId?: number | null;
	name?: string | null;
	role?: string | null;
	phone?: string | null;
	email?: string | null;
};

export type ClientActivityResponseDTO = {
	id?: number | null;
	type: ClientActivityTypeEnum;
	calendarId?: number | null;
	date: string;
	timeFrom?: string | null;
	timeTo?: string | null;
	place?: string | null;
	description?: string | null;
	myplannShared?: boolean | null;
	solved?: boolean | null;
};

export type ClientAddressResponseDTO = {
	id: number;
	type?: string | null;
	typeId?: number | null;
	title?: string | null;
	street?: string | null;
	descriptiveNumber?: string | null;
	city?: string | null;
	zip?: string | null;
	country?: string | null;
	countryId?: number | null;
	ruian?: string | null;
	gpsLat?: string | null;
	gpsLon?: string | null;
};

export type ClientAgreementResponseDTO = {
	isGoldAgreement?: boolean | null;
	isGoldAgreementWaiting?: boolean | null;
	isBlueAgreement?: boolean | null;
	isBlueAgreementWaiting?: boolean | null;
	documentType?: ClientAgreementIdentificationDocumentEnum | null;
	documentNumber?: string | null;
	goldAgreementEmail?: string | null;
	goldAgreementPhone?: string | null;
	isClientValidForGoldAgreement?: boolean | null;
};

export type ClientContactResponseDTO = {
	id: number;
	authorized: boolean;
	type: ClientContactTypeEnum;
	value?: string | null;
};

export type ClientDataResponseDTO = {
	degreeBefore?: string | null;
	degreeAfter?: string | null;
	firstName?: string | null;
	lastName?: string | null;
	maritalStatus?: string | null;
	healthInsurance?: string | null;
	job?: string | null;
	company?: string | null;
	name?: string | null;
	bornPlace?: string | null;
	bornDate?: string | null;
	incomeSource?: string | null;
	accountNumber?: string | null;
	identificationNumber?: string | null;
	companyName?: string | null;
	vat?: string | null;
	note?: string | null;
	recommendedBy?: string | null;
	responsiblePersonFirstName?: string | null;
	responsiblePersonLastName?: string | null;
	responsiblePersonJob?: string | null;
};

export type ClientDetailResponseDTO = {
	id: number;
	clientType: ClientTypeResponseDTO;
	favourite: boolean;
	points?: number | null;
	createdAt?: string | null;
	data?: ClientDataResponseDTO | null;
	info?: ClientInfoResponseDTO | null;
	contacts: ClientContactResponseDTO[];
	contactPhone?: string | null;
	contactEmail?: string | null;
	addresses: ClientAddressResponseDTO[];
	identificationDocuments: ClientIdentificationDocumentResponseDTO[];
	oldDetailLink?: string | null;
	group?: ClientGroupResponseDTO | null;
	agreement?: ClientAgreementResponseDTO | null;
};

export type ClientExpenseDetailResponseDTO = {
	id: number;
	name: ClientFinancialPlanExpenseNameEnum;
	type: ClientFinancialPlanExpenseTypeEnum;
	monthlyPayment: number;
	sustainableAmount: number;
};

export type ClientExpenseListItemResponseDTO = {
	id: number;
	type: ClientFinancialPlanExpenseTypeEnum;
	name: ClientFinancialPlanExpenseNameEnum;
	monthlyPayment: number;
	sustainableAmount: number;
};

export type ClientGroupContactItemResponseDTO = {
	id: number;
	clientId?: number | null;
	identificationNumber?: string | null;
	degreeBefore?: string | null;
	degreeAfter?: string | null;
	firstName?: string | null;
	lastName?: string | null;
	companyName?: string | null;
	favourite: boolean;
	rating: ClientRatingEnum;
};

export type ClientGroupResponseDTO = {
	title?: string | null;
	clients: ClientGroupContactItemResponseDTO[];
};

export type ClientIdentificationDocumentResponseDTO = {
	id?: number | null;
	type?: ClientIdentificationDocumentTypeEnum | null;
	number?: string | null;
	issuer?: string | null;
	validToDate?: string | null;
};

export type ClientIncomeDetailResponseDTO = {
	id: number;
	name?: string | null;
	amount: number;
};

export type ClientInfoResponseDTO = {
	isAML: boolean;
	amlDate?: string | null;
	isWebMyplann: boolean;
	isMyplann: boolean;
	isMyplannWaitingWithCurrentAgentPerson: boolean;
	isMyplannConnectedWithCurrentAgentPerson: boolean;
	isOwn: boolean;
	fullName?: string | null;
};

export type CryptocurrencyResponseDTO = {
	id: string;
	name: string;
};

export type ClientActivityEventDataItemResponseDTO = {
	action: ClientActivityEventDataItemActionEnum;
	occurredOn: string;
	agentPersonUsername?: string | null;
	agentPersonFullName?: string | null;
	apiUser?: ApiUserEnum | null;
};

export type ClientActivityEventDataResponseDTO = {
	discriminator: string;
	activityType: ClientActivityTypeEnum;
	items: ClientActivityEventDataItemResponseDTO[];
};

export type ClientChangedPropertyResponseDTO = {
	property: ClientChangedPropertyEnum;
	identifier: number;
	oldValue?: boolean | string | number | null;
	newValue?: boolean | string | number | null;
	propertyLabel: string;
};

export type ClientDocumentEventDataResponseDTO = {
	discriminator: string;
	documentType: ClientDocumentTypeEnum;
};

export type ClientEventDataResponseDTO = {
	discriminator: string;
};

export type ClientEventListItemResponseDTO = {
	id: number;
	typeGroup: ClientEventTypeGroupEnum;
	agentPersonName?: string | null;
	apiUser?: ApiUserEnum | null;
	contactId: number;
	contactName: string;
	entityId: string;
	type: ClientEventTypeEnum;
	title?: string | null;
	data?: ClientActivityEventDataResponseDTO | ClientPortfolioEventDataResponseDTO | ClientDocumentEventDataResponseDTO | ClientUpdatedEventDataResponseDTO | ClientFinancialPlanUpdatedEventDataResponseDTO | ClientTaskEventDataResponseDTO | null;
	date?: string | null;
	time?: string | null;
	timeTo?: string | null;
	solvedAt?: string | null;
	myplannShared?: boolean | null;
	link?: string | null;
	place?: string | null;
};

export type ClientEventListResponseDTO = any;

export type ClientFinancialPlanChangedPropertyResponseDTO = {
	property: ClientFinancialPlanChangedPropertyEnum;
	identifier: number;
	oldValue?: string | number | null;
	newValue?: string | number | null;
	discriminator: string;
};

export type ClientFinancialPlanIncomeChangedPropertyResponseDTO = {
	property: ClientFinancialPlanChangedPropertyEnum;
	identifier: number;
	oldValue?: string | number | null;
	newValue?: string | number | null;
	discriminator: string;
	incomeName: string;
	propertyLabel: string;
};

export type ClientFinancialPlanOutcomeChangedPropertyResponseDTO = {
	property: ClientFinancialPlanChangedPropertyEnum;
	identifier: number;
	oldValue?: string | number | null;
	newValue?: string | number | null;
	discriminator: string;
	outcomeType: ClientOutcomeTypeEnum;
	outcomeSubType: ClientOutcomeSubTypeEnum;
	propertyLabel: string;
	outcomeTypeLabel: string;
	outcomeSubTypeLabel: string;
};

export type ClientFinancialPlanUpdatedEventDataResponseDTO = {
	discriminator: string;
	changedProperties: (ClientFinancialPlanIncomeChangedPropertyResponseDTO | ClientFinancialPlanOutcomeChangedPropertyResponseDTO)[];
};

export type ClientPortfolioEventDataResponseDTO = {
	discriminator: string;
	portfolioType: ClientPortfolioTypeEnum;
};

export type ClientTaskEventDataItemResponseDTO = {
	action: ClientTaskEventDataItemActionEnum;
	occurredOn: string;
	agentPersonUsername?: string | null;
	agentPersonFullName?: string | null;
	apiUser?: ApiUserEnum | null;
};

export type ClientTaskEventDataResponseDTO = {
	discriminator: string;
	items: ClientTaskEventDataItemResponseDTO[];
};

export type ClientUpdatedEventDataResponseDTO = {
	discriminator: string;
	changedProperties: ClientChangedPropertyResponseDTO[];
};

export type FinancialPlanUpdateResponseDTO = {
	incomes: ClientIncomeDetailResponseDTO[];
	expenses: ClientExpenseListItemResponseDTO[];
};

export type ClientIdentificationDocumentDetailResponseDTO = {
	id: number;
	sharedId?: string | null;
	documentType: ClientIdentificationDocumentTypeEnum;
	name?: string | null;
	number?: string | null;
	validFrom?: string | null;
	validTo?: string | null;
};

export enum ClientInsuredPersonRiskVariantEnum {
	Constant = "Constant",
	Decreasing = "Decreasing",
	Annuities = "Annuities",
	Retroactively = "Retroactively",
	NonRetroactively = "NonRetroactively",
	Progression = "Progression",
	Empty = "Empty"
};

export type ClientPortfolioCryptocurrencyInstructionResponseDTO = {
	id: number;
	name?: string | null;
	frequency: ClientPortfolioInvestmentFrequencyEnum;
	currencyFrom: string;
	countFrom?: number | null;
	countTo?: number | null;
	currencyTo: string;
	date: string;
	endedAt?: string | null;
	holdingType: ClientPortfolioInstructionHoldingTypeEnum;
	investmentType?: ClientPortfolioInvestmentTypeEnum | null;
	enterFee?: ClientPortfolioInvestmentEnterFeeResponseDTO | null;
};

export enum ClientPortfolioDataCommodityServiceEnum {
	Gas = "Gas",
	Electricity = "Electricity",
	Water = "Water",
	Television = "Television",
	Internet = "Internet",
	CellPhoneTarrif = "CellPhoneTarrif",
	Other = "Other",
	None = "None"
};

export type ClientPortfolioDetailBankInstructionResponseDTO = {
	id: number;
	sabId?: number | null;
	startAt?: string | null;
	endAt?: string | null;
	investmentType: ClientPortfolioInvestmentTypeEnum;
	identification: string;
	interestRate?: number | null;
	name: string;
	amount?: number | null;
	currency?: CurrencyEnum | null;
	frequency: ClientPortfolioInvestmentFrequencyEnum;
};

export type ClientPortfolioDetailBankProductToolResponseDTO = {
	id: number;
	type?: ClientPortfolioToolTypeEnum | null;
	identificationType?: ClientPortfolioToolIdentificationTypeEnum | null;
	identification?: string | null;
	name?: string | null;
	instructions: ClientPortfolioDetailBankInstructionResponseDTO[];
	monthlyPayment: number;
};

export type ClientPortfolioDetailBondRateResponseDTO = {
	date: string;
	yield?: number | null;
};

export type ClientPortfolioDetailBondResponseDTO = {
	id: number;
	interestType?: ClientBondInterestTypeEnum | null;
	count?: number | null;
	price?: number | null;
	currency: CurrencyEnum;
	frequency: ClientPortfolioInvestmentFrequencyEnum;
	yield?: number | null;
	tax?: number | null;
	fee?: number | null;
	issueDate?: string | null;
	maturityDate?: string | null;
	rates: ClientPortfolioDetailBondRateResponseDTO[];
};

export type ClientPortfolioDetailBondToolResponseDTO = {
	id: number;
	type?: ClientPortfolioToolTypeEnum | null;
	identificationType?: ClientPortfolioToolIdentificationTypeEnum | null;
	identification?: string | null;
	name?: string | null;
	evaluation?: number | null;
	instructions: ClientPortfolioDetailBondResponseDTO[];
	monthlyPayment: number;
};

export type ClientPortfolioDetailCoDebtorResponseDTO = {
	id: number;
	firstname?: string | null;
	lastname?: string | null;
	identification?: string | null;
};

export type ClientPortfolioDetailCommodityResponseDTO = {
	id: number;
	investmentType?: ClientPortfolioInvestmentTypeEnum | null;
	startAt?: string | null;
	endAt?: string | null;
	amount?: number | null;
	currency?: CurrencyEnum | null;
	frequency: ClientPortfolioInvestmentFrequencyEnum;
	spread?: number | null;
	enterFee?: ClientPortfolioInvestmentEnterFeeResponseDTO | null;
};

export type ClientPortfolioDetailCommodityToolResponseDTO = {
	id: number;
	type?: ClientPortfolioToolTypeEnum | null;
	identificationType?: ClientPortfolioToolIdentificationTypeEnum | null;
	identification?: string | null;
	name?: string | null;
	commodities: ClientPortfolioDetailCommodityResponseDTO[];
	monthlyPayment: number;
};

export type ClientPortfolioDetailCryptocurrencyToolResponseDTO = {
	id: number;
	type?: ClientPortfolioToolTypeEnum | null;
	identificationType?: ClientPortfolioToolIdentificationTypeEnum | null;
	identification?: string | null;
	name?: string | null;
	cryptocurrencyInstructions: ClientPortfolioCryptocurrencyInstructionResponseDTO[];
	monthlyPayment: number;
};

export type ClientPortfolioDetailDataChangeResponseDTO = {
	id?: number | null;
	change?: number | null;
	updatedAt?: string | null;
	changeType?: ClientPortfolioDataChangeChangeTypeEnum | null;
	changeTypeSupplement?: ClientPortfolioDataChangeTypeSupplementEnum | null;
	originalObligationAmount?: number | null;
	installment?: number | null;
	interestRate?: number | null;
	fixationEndDate?: string | null;
	paymentFrequency?: ClientPortfolioPaymentFrequencyEnum | null;
	maturityLengthMonths?: number | null;
};

export type ClientPortfolioDetailDataResponseDTO = {
	employerContribution?: number | null;
	insurance?: number | null;
	insurancePeriod?: number | null;
	payment?: number | null;
	ageLimit?: number | null;
	depositAmount?: number | null;
	tariff?: string | null;
	commodityService?: ClientPortfolioDataCommodityServiceEnum | null;
	unitOfMeasurement?: string | null;
	pricePerUnit?: number | null;
	fixedPriceByFrequency?: number | null;
	paymentFrequency?: ClientPortfolioPaymentFrequencyEnum | null;
	interestRate?: number | null;
	fixationEndDate?: string | null;
	installment?: number | null;
	originalObligationAmount?: number | null;
	targetAmount?: number | null;
	lifeComponent?: number | null;
	riskComponent?: number | null;
	appreciation?: number | null;
	stateContribution?: boolean | null;
};

export type ClientPortfolioDetailFundToolResponseDTO = {
	id: number;
	type?: ClientPortfolioToolTypeEnum | null;
	identificationType?: ClientPortfolioToolIdentificationTypeEnum | null;
	identification?: string | null;
	name?: string | null;
	evaluation?: number | null;
	instructions: ClientPortfolioDetailInvestmentResponseDTO[];
	monthlyPayment: number;
};

export type ClientPortfolioDetailInsuredPersonResponseDTO = {
	id: number;
	firstname?: string | null;
	lastname?: string | null;
	identificationNumber?: string | null;
	risks: ClientPortfolioDetailInsuredPersonRiskResponseDTO[];
};

export type ClientPortfolioDetailInsuredPersonRiskResponseDTO = {
	id: number;
};

export type ClientPortfolioDetailInvestmentResponseDTO = {
	id: number;
	startAt?: string | null;
	endAt?: string | null;
	investmentType?: ClientPortfolioInvestmentTypeEnum | null;
	evaluation?: number | null;
	amount?: number | null;
	currency: CurrencyEnum;
	frequency: ClientPortfolioInvestmentFrequencyEnum;
	transactionType?: ClientPortfolioInvestmentTransactionEnum | null;
	otherDisposition?: string | null;
	enterFee?: ClientPortfolioInvestmentEnterFeeResponseDTO | null;
};

export type ClientPortfolioDetailRelatedPortfolioResponseDTO = {
	id: number;
	myplannPortfolioId?: number | null;
	name?: string | null;
	product?: string | null;
	domain: ClientPortfolioDomainEnum;
	contractNumber?: string | null;
};

export type ClientPortfolioDetailRelatedPropertyResponseDTO = {
	id: number;
	myplannPropertyId?: number | null;
	type: ClientPropertyTypeEnum;
	name?: string | null;
	carBrand?: string | null;
	carModel?: string | null;
	carLicensePlate?: string | null;
	location?: string | null;
	locationMunicipality?: string | null;
	locationZipCode?: string | null;
	propertyType?: string | null;
};

export type ClientPortfolioDetailRelatedResponseDTO = {
	id: number;
	note?: string | null;
	relatedPortfolio?: ClientPortfolioDetailRelatedPortfolioResponseDTO | null;
	relatedProperty?: ClientPortfolioDetailRelatedPropertyResponseDTO | null;
	canUnpin: boolean;
};

export type ClientPortfolioDetailResponseDTO = {
	id: number;
	myPlannSharedId?: number | null;
	contractNumber?: string | null;
	data?: ClientPortfolioDetailDataResponseDTO | null;
	insuredPersons: ClientPortfolioDetailInsuredPersonResponseDTO[];
	related: ClientPortfolioDetailRelatedResponseDTO[];
	coDebtors: ClientPortfolioDetailCoDebtorResponseDTO[];
	dataChanges: ClientPortfolioDetailDataChangeResponseDTO[];
	tools?: ClientPortfolioDetailToolsResponseDTO | null;
	producerInstruments?: ClientPortfolioProducerInstrumentResponseDTO[] | null;
	type: string;
	valueType?: string | null;
	modeTool?: boolean | null;
	modeFillup?: boolean | null;
	producer?: string | null;
	domain?: ClientPortfolioDomainEnum | null;
	product?: string | null;
	productCategoryId?: number | null;
	productCategoryName?: string | null;
	name?: string | null;
	signedAt?: string | null;
	startAt?: string | null;
	endAt?: string | null;
	portfolioValueDate?: string | null;
	clientName?: string | null;
	maturityLengthMonths?: number | null;
	source?: string | null;
	currency: CurrencyEnum;
};

export type ClientPortfolioDetailToolsResponseDTO = {
	funds: ClientPortfolioDetailFundToolResponseDTO[];
	bonds: ClientPortfolioDetailBondToolResponseDTO[];
	commodities: ClientPortfolioDetailCommodityToolResponseDTO[];
	cryptocurrencies: ClientPortfolioDetailCryptocurrencyToolResponseDTO[];
	bankProducts: ClientPortfolioDetailBankProductToolResponseDTO[];
};

export type ClientPortfolioInvestmentEnterFeeResponseDTO = {
	id: number;
	amountType: ClientPortfolioInvestmentEnterFeeAmountTypeEnum;
	type: ClientPortfolioInvestmentEnterFeeTypeEnum;
	amount: number;
	chargedFeeFromFirstPayments?: number | null;
	applying?: ClientPortfolioInvestmentEnterFeeApplyingEnum | null;
};

export enum ClientPortfolioPaymentFrequencyEnum {
	None = "None",
	Single = "Single",
	Yearly = "Yearly",
	Semiannually = "Semiannually",
	Quarterly = "Quarterly",
	Monthly = "Monthly"
};

export type ClientPortfolioProducerInstrumentResponseDTO = {
	isin: string;
	name?: string | null;
	type?: ClientPortfolioToolTypeEnum | null;
	currentValue?: number | null;
	currency: CurrencyEnum;
};

export type ClientRelatedCandidateResponseDTO = {
	myplannId: number;
	name?: string | null;
	domain?: ClientPortfolioDomainEnum | null;
	product?: string | null;
	contractNumber?: string | null;
	type?: ClientPropertyTypeEnum | null;
	propertyType?: string | null;
	carBrand?: string | null;
	carModel?: string | null;
	carLicensePlate?: string | null;
	location?: string | null;
	locationMunicipality?: string | null;
	locationZipCode?: string | null;
};

export type ClientRelatedListResponseDTO = {
	data: ClientPortfolioDetailRelatedResponseDTO[];
};

export type ClientRelatedOptionsResponseDTO = {
	contracts?: ClientRelatedOptionsSectionResponseDTO | null;
	properties?: ClientRelatedOptionsSectionResponseDTO | null;
	services?: ClientRelatedOptionsSectionResponseDTO | null;
};

export type ClientRelatedOptionsSectionResponseDTO = {
	canOfferExisting: boolean;
	items: ClientRelatedCandidateResponseDTO[];
};

export type ClientPortfolioManualValueListResponseDTO = {
	data: ClientPortfolioManualValueResponseDTO[];
};

export type ClientPortfolioManualValueResponseDTO = {
	id: number;
	date: string;
	value: number;
	invested?: number | null;
};

export type ClientPropertyArtDetailResponseDTO = {
	id: number;
	title?: string | null;
	name?: string | null;
	customDisposition?: string | null;
	propertyType?: string | null;
	description?: string | null;
	purchaseDate?: string | null;
	value?: number | null;
	forInvestments?: boolean | null;
	related: ClientPortfolioDetailRelatedResponseDTO[];
	source?: string | null;
	propertyValueDate?: string | null;
	evaluationPercent?: number | null;
	type: ClientPropertyTypeEnum;
};

export type ClientPropertyCottageDetailResponseDTO = {
	id: number;
	title?: string | null;
	name?: string | null;
	location?: string | null;
	locationMunicipality?: string | null;
	locationDistrict?: string | null;
	locationZipCode?: string | null;
	usableArea?: number | null;
	floorArea?: number | null;
	disposition?: ClientPropertyBuildingDispositionEnum | null;
	customDisposition?: string | null;
	buildingMaterial?: ClientPropertyBuildingMaterialEnum | null;
	customBuildingMaterial?: string | null;
	numberOfFloors?: number | null;
	terrace: boolean;
	loggia: boolean;
	balcony: boolean;
	garage: boolean;
	cellar: boolean;
	elevator: boolean;
	barrierFree: boolean;
	swimmingPool: boolean;
	parkingSpace: boolean;
	furnished: boolean;
	purchaseDate?: string | null;
	description?: string | null;
	estimatedPriceAt?: string | null;
	estimatedPriceMin?: number | null;
	estimatedPriceMax?: number | null;
	estimatedPriceIsApproximate: boolean;
	interiorValue?: number | null;
	reproductionValue?: number | null;
	marketValue?: number | null;
	constructionType?: ClientConstructionTypeEnum | null;
	landSize?: number | null;
	secondaryBuildingArea?: number | null;
	ownership?: ClientPropertyOwnershipEnum | null;
	related: ClientPortfolioDetailRelatedResponseDTO[];
	propertyCategory?: ClientPropertyCategoryEnum | null;
	estimatedPriceHistoryList: ClientPropertyEstimatedPriceHistoryResponseDTO[];
	forInvestments?: boolean | null;
	myPlannSharedId?: number | null;
	source?: string | null;
	propertyValueDate?: string | null;
	evaluationPercent?: number | null;
	type: ClientPropertyTypeEnum;
};

export type ClientPropertyEstimatedPriceHistoryResponseDTO = {
	id: number;
	estimatedPriceMin: number;
	estimatedPriceMax: number;
	estimatedPriceAt: string;
};

export type ClientPropertyFlatDetailResponseDTO = {
	id: number;
	title?: string | null;
	name?: string | null;
	location?: string | null;
	locationMunicipality?: string | null;
	locationDistrict?: string | null;
	locationZipCode?: string | null;
	usableArea?: number | null;
	floorArea?: number | null;
	disposition?: ClientPropertyBuildingDispositionEnum | null;
	customDisposition?: string | null;
	terrace: boolean;
	loggia: boolean;
	balcony: boolean;
	garage: boolean;
	cellar: boolean;
	elevator: boolean;
	barrierFree: boolean;
	swimmingPool: boolean;
	parkingSpace: boolean;
	furnished: boolean;
	buildingMaterial?: ClientPropertyBuildingMaterialEnum | null;
	customBuildingMaterial?: string | null;
	apartmentNumber?: string | null;
	yearOfCompletion?: number | null;
	marketValue?: number | null;
	reproductionValue?: number | null;
	interiorValue?: number | null;
	estimatedPriceMin?: number | null;
	estimatedPriceMax?: number | null;
	estimatedPriceIsApproximate: boolean;
	estimatedPriceAt?: string | null;
	householdArea?: number | null;
	renovation?: ClientPropertyRenovationEnum | null;
	yearOfRenovation?: number | null;
	ownership?: ClientPropertyOwnershipEnum | null;
	purchaseDate?: string | null;
	description?: string | null;
	apartmentFloorFrom?: number | null;
	floorTo?: number | null;
	numberOfAboveGroundFloors?: number | null;
	related: ClientPortfolioDetailRelatedResponseDTO[];
	estimatedPriceHistoryList: ClientPropertyEstimatedPriceHistoryResponseDTO[];
	forInvestments?: boolean | null;
	myPlannSharedId?: number | null;
	source?: string | null;
	propertyValueDate?: string | null;
	evaluationPercent?: number | null;
	type: ClientPropertyTypeEnum;
};

export type ClientPropertyHouseDetailResponseDTO = {
	id: number;
	title?: string | null;
	name?: string | null;
	location?: string | null;
	locationMunicipality?: string | null;
	locationDistrict?: string | null;
	locationZipCode?: string | null;
	related: ClientPortfolioDetailRelatedResponseDTO[];
	usableArea?: number | null;
	floorArea?: number | null;
	disposition?: ClientPropertyBuildingDispositionEnum | null;
	customDisposition?: string | null;
	buildingMaterial?: ClientPropertyBuildingMaterialEnum | null;
	customBuildingMaterial?: string | null;
	numberOfFloors?: number | null;
	terrace: boolean;
	loggia: boolean;
	balcony: boolean;
	garage: boolean;
	cellar: boolean;
	elevator: boolean;
	barrierFree: boolean;
	swimmingPool: boolean;
	parkingSpace: boolean;
	furnished: boolean;
	purchaseDate?: string | null;
	description?: string | null;
	propertyCategory?: ClientPropertyCategoryEnum | null;
	yearOfCompletion?: number | null;
	landSize?: number | null;
	ownership?: ClientPropertyOwnershipEnum | null;
	renovation?: ClientPropertyRenovationEnum | null;
	yearOfRenovation?: number | null;
	marketValue?: number | null;
	reproductionValue?: number | null;
	interiorValue?: number | null;
	estimatedPriceAt?: string | null;
	estimatedPriceMin?: number | null;
	estimatedPriceMax?: number | null;
	estimatedPriceIsApproximate: boolean;
	estimatedPriceHistoryList: ClientPropertyEstimatedPriceHistoryResponseDTO[];
	forInvestments?: boolean | null;
	myPlannSharedId?: number | null;
	source?: string | null;
	propertyValueDate?: string | null;
	evaluationPercent?: number | null;
	type: ClientPropertyTypeEnum;
};

export type ClientPropertyItemResponseDTO = {
	id: number;
	name?: string | null;
	icon?: string | null;
	iconText?: string | null;
	property?: ClientPropertyTypeEnum | null;
	propertyType?: string | null;
	link?: string | null;
	carBrand?: string | null;
	carModel?: string | null;
	carLicensePlate?: string | null;
	value?: string | null;
	marketValue?: string | null;
	location?: string | null;
	locationMunicipality?: string | null;
	locationDistrict?: string | null;
	locationZipCode?: string | null;
	forInvestments?: boolean | null;
	archived: boolean;
};

export type ClientPropertyLandDetailResponseDTO = {
	id: number;
	myPlannSharedId?: number | null;
	title?: string | null;
	name?: string | null;
	propertyCategory?: ClientPropertyCategoryEnum | null;
	ownership?: ClientPropertyOwnershipEnum | null;
	location?: string | null;
	locationMunicipality?: string | null;
	locationDistrict?: string | null;
	locationZipCode?: string | null;
	parcelNumber?: string | null;
	gps?: string | null;
	gpsLat?: string | null;
	gpsLon?: string | null;
	landSize?: number | null;
	landValue?: number | null;
	reproductionValue?: number | null;
	purchaseDate?: string | null;
	description?: string | null;
	forInvestments?: boolean | null;
	estimatedPriceAt?: string | null;
	estimatedPriceMin?: number | null;
	estimatedPriceMax?: number | null;
	estimatedPriceIsApproximate: boolean;
	estimatedPriceHistoryList: ClientPropertyEstimatedPriceHistoryResponseDTO[];
	related: ClientPortfolioDetailRelatedResponseDTO[];
	source?: string | null;
	propertyValueDate?: string | null;
	evaluationPercent?: number | null;
	type: ClientPropertyTypeEnum;
};

export type ClientPropertyVehicleDetailResponseDTO = {
	id: number;
	title?: string | null;
	name?: string | null;
	carBrand?: string | null;
	carModel?: string | null;
	propertyType?: ClientPropertyVehicleTypeEnum | null;
	carVehicleType?: ClientPropertyCarVehicleTypeEnum | null;
	carBodyType?: ClientCarBodyTypeEnum | null;
	carVin?: string | null;
	carLicensePlate?: string | null;
	carPurchaseDate?: string | null;
	carRegistration?: string | null;
	carManufactureMonthYear?: string | null;
	carPutIntoService?: string | null;
	description?: string | null;
	carWeight?: number | null;
	value?: number | null;
	carSeatCount?: number | null;
	carVolume?: number | null;
	carPower?: number | null;
	carFuel?: ClientCarFuelEnum | null;
	carMechanicalSecurity?: boolean | null;
	carAlarmSecurity?: boolean | null;
	carPassiveTrackingSecurity?: boolean | null;
	carImmobilizerSecurity?: boolean | null;
	carActiveTrackingSecurity?: boolean | null;
	carGlassEtchingSecurity?: boolean | null;
	carSpecialEquipment44?: boolean | null;
	carSpecialEquipmentAudiovisualSystem?: boolean | null;
	carSpecialEquipmentLeatherUpholstery?: boolean | null;
	carSpecialEquipmentPanoramicRoof?: boolean | null;
	carSpecialEquipmentParkingAssistant?: boolean | null;
	forInvestments?: boolean | null;
	related: ClientPortfolioDetailRelatedResponseDTO[];
	createdAt: string;
	source?: string | null;
	propertyValueDate?: string | null;
	evaluationPercent?: number | null;
	type: ClientPropertyTypeEnum;
};

export type ClientPortfolioListItemReportingSummaryResponseDTO = {
	id: number;
	myPlannSharedId?: number | null;
	calculatedAt: string;
	summary?: ClientPortfolioReportingSummaryResponseDTO | null;
};

export type ClientPortfolioReportingOverviewItemResponseDTO = {
	type: PortfolioReportingOverviewTypeEnum;
	value?: number | null;
	nettoValue?: number | null;
	initialValue?: number | null;
	evaluation?: number | null;
	currency?: CurrencyEnum | null;
	canCalculateRating: boolean;
	itemCount: number;
	itemCountWithoutValue: number;
};

export type ClientPortfolioReportingSummaryResponseDTO = {
	totalValue: number;
	totalInvestedValue?: number | null;
	totalEvaluationValue?: number | null;
	totalEvaluationPercent?: number | null;
	currency: CurrencyEnum;
};

export type ClientPortfolioToolReportingSummaryResponseDTO = {
	toolId: number;
	name: string;
	totalValue: number;
	totalInvestedValue: number;
	totalEvaluationValue: number;
	totalEvaluationPercent: number;
	totalCount: number;
	currency: CurrencyEnum;
};

export enum FuturePortfolioStateEnum {
	New = "New",
	Completed = "Completed"
};

export enum FuturePortfolioTypeEnum {
	Investment = "Investment",
	Mortgage = "Mortgage",
	Loan = "Loan"
};

export enum GoalCategoryTypeEnum {
	Basic = "Basic",
	Car = "Car",
	Student = "Student",
	Pension = "Pension",
	House = "House",
	Vacation = "Vacation",
	Rent = "Rent"
};

export enum GoalCoveredStateEnum {
	OnTrack = "OnTrack",
	Warning = "Warning",
	OffTrack = "OffTrack",
	Unplanned = "Unplanned"
};

export enum GoalFundingTypeEnum {
	Investment = "Investment",
	Payout = "Payout",
	Buy = "Buy",
	Sell = "Sell",
	Contract = "Contract"
};

export enum GoalPortfolioTypeEnum {
	SetAside = "SetAside",
	Allocated = "Allocated"
};

export enum GoalSourceEnum {
	Mydock = "Mydock",
	Myplann = "Myplann",
	Nsure = "Nsure"
};

export enum TaskArchivationStatusEnum {
	Archived = "Archived",
	NotArchived = "NotArchived"
};

export enum TaskUserSharingTypeEnum {
	TaskOwner = "TaskOwner",
	DirectShare = "DirectShare",
	InheritedShare = "InheritedShare"
};

export type EntityListOfTaskWorkflowResponse = {
	offset: number;
	limit: number;
	totalCount: number;
	items: GetTaskWorkflowResponse[];
};

export type GetTaskClientsListItemResponse = {
	taskPublicID: string;
	taskClientID: number;
	clientID: string;
};

export type GetTaskResponse = {
	taskID: number;
	taskPublicID: string;
	name: string;
	description?: string | null;
	statusId?: number | null;
	statusName?: string | null;
	statusColor?: string | null;
	taskGroupID?: number | null;
	taskGroupName?: string | null;
	taskGroupPublicID?: string | null;
	taskGroupUserID?: number | null;
	assignedToUserFullName?: string | null;
	assignedToUserExternalID?: string | null;
	assignedToUserID?: number | null;
	dueDate?: string | null;
	isFavorite: boolean;
	archivationStatus: TaskArchivationStatusEnum;
	firstClientName?: string | null;
	isCompleted: boolean;
	isSharedWithMe: boolean;
	canArchive: boolean;
	canRestore: boolean;
	canUpdateComplete: boolean;
	canChangeTaskGroup: boolean;
	unreadCommentCount: number;
	isWatchedByCurrentUser: boolean;
	clients: GetTaskClientsListItemResponse[];
	users: GetTaskUsersListItemResponse[];
};

export type GetTaskUsersListItemResponse = {
	taskPublicID: string;
	taskUserID: number;
	userFullName: string;
	userFirstName: string;
	userLastName: string;
	userCompanyName: string;
	userExternalID: string;
	sharingType: TaskUserSharingTypeEnum;
};

export type GetTaskWorkflowResponse = {
	taskPublicID: string;
	taskWorkflowID: number;
	rank: number;
	name: string;
	steps: GetTaskWorkflowStepResponse[];
};

export type GetTaskWorkflowStepResponse = {
	taskWorkflowStepID: number;
	taskWorkflowID: number;
	name: number;
	isCompleted: boolean;
	rank: number;
	assignedToUserFullName?: string | null;
	assignedToUserExternalID?: string | null;
	assignedToUserID?: number | null;
	dueDate?: string | null;
	completedDate?: string | null;
	completedByUserFullName?: string | null;
	completedByUserExternalID?: string | null;
};

export type GetActivityIdV2FetchResponse = 
| FetchResponse<ActivityDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getActivityIdV2Path = (id: number) => `/v2/activity/${id}`;

export const getActivityIdV2 = (id: number, filterTerm?: string, filterDatefrom?: string, filterDateto?: string, filterOnlyunsolved?: boolean, filterOnlysolved?: boolean, filterAlltypes?: boolean, filterTypegroups?: ClientEventTypeGroupEnum[], limit?: number, offset?: number, options?: FetchArgsOptions):
  Promise<GetActivityIdV2FetchResponse> => {
    const queryParams = {
      "filter[term]": filterTerm,
      "filter[dateFrom]": filterDatefrom,
      "filter[dateTo]": filterDateto,
      "filter[onlyUnsolved]": filterOnlyunsolved,
      "filter[onlySolved]": filterOnlysolved,
      "filter[allTypes]": filterAlltypes,
      "filter[typeGroups][]": filterTypegroups,
      "limit": limit,
      "offset": offset
    }
    return apiGet(`${getApiUrl()}${getActivityIdV2Path(id)}`, options, queryParams) as Promise<GetActivityIdV2FetchResponse>;
}

export type GetActivityIdAgentsV2FetchResponse = 
| FetchResponse<{data: ClientActivityAgentItemResponseDTO[];}, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getActivityIdAgentsV2Path = (id: number) => `/v2/activity/${id}/agents`;

export const getActivityIdAgentsV2 = (id: number, options?: FetchArgsOptions):
  Promise<GetActivityIdAgentsV2FetchResponse> => {
    return apiGet(`${getApiUrl()}${getActivityIdAgentsV2Path(id)}`, options, {}) as Promise<GetActivityIdAgentsV2FetchResponse>;
}

export type GetActivityIdNotesV2FetchResponse = 
| FetchResponse<{data: ClientActivityNoteItemResponseDTO[];}, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getActivityIdNotesV2Path = (id: number) => `/v2/activity/${id}/notes`;

export const getActivityIdNotesV2 = (id: number, options?: FetchArgsOptions):
  Promise<GetActivityIdNotesV2FetchResponse> => {
    return apiGet(`${getApiUrl()}${getActivityIdNotesV2Path(id)}`, options, {}) as Promise<GetActivityIdNotesV2FetchResponse>;
}

export type GetActivityIdParticipantsV2FetchResponse = 
| FetchResponse<{data: ClientActivityParticipantItemResponseDTO[];}, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getActivityIdParticipantsV2Path = (id: number) => `/v2/activity/${id}/participants`;

export const getActivityIdParticipantsV2 = (id: number, options?: FetchArgsOptions):
  Promise<GetActivityIdParticipantsV2FetchResponse> => {
    return apiGet(`${getApiUrl()}${getActivityIdParticipantsV2Path(id)}`, options, {}) as Promise<GetActivityIdParticipantsV2FetchResponse>;
}

export type GetActivityV2FetchResponse = 
| FetchResponse<{data: ActivityListItemResponseDTO[];
	meta: DefaultListMetaDTO;}, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getActivityV2Path = () => `/v2/activity`;

export const getActivityV2 = (filterDatefrom?: string, filterDateto?: string, filterOnlyunsolved?: boolean, filterOnlysolved?: boolean, limit?: number, offset?: number, filterSortdesc?: boolean, options?: FetchArgsOptions):
  Promise<GetActivityV2FetchResponse> => {
    const queryParams = {
      "filter[dateFrom]": filterDatefrom,
      "filter[dateTo]": filterDateto,
      "filter[onlyUnsolved]": filterOnlyunsolved,
      "filter[onlySolved]": filterOnlysolved,
      "limit": limit,
      "offset": offset,
      "filter[sortDesc]": filterSortdesc
    }
    return apiGet(`${getApiUrl()}${getActivityV2Path()}`, options, queryParams) as Promise<GetActivityV2FetchResponse>;
}

export type GetAgentAssignedV2FetchResponse = 
| FetchResponse<{data: AgentAssignedListItemResponseDTO[];
	meta: DefaultListMetaDTO;}, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getAgentAssignedV2Path = () => `/v2/agent/assigned`;

export const getAgentAssignedV2 = (filterStatus?: UserAgentStatusEnum, limit?: number, offset?: number, options?: FetchArgsOptions):
  Promise<GetAgentAssignedV2FetchResponse> => {
    const queryParams = {
      "filter[status]": filterStatus,
      "limit": limit,
      "offset": offset
    }
    return apiGet(`${getApiUrl()}${getAgentAssignedV2Path()}`, options, queryParams) as Promise<GetAgentAssignedV2FetchResponse>;
}

export type GetAgentIdV2FetchResponse = 
| FetchResponse<AgentDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getAgentIdV2Path = (id: number) => `/v2/agent/${id}`;

export const getAgentIdV2 = (id: number, options?: FetchArgsOptions):
  Promise<GetAgentIdV2FetchResponse> => {
    return apiGet(`${getApiUrl()}${getAgentIdV2Path(id)}`, options, {}) as Promise<GetAgentIdV2FetchResponse>;
}

export type GetAgentByUidUidV2FetchResponse = 
| FetchResponse<AgentDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getAgentByUidUidV2Path = (uid: string) => `/v2/agent/by-uid/${uid}`;

export const getAgentByUidUidV2 = (uid: string, options?: FetchArgsOptions):
  Promise<GetAgentByUidUidV2FetchResponse> => {
    return apiGet(`${getApiUrl()}${getAgentByUidUidV2Path(uid)}`, options, {}) as Promise<GetAgentByUidUidV2FetchResponse>;
}

export type GetAppV2FetchResponse = 
| FetchResponse<AppConfigResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getAppV2Path = () => `/v2/app`;

export const getAppV2 = (options?: FetchArgsOptions):
  Promise<GetAppV2FetchResponse> => {
    return apiGet(`${getApiUrl()}${getAppV2Path()}`, options, {}) as Promise<GetAppV2FetchResponse>;
}

export type GetCalculatorMortgageRatesV2FetchResponse = 
| FetchResponse<{data: MortgageRateResponseDTO[];}, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getCalculatorMortgageRatesV2Path = () => `/v2/calculator/mortgage-rates`;

export const getCalculatorMortgageRatesV2 = (options?: FetchArgsOptions):
  Promise<GetCalculatorMortgageRatesV2FetchResponse> => {
    return apiGet(`${getApiUrl()}${getCalculatorMortgageRatesV2Path()}`, options, {}) as Promise<GetCalculatorMortgageRatesV2FetchResponse>;
}

export type GetClientV2FetchResponse = 
| FetchResponse<ClientProfileResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getClientV2Path = () => `/v2/client`;

export const getClientV2 = (options?: FetchArgsOptions):
  Promise<GetClientV2FetchResponse> => {
    return apiGet(`${getApiUrl()}${getClientV2Path()}`, options, {}) as Promise<GetClientV2FetchResponse>;
}

export type GetClientFinancialPlanExpensesV2FetchResponse = 
| FetchResponse<{data: ClientExpenseListItemResponseDTO[];
	meta: DefaultListMetaDTO;}, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getClientFinancialPlanExpensesV2Path = () => `/v2/client/financial-plan/expenses`;

export const getClientFinancialPlanExpensesV2 = (options?: FetchArgsOptions):
  Promise<GetClientFinancialPlanExpensesV2FetchResponse> => {
    return apiGet(`${getApiUrl()}${getClientFinancialPlanExpensesV2Path()}`, options, {}) as Promise<GetClientFinancialPlanExpensesV2FetchResponse>;
}

export type PostClientFinancialPlanExpensesV2FetchResponse = 
| FetchResponse<ClientExpenseDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postClientFinancialPlanExpensesV2Path = () => `/v2/client/financial-plan/expenses`;

export const postClientFinancialPlanExpensesV2 = (requestContract: ClientFinancialPlanExpenseCreateRequestDTO, options?: FetchArgsOptions):
  Promise<PostClientFinancialPlanExpensesV2FetchResponse> => {
    const requestData = getApiRequestData<ClientFinancialPlanExpenseCreateRequestDTO>(requestContract, false);

    return apiPost(`${getApiUrl()}${postClientFinancialPlanExpensesV2Path()}`, requestData, options) as Promise<PostClientFinancialPlanExpensesV2FetchResponse>;
}

export type GetClientFinancialPlanIncomesV2FetchResponse = 
| FetchResponse<{data: ClientIncomeDetailResponseDTO[];}, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getClientFinancialPlanIncomesV2Path = () => `/v2/client/financial-plan/incomes`;

export const getClientFinancialPlanIncomesV2 = (options?: FetchArgsOptions):
  Promise<GetClientFinancialPlanIncomesV2FetchResponse> => {
    return apiGet(`${getApiUrl()}${getClientFinancialPlanIncomesV2Path()}`, options, {}) as Promise<GetClientFinancialPlanIncomesV2FetchResponse>;
}

export type PostClientFinancialPlanIncomesV2FetchResponse = 
| FetchResponse<ClientIncomeDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postClientFinancialPlanIncomesV2Path = () => `/v2/client/financial-plan/incomes`;

export const postClientFinancialPlanIncomesV2 = (requestContract: ClientFinancialPlanIncomeSaveRequestDTO, options?: FetchArgsOptions):
  Promise<PostClientFinancialPlanIncomesV2FetchResponse> => {
    const requestData = getApiRequestData<ClientFinancialPlanIncomeSaveRequestDTO>(requestContract, false);

    return apiPost(`${getApiUrl()}${postClientFinancialPlanIncomesV2Path()}`, requestData, options) as Promise<PostClientFinancialPlanIncomesV2FetchResponse>;
}

export type GetClientFinancialPlanExpensesIdV2FetchResponse = 
| FetchResponse<{data: ClientExpenseListItemResponseDTO[];
	meta: DefaultListMetaDTO;}, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getClientFinancialPlanExpensesIdV2Path = (id: number) => `/v2/client/financial-plan/expenses/${id}`;

export const getClientFinancialPlanExpensesIdV2 = (id: number, options?: FetchArgsOptions):
  Promise<GetClientFinancialPlanExpensesIdV2FetchResponse> => {
    return apiGet(`${getApiUrl()}${getClientFinancialPlanExpensesIdV2Path(id)}`, options, {}) as Promise<GetClientFinancialPlanExpensesIdV2FetchResponse>;
}

export type DeleteClientFinancialPlanExpensesIdV2FetchResponse = 
| FetchResponse<{data: ClientExpenseListItemResponseDTO[];
	meta: DefaultListMetaDTO;}, 200> 
| FetchResponse<void, 204> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const deleteClientFinancialPlanExpensesIdV2Path = (id: number) => `/v2/client/financial-plan/expenses/${id}`;

export const deleteClientFinancialPlanExpensesIdV2 = (id: number, options?: FetchArgsOptions):
  Promise<DeleteClientFinancialPlanExpensesIdV2FetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteClientFinancialPlanExpensesIdV2Path(id)}`, options, {}) as Promise<DeleteClientFinancialPlanExpensesIdV2FetchResponse>;
}

export type DeleteClientFinancialPlanIncomesIdV2FetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const deleteClientFinancialPlanIncomesIdV2Path = (id: number) => `/v2/client/financial-plan/incomes/${id}`;

export const deleteClientFinancialPlanIncomesIdV2 = (id: number, options?: FetchArgsOptions):
  Promise<DeleteClientFinancialPlanIncomesIdV2FetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteClientFinancialPlanIncomesIdV2Path(id)}`, options, {}) as Promise<DeleteClientFinancialPlanIncomesIdV2FetchResponse>;
}

export type PutClientFinancialPlanIncomesIdV2FetchResponse = 
| FetchResponse<ClientIncomeDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const putClientFinancialPlanIncomesIdV2Path = (id: number) => `/v2/client/financial-plan/incomes/${id}`;

export const putClientFinancialPlanIncomesIdV2 = (id: number, options?: FetchArgsOptions):
  Promise<PutClientFinancialPlanIncomesIdV2FetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPut(`${getApiUrl()}${putClientFinancialPlanIncomesIdV2Path(id)}`, requestData, options) as Promise<PutClientFinancialPlanIncomesIdV2FetchResponse>;
}

export type PatchClientFinancialPlanV2FetchResponse = 
| FetchResponse<FinancialPlanUpdateResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const patchClientFinancialPlanV2Path = () => `/v2/client/financial-plan`;

export const patchClientFinancialPlanV2 = (requestContract: FinancialPlanUpdateRequestDTO, options?: FetchArgsOptions):
  Promise<PatchClientFinancialPlanV2FetchResponse> => {
    const requestData = getApiRequestData<FinancialPlanUpdateRequestDTO>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchClientFinancialPlanV2Path()}`, requestData, options) as Promise<PatchClientFinancialPlanV2FetchResponse>;
}

export type PostImportClientActionRequestV2FetchResponse = 
| FetchResponse<CreateClientActionRequestResponse, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postImportClientActionRequestV2Path = () => `/v2/import/client-action-request`;

export const postImportClientActionRequestV2 = (requestContract: ImportClientActionRequest, options?: FetchArgsOptions):
  Promise<PostImportClientActionRequestV2FetchResponse> => {
    const requestData = getApiRequestData<ImportClientActionRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postImportClientActionRequestV2Path()}`, requestData, options) as Promise<PostImportClientActionRequestV2FetchResponse>;
}

export type PostClientActionRequestsIdSignV2FetchResponse = 
| FetchResponse<ClientActionRequest, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<void, 409> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postClientActionRequestsIdSignV2Path = (id: number) => `/v2/client-action-requests/${id}/sign`;

export const postClientActionRequestsIdSignV2 = (id: number, options?: FetchArgsOptions):
  Promise<PostClientActionRequestsIdSignV2FetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postClientActionRequestsIdSignV2Path(id)}`, requestData, options) as Promise<PostClientActionRequestsIdSignV2FetchResponse>;
}

export type GetClientEventV2FetchResponse = 
| FetchResponse<{data: ClientEventListResponseDTO[];
	meta: DefaultListMetaDTO;}, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getClientEventV2Path = () => `/v2/client/event`;

export const getClientEventV2 = (filterTerm?: string, filterDatefrom?: string, filterDateto?: string, filterOnlyunsolved?: boolean, filterOnlysolved?: boolean, filterAlltypes?: boolean, filterTypegroups?: ClientEventTypeGroupEnum[], limit?: number, offset?: number, options?: FetchArgsOptions):
  Promise<GetClientEventV2FetchResponse> => {
    const queryParams = {
      "filter[term]": filterTerm,
      "filter[dateFrom]": filterDatefrom,
      "filter[dateTo]": filterDateto,
      "filter[onlyUnsolved]": filterOnlyunsolved,
      "filter[onlySolved]": filterOnlysolved,
      "filter[allTypes]": filterAlltypes,
      "filter[typeGroups][]": filterTypegroups,
      "limit": limit,
      "offset": offset
    }
    return apiGet(`${getApiUrl()}${getClientEventV2Path()}`, options, queryParams) as Promise<GetClientEventV2FetchResponse>;
}

export type GetCryptocurrenciesV2FetchResponse = 
| FetchResponse<{data: CryptocurrencyResponseDTO[];}, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getCryptocurrenciesV2Path = () => `/v2/cryptocurrencies`;

export const getCryptocurrenciesV2 = (options?: FetchArgsOptions):
  Promise<GetCryptocurrenciesV2FetchResponse> => {
    return apiGet(`${getApiUrl()}${getCryptocurrenciesV2Path()}`, options, {}) as Promise<GetCryptocurrenciesV2FetchResponse>;
}

export type GetDashboardEventsV2FetchResponse = 
| FetchResponse<{data: (TaskListItemResponseDTO | ActivityListItemResponseDTO)[];
	meta: DefaultListMetaDTO;}, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getDashboardEventsV2Path = () => `/v2/dashboard/events`;

export const getDashboardEventsV2 = (filterDatefrom?: string, filterDateto?: string, filterOnlyunsolved?: boolean, filterOnlysolved?: boolean, limit?: number, offset?: number, filterSortdesc?: boolean, options?: FetchArgsOptions):
  Promise<GetDashboardEventsV2FetchResponse> => {
    const queryParams = {
      "filter[dateFrom]": filterDatefrom,
      "filter[dateTo]": filterDateto,
      "filter[onlyUnsolved]": filterOnlyunsolved,
      "filter[onlySolved]": filterOnlysolved,
      "limit": limit,
      "offset": offset,
      "filter[sortDesc]": filterSortdesc
    }
    return apiGet(`${getApiUrl()}${getDashboardEventsV2Path()}`, options, queryParams) as Promise<GetDashboardEventsV2FetchResponse>;
}

export type DeleteDocumentIdV2FetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const deleteDocumentIdV2Path = (id: number) => `/v2/document/${id}`;

export const deleteDocumentIdV2 = (id: number, options?: FetchArgsOptions):
  Promise<DeleteDocumentIdV2FetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteDocumentIdV2Path(id)}`, options, {}) as Promise<DeleteDocumentIdV2FetchResponse>;
}

export type PatchDocumentIdV2FetchResponse = 
| FetchResponse<DocumentDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const patchDocumentIdV2Path = (id: number) => `/v2/document/${id}`;

export const patchDocumentIdV2 = (requestContract: DocumentEditRequestDTO, id: number, options?: FetchArgsOptions):
  Promise<PatchDocumentIdV2FetchResponse> => {
    const requestData = getApiRequestData<DocumentEditRequestDTO>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchDocumentIdV2Path(id)}`, requestData, options) as Promise<PatchDocumentIdV2FetchResponse>;
}

export type GetDocumentIdContentV2FetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getDocumentIdContentV2Path = (id: number) => `/v2/document/${id}/content`;

export const getDocumentIdContentV2 = (id: number, options?: FetchArgsOptions):
  Promise<GetDocumentIdContentV2FetchResponse> => {
    return apiGet(`${getApiUrl()}${getDocumentIdContentV2Path(id)}`, options, {}) as Promise<GetDocumentIdContentV2FetchResponse>;
}

export type GetDocumentV2FetchResponse = 
| FetchResponse<DocumentListResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getDocumentV2Path = () => `/v2/document`;

export const getDocumentV2 = (tag?: string, options?: FetchArgsOptions):
  Promise<GetDocumentV2FetchResponse> => {
    const queryParams = {
      "tag": tag
    }
    return apiGet(`${getApiUrl()}${getDocumentV2Path()}`, options, queryParams) as Promise<GetDocumentV2FetchResponse>;
}

export type PostDocumentV2FetchResponse = 
| FetchResponse<DocumentDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postDocumentV2Path = () => `/v2/document`;

export const postDocumentV2 = (requestContract: DocumentUploadRequestDTO, options?: FetchArgsOptions):
  Promise<PostDocumentV2FetchResponse> => {
    const requestData = getApiRequestData<DocumentUploadRequestDTO>(requestContract, true);

    return apiPost(`${getApiUrl()}${postDocumentV2Path()}`, requestData, options) as Promise<PostDocumentV2FetchResponse>;
}

export type DeleteDocumentTagV2FetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const deleteDocumentTagV2Path = () => `/v2/document/tag`;

export const deleteDocumentTagV2 = (options?: FetchArgsOptions):
  Promise<DeleteDocumentTagV2FetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteDocumentTagV2Path()}`, options, {}) as Promise<DeleteDocumentTagV2FetchResponse>;
}

export type PatchDocumentTagV2FetchResponse = 
| FetchResponse<DocumentTagResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const patchDocumentTagV2Path = () => `/v2/document/tag`;

export const patchDocumentTagV2 = (requestContract: DocumentTagEditRequestDTO, options?: FetchArgsOptions):
  Promise<PatchDocumentTagV2FetchResponse> => {
    const requestData = getApiRequestData<DocumentTagEditRequestDTO>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchDocumentTagV2Path()}`, requestData, options) as Promise<PatchDocumentTagV2FetchResponse>;
}

export type PostFuturePortfoliosV2FetchResponse = 
| FetchResponse<GoalFuturePortfolioResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postFuturePortfoliosV2Path = () => `/v2/future-portfolios`;

export const postFuturePortfoliosV2 = (requestContract: FuturePortfolioCreateRequestDTO, options?: FetchArgsOptions):
  Promise<PostFuturePortfoliosV2FetchResponse> => {
    const requestData = getApiRequestData<FuturePortfolioCreateRequestDTO>(requestContract, false);

    return apiPost(`${getApiUrl()}${postFuturePortfoliosV2Path()}`, requestData, options) as Promise<PostFuturePortfoliosV2FetchResponse>;
}

export type DeleteFuturePortfoliosIdV2FetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const deleteFuturePortfoliosIdV2Path = (id: number) => `/v2/future-portfolios/${id}`;

export const deleteFuturePortfoliosIdV2 = (id: number, options?: FetchArgsOptions):
  Promise<DeleteFuturePortfoliosIdV2FetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteFuturePortfoliosIdV2Path(id)}`, options, {}) as Promise<DeleteFuturePortfoliosIdV2FetchResponse>;
}

export type PatchFuturePortfoliosIdV2FetchResponse = 
| FetchResponse<GoalFuturePortfolioResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const patchFuturePortfoliosIdV2Path = (id: number) => `/v2/future-portfolios/${id}`;

export const patchFuturePortfoliosIdV2 = (requestContract: FuturePortfolioPartialUpdateRequestDTO, id: number, options?: FetchArgsOptions):
  Promise<PatchFuturePortfoliosIdV2FetchResponse> => {
    const requestData = getApiRequestData<FuturePortfolioPartialUpdateRequestDTO>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchFuturePortfoliosIdV2Path(id)}`, requestData, options) as Promise<PatchFuturePortfoliosIdV2FetchResponse>;
}

export type GetGoalV2FetchResponse = 
| FetchResponse<{data: GoalListItemResponseDTO[];
	meta: DefaultListMetaDTO;}, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getGoalV2Path = () => `/v2/goal`;

export const getGoalV2 = (filterState?: GoalStateEnum[], limit?: number, offset?: number, options?: FetchArgsOptions):
  Promise<GetGoalV2FetchResponse> => {
    const queryParams = {
      "filter[state][]": filterState,
      "limit": limit,
      "offset": offset
    }
    return apiGet(`${getApiUrl()}${getGoalV2Path()}`, options, queryParams) as Promise<GetGoalV2FetchResponse>;
}

export type PostGoalV2FetchResponse = 
| FetchResponse<GoalDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postGoalV2Path = () => `/v2/goal`;

export const postGoalV2 = (requestContract: CreateGoalRequestDTO, options?: FetchArgsOptions):
  Promise<PostGoalV2FetchResponse> => {
    const requestData = getApiRequestData<CreateGoalRequestDTO>(requestContract, false);

    return apiPost(`${getApiUrl()}${postGoalV2Path()}`, requestData, options) as Promise<PostGoalV2FetchResponse>;
}

export type GetGoalIdV2FetchResponse = 
| FetchResponse<GoalDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getGoalIdV2Path = (id: number) => `/v2/goal/${id}`;

export const getGoalIdV2 = (id: number, options?: FetchArgsOptions):
  Promise<GetGoalIdV2FetchResponse> => {
    return apiGet(`${getApiUrl()}${getGoalIdV2Path(id)}`, options, {}) as Promise<GetGoalIdV2FetchResponse>;
}

export type DeleteGoalIdV2FetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const deleteGoalIdV2Path = (id: number) => `/v2/goal/${id}`;

export const deleteGoalIdV2 = (id: number, options?: FetchArgsOptions):
  Promise<DeleteGoalIdV2FetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteGoalIdV2Path(id)}`, options, {}) as Promise<DeleteGoalIdV2FetchResponse>;
}

export type PutGoalIdV2FetchResponse = 
| FetchResponse<GoalDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<void, 409> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const putGoalIdV2Path = (id: number) => `/v2/goal/${id}`;

export const putGoalIdV2 = (requestContract: UpdateGoalRequestDTO, id: number, options?: FetchArgsOptions):
  Promise<PutGoalIdV2FetchResponse> => {
    const requestData = getApiRequestData<UpdateGoalRequestDTO>(requestContract, false);

    return apiPut(`${getApiUrl()}${putGoalIdV2Path(id)}`, requestData, options) as Promise<PutGoalIdV2FetchResponse>;
}

export type DeleteGoalIdPortfoliosPortfolioIdV2FetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const deleteGoalIdPortfoliosPortfolioIdV2Path = (id: number, portfolioId: number) => `/v2/goal/${id}/portfolios/${portfolioId}`;

export const deleteGoalIdPortfoliosPortfolioIdV2 = (id: number, portfolioId: number, options?: FetchArgsOptions):
  Promise<DeleteGoalIdPortfoliosPortfolioIdV2FetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteGoalIdPortfoliosPortfolioIdV2Path(id, portfolioId)}`, options, {}) as Promise<DeleteGoalIdPortfoliosPortfolioIdV2FetchResponse>;
}

export type GetGoalPortfoliosV2FetchResponse = 
| FetchResponse<{data: GoalPortfolioListItemResponseDTO[];
	meta: DefaultListMetaDTO;}, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getGoalPortfoliosV2Path = () => `/v2/goal/portfolios`;

export const getGoalPortfoliosV2 = (options?: FetchArgsOptions):
  Promise<GetGoalPortfoliosV2FetchResponse> => {
    return apiGet(`${getApiUrl()}${getGoalPortfoliosV2Path()}`, options, {}) as Promise<GetGoalPortfoliosV2FetchResponse>;
}

export type PutGoalIdStateV2FetchResponse = 
| FetchResponse<GoalDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const putGoalIdStateV2Path = (id: number) => `/v2/goal/${id}/state`;

export const putGoalIdStateV2 = (requestContract: UpdateGoalStateRequestDTO, id: number, options?: FetchArgsOptions):
  Promise<PutGoalIdStateV2FetchResponse> => {
    const requestData = getApiRequestData<UpdateGoalStateRequestDTO>(requestContract, false);

    return apiPut(`${getApiUrl()}${putGoalIdStateV2Path(id)}`, requestData, options) as Promise<PutGoalIdStateV2FetchResponse>;
}

export type GetClientIdentificationDocumentsV2FetchResponse = 
| FetchResponse<{data: IdentificationDocumentListItemResponseDTO[];
	meta: DefaultListMetaDTO;}, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getClientIdentificationDocumentsV2Path = () => `/v2/client/identification-documents`;

export const getClientIdentificationDocumentsV2 = (filterState?: IdentificationDocumentStateEnum, limit?: number, offset?: number, options?: FetchArgsOptions):
  Promise<GetClientIdentificationDocumentsV2FetchResponse> => {
    const queryParams = {
      "filter[state]": filterState,
      "limit": limit,
      "offset": offset
    }
    return apiGet(`${getApiUrl()}${getClientIdentificationDocumentsV2Path()}`, options, queryParams) as Promise<GetClientIdentificationDocumentsV2FetchResponse>;
}

export type PostClientIdentificationDocumentsV2FetchResponse = 
| FetchResponse<IdentificationDocumentResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postClientIdentificationDocumentsV2Path = () => `/v2/client/identification-documents`;

export const postClientIdentificationDocumentsV2 = (requestContract: CreateIdentificationDocumentRequestDTO, options?: FetchArgsOptions):
  Promise<PostClientIdentificationDocumentsV2FetchResponse> => {
    const requestData = getApiRequestData<CreateIdentificationDocumentRequestDTO>(requestContract, false);

    return apiPost(`${getApiUrl()}${postClientIdentificationDocumentsV2Path()}`, requestData, options) as Promise<PostClientIdentificationDocumentsV2FetchResponse>;
}

export type GetClientIdentificationDocumentsIdV2FetchResponse = 
| FetchResponse<IdentificationDocumentDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getClientIdentificationDocumentsIdV2Path = (id: number) => `/v2/client/identification-documents/${id}`;

export const getClientIdentificationDocumentsIdV2 = (id: number, options?: FetchArgsOptions):
  Promise<GetClientIdentificationDocumentsIdV2FetchResponse> => {
    return apiGet(`${getApiUrl()}${getClientIdentificationDocumentsIdV2Path(id)}`, options, {}) as Promise<GetClientIdentificationDocumentsIdV2FetchResponse>;
}

export type DeleteClientIdentificationDocumentsIdV2FetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const deleteClientIdentificationDocumentsIdV2Path = (id: number) => `/v2/client/identification-documents/${id}`;

export const deleteClientIdentificationDocumentsIdV2 = (id: number, options?: FetchArgsOptions):
  Promise<DeleteClientIdentificationDocumentsIdV2FetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteClientIdentificationDocumentsIdV2Path(id)}`, options, {}) as Promise<DeleteClientIdentificationDocumentsIdV2FetchResponse>;
}

export type PutClientIdentificationDocumentsIdV2FetchResponse = 
| FetchResponse<IdentificationDocumentResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const putClientIdentificationDocumentsIdV2Path = (id: number) => `/v2/client/identification-documents/${id}`;

export const putClientIdentificationDocumentsIdV2 = (requestContract: UpdateIdentificationDocumentRequestDTO, id: number, options?: FetchArgsOptions):
  Promise<PutClientIdentificationDocumentsIdV2FetchResponse> => {
    const requestData = getApiRequestData<UpdateIdentificationDocumentRequestDTO>(requestContract, false);

    return apiPut(`${getApiUrl()}${putClientIdentificationDocumentsIdV2Path(id)}`, requestData, options) as Promise<PutClientIdentificationDocumentsIdV2FetchResponse>;
}

export type PostImportActivitySynchronizeV2FetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postImportActivitySynchronizeV2Path = () => `/v2/import/activity-synchronize`;

export const postImportActivitySynchronizeV2 = (requestContract: ImportActivitySynchronizeRequestDTO, options?: FetchArgsOptions):
  Promise<PostImportActivitySynchronizeV2FetchResponse> => {
    const requestData = getApiRequestData<ImportActivitySynchronizeRequestDTO>(requestContract, false);

    return apiPost(`${getApiUrl()}${postImportActivitySynchronizeV2Path()}`, requestData, options) as Promise<PostImportActivitySynchronizeV2FetchResponse>;
}

export type DeleteImportAgentConnectionsV2FetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const deleteImportAgentConnectionsV2Path = () => `/v2/import/agent/connections`;

export const deleteImportAgentConnectionsV2 = (options?: FetchArgsOptions):
  Promise<DeleteImportAgentConnectionsV2FetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteImportAgentConnectionsV2Path()}`, options, {}) as Promise<DeleteImportAgentConnectionsV2FetchResponse>;
}

export type DeleteImportCacheV2FetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const deleteImportCacheV2Path = () => `/v2/import/cache`;

export const deleteImportCacheV2 = (options?: FetchArgsOptions):
  Promise<DeleteImportCacheV2FetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteImportCacheV2Path()}`, options, {}) as Promise<DeleteImportCacheV2FetchResponse>;
}

export type PostImportGoalSynchronizeV2FetchResponse = 
| FetchResponse<ImportGoalSynchronizeResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postImportGoalSynchronizeV2Path = () => `/v2/import/goal-synchronize`;

export const postImportGoalSynchronizeV2 = (requestContract: ImportGoalSynchronizeRequestDTO, options?: FetchArgsOptions):
  Promise<PostImportGoalSynchronizeV2FetchResponse> => {
    const requestData = getApiRequestData<ImportGoalSynchronizeRequestDTO>(requestContract, false);

    return apiPost(`${getApiUrl()}${postImportGoalSynchronizeV2Path()}`, requestData, options) as Promise<PostImportGoalSynchronizeV2FetchResponse>;
}

export type PostImportIdentificationDocumentExpiryNotificationsV2FetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postImportIdentificationDocumentExpiryNotificationsV2Path = (dryRun?: boolean) => `/v2/import/identification-document-expiry-notifications`;

export const postImportIdentificationDocumentExpiryNotificationsV2 = (dryRun?: boolean, options?: FetchArgsOptions):
  Promise<PostImportIdentificationDocumentExpiryNotificationsV2FetchResponse> => {
    const queryParams = {
      "dryRun": dryRun
    };
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postImportIdentificationDocumentExpiryNotificationsV2Path()}`, requestData, options, queryParams) as Promise<PostImportIdentificationDocumentExpiryNotificationsV2FetchResponse>;
}

export type PostImportIdentificationDocumentsSyncRetryV2FetchResponse = 
| FetchResponse<IdentificationDocumentSyncRetryResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postImportIdentificationDocumentsSyncRetryV2Path = () => `/v2/import/identification-documents-sync-retry`;

export const postImportIdentificationDocumentsSyncRetryV2 = (options?: FetchArgsOptions):
  Promise<PostImportIdentificationDocumentsSyncRetryV2FetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postImportIdentificationDocumentsSyncRetryV2Path()}`, requestData, options) as Promise<PostImportIdentificationDocumentsSyncRetryV2FetchResponse>;
}

export type PostImportActivityNotificationV2FetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postImportActivityNotificationV2Path = () => `/v2/import/activity-notification`;

export const postImportActivityNotificationV2 = (requestContract: ImportActivitySendRequestDTO, options?: FetchArgsOptions):
  Promise<PostImportActivityNotificationV2FetchResponse> => {
    const requestData = getApiRequestData<ImportActivitySendRequestDTO>(requestContract, false);

    return apiPost(`${getApiUrl()}${postImportActivityNotificationV2Path()}`, requestData, options) as Promise<PostImportActivityNotificationV2FetchResponse>;
}

export type PostImportActivityTermNoticeV2FetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postImportActivityTermNoticeV2Path = () => `/v2/import/activity-term-notice`;

export const postImportActivityTermNoticeV2 = (options?: FetchArgsOptions):
  Promise<PostImportActivityTermNoticeV2FetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postImportActivityTermNoticeV2Path()}`, requestData, options) as Promise<PostImportActivityTermNoticeV2FetchResponse>;
}

export type PostImportInvestmentQuestionnaireNotificationV2FetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postImportInvestmentQuestionnaireNotificationV2Path = () => `/v2/import/investment-questionnaire-notification`;

export const postImportInvestmentQuestionnaireNotificationV2 = (requestContract: ImportInvestmentQuestionnaireNotificationRequestDTO, options?: FetchArgsOptions):
  Promise<PostImportInvestmentQuestionnaireNotificationV2FetchResponse> => {
    const requestData = getApiRequestData<ImportInvestmentQuestionnaireNotificationRequestDTO>(requestContract, false);

    return apiPost(`${getApiUrl()}${postImportInvestmentQuestionnaireNotificationV2Path()}`, requestData, options) as Promise<PostImportInvestmentQuestionnaireNotificationV2FetchResponse>;
}

export type PostImportPortfolioNotificationsV2FetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postImportPortfolioNotificationsV2Path = (dryRun?: boolean, portfolioId?: number | undefined | null) => `/v2/import/portfolio-notifications`;

export const postImportPortfolioNotificationsV2 = (dryRun?: boolean, portfolioId?: number | undefined | null, options?: FetchArgsOptions):
  Promise<PostImportPortfolioNotificationsV2FetchResponse> => {
    const queryParams = {
      "dryRun": dryRun,
      "portfolioId": portfolioId
    };
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postImportPortfolioNotificationsV2Path()}`, requestData, options, queryParams) as Promise<PostImportPortfolioNotificationsV2FetchResponse>;
}

export type PostImportSendPushSummaryV2FetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postImportSendPushSummaryV2Path = () => `/v2/import/send-push-summary`;

export const postImportSendPushSummaryV2 = (requestContract: NotificationSendPushSummaryRequestDTO, options?: FetchArgsOptions):
  Promise<PostImportSendPushSummaryV2FetchResponse> => {
    const requestData = getApiRequestData<NotificationSendPushSummaryRequestDTO>(requestContract, false);

    return apiPost(`${getApiUrl()}${postImportSendPushSummaryV2Path()}`, requestData, options) as Promise<PostImportSendPushSummaryV2FetchResponse>;
}

export type PostImportTaskNotificationV2FetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postImportTaskNotificationV2Path = () => `/v2/import/task-notification`;

export const postImportTaskNotificationV2 = (requestContract: ImportTaskSendRequestDTO, options?: FetchArgsOptions):
  Promise<PostImportTaskNotificationV2FetchResponse> => {
    const requestData = getApiRequestData<ImportTaskSendRequestDTO>(requestContract, false);

    return apiPost(`${getApiUrl()}${postImportTaskNotificationV2Path()}`, requestData, options) as Promise<PostImportTaskNotificationV2FetchResponse>;
}

export type PostImportPortfolioReportingEventV2FetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postImportPortfolioReportingEventV2Path = () => `/v2/import/portfolio-reporting-event`;

export const postImportPortfolioReportingEventV2 = (requestContract: ImportPortfolioReportingEventRequestDTO, options?: FetchArgsOptions):
  Promise<PostImportPortfolioReportingEventV2FetchResponse> => {
    const requestData = getApiRequestData<ImportPortfolioReportingEventRequestDTO>(requestContract, false);

    return apiPost(`${getApiUrl()}${postImportPortfolioReportingEventV2Path()}`, requestData, options) as Promise<PostImportPortfolioReportingEventV2FetchResponse>;
}

export type PostImportSendReminderPushesV2FetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postImportSendReminderPushesV2Path = () => `/v2/import/send-reminder-pushes`;

export const postImportSendReminderPushesV2 = (options?: FetchArgsOptions):
  Promise<PostImportSendReminderPushesV2FetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postImportSendReminderPushesV2Path()}`, requestData, options) as Promise<PostImportSendReminderPushesV2FetchResponse>;
}

export type PostImportRemindersSyncRetryV2FetchResponse = 
| FetchResponse<ReminderSyncRetryResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postImportRemindersSyncRetryV2Path = () => `/v2/import/reminders-sync-retry`;

export const postImportRemindersSyncRetryV2 = (options?: FetchArgsOptions):
  Promise<PostImportRemindersSyncRetryV2FetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postImportRemindersSyncRetryV2Path()}`, requestData, options) as Promise<PostImportRemindersSyncRetryV2FetchResponse>;
}

export type PostImportTaskSynchronizeV2FetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postImportTaskSynchronizeV2Path = () => `/v2/import/task-synchronize`;

export const postImportTaskSynchronizeV2 = (requestContract: ImportTaskSynchronizeRequestDTO, options?: FetchArgsOptions):
  Promise<PostImportTaskSynchronizeV2FetchResponse> => {
    const requestData = getApiRequestData<ImportTaskSynchronizeRequestDTO>(requestContract, false);

    return apiPost(`${getApiUrl()}${postImportTaskSynchronizeV2Path()}`, requestData, options) as Promise<PostImportTaskSynchronizeV2FetchResponse>;
}

export type PostImportAgentReadonlyTokenV2FetchResponse = 
| FetchResponse<GenerateAgentReadOnlyTokenResponse, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postImportAgentReadonlyTokenV2Path = () => `/v2/import/agent-readonly-token`;

export const postImportAgentReadonlyTokenV2 = (requestContract: GenerateAgentReadOnlyTokenRequest, options?: FetchArgsOptions):
  Promise<PostImportAgentReadonlyTokenV2FetchResponse> => {
    const requestData = getApiRequestData<GenerateAgentReadOnlyTokenRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postImportAgentReadonlyTokenV2Path()}`, requestData, options) as Promise<PostImportAgentReadonlyTokenV2FetchResponse>;
}

export type DeleteInsuranceClaimIdAttachmentAttachmentIdV2FetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const deleteInsuranceClaimIdAttachmentAttachmentIdV2Path = (id: number, attachmentId: number) => `/v2/insurance-claim/${id}/attachment/${attachmentId}`;

export const deleteInsuranceClaimIdAttachmentAttachmentIdV2 = (id: number, attachmentId: number, options?: FetchArgsOptions):
  Promise<DeleteInsuranceClaimIdAttachmentAttachmentIdV2FetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteInsuranceClaimIdAttachmentAttachmentIdV2Path(id, attachmentId)}`, options, {}) as Promise<DeleteInsuranceClaimIdAttachmentAttachmentIdV2FetchResponse>;
}

export type GetInsuranceClaimIdAttachmentAttachmentIdContentV2FetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getInsuranceClaimIdAttachmentAttachmentIdContentV2Path = (id: number, attachmentId: number) => `/v2/insurance-claim/${id}/attachment/${attachmentId}/content`;

export const getInsuranceClaimIdAttachmentAttachmentIdContentV2 = (id: number, attachmentId: number, options?: FetchArgsOptions):
  Promise<GetInsuranceClaimIdAttachmentAttachmentIdContentV2FetchResponse> => {
    return apiGet(`${getApiUrl()}${getInsuranceClaimIdAttachmentAttachmentIdContentV2Path(id, attachmentId)}`, options, {}) as Promise<GetInsuranceClaimIdAttachmentAttachmentIdContentV2FetchResponse>;
}

export type PostInsuranceClaimIdAttachmentV2FetchResponse = 
| FetchResponse<InsuranceClaimAttachmentResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postInsuranceClaimIdAttachmentV2Path = (id: number) => `/v2/insurance-claim/${id}/attachment`;

export const postInsuranceClaimIdAttachmentV2 = (requestContract: InsuranceClaimAttachmentUploadRequestDTO, id: number, options?: FetchArgsOptions):
  Promise<PostInsuranceClaimIdAttachmentV2FetchResponse> => {
    const requestData = getApiRequestData<InsuranceClaimAttachmentUploadRequestDTO>(requestContract, true);

    return apiPost(`${getApiUrl()}${postInsuranceClaimIdAttachmentV2Path(id)}`, requestData, options) as Promise<PostInsuranceClaimIdAttachmentV2FetchResponse>;
}

export type GetInsuranceClaimV2FetchResponse = 
| FetchResponse<{data: InsuranceClaimListItemResponseDTO[];
	meta: DefaultListMetaDTO;}, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getInsuranceClaimV2Path = () => `/v2/insurance-claim`;

export const getInsuranceClaimV2 = (filterState?: InsuranceClaimStateEnum[], filterType?: InsuranceClaimTypeEnum[], filterPortfolioid?: number, filterPropertyid?: number, limit?: number, offset?: number, options?: FetchArgsOptions):
  Promise<GetInsuranceClaimV2FetchResponse> => {
    const queryParams = {
      "filter[state][]": filterState,
      "filter[type][]": filterType,
      "filter[portfolioId]": filterPortfolioid,
      "filter[propertyId]": filterPropertyid,
      "limit": limit,
      "offset": offset
    }
    return apiGet(`${getApiUrl()}${getInsuranceClaimV2Path()}`, options, queryParams) as Promise<GetInsuranceClaimV2FetchResponse>;
}

export type PostInsuranceClaimV2FetchResponse = 
| FetchResponse<InsuranceClaimDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postInsuranceClaimV2Path = () => `/v2/insurance-claim`;

export const postInsuranceClaimV2 = (requestContract: CreateInsuranceClaimRequestDTO, options?: FetchArgsOptions):
  Promise<PostInsuranceClaimV2FetchResponse> => {
    const requestData = getApiRequestData<CreateInsuranceClaimRequestDTO>(requestContract, true);

    return apiPost(`${getApiUrl()}${postInsuranceClaimV2Path()}`, requestData, options) as Promise<PostInsuranceClaimV2FetchResponse>;
}

export type GetInsuranceClaimIdV2FetchResponse = 
| FetchResponse<InsuranceClaimDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getInsuranceClaimIdV2Path = (id: number) => `/v2/insurance-claim/${id}`;

export const getInsuranceClaimIdV2 = (id: number, options?: FetchArgsOptions):
  Promise<GetInsuranceClaimIdV2FetchResponse> => {
    return apiGet(`${getApiUrl()}${getInsuranceClaimIdV2Path(id)}`, options, {}) as Promise<GetInsuranceClaimIdV2FetchResponse>;
}

export type DeleteInsuranceClaimIdV2FetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const deleteInsuranceClaimIdV2Path = (id: number) => `/v2/insurance-claim/${id}`;

export const deleteInsuranceClaimIdV2 = (id: number, options?: FetchArgsOptions):
  Promise<DeleteInsuranceClaimIdV2FetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteInsuranceClaimIdV2Path(id)}`, options, {}) as Promise<DeleteInsuranceClaimIdV2FetchResponse>;
}

export type PutInsuranceClaimIdV2FetchResponse = 
| FetchResponse<InsuranceClaimDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const putInsuranceClaimIdV2Path = (id: number) => `/v2/insurance-claim/${id}`;

export const putInsuranceClaimIdV2 = (requestContract: UpdateInsuranceClaimRequestDTO, id: number, options?: FetchArgsOptions):
  Promise<PutInsuranceClaimIdV2FetchResponse> => {
    const requestData = getApiRequestData<UpdateInsuranceClaimRequestDTO>(requestContract, false);

    return apiPut(`${getApiUrl()}${putInsuranceClaimIdV2Path(id)}`, requestData, options) as Promise<PutInsuranceClaimIdV2FetchResponse>;
}

export type PostLeadFinancialBalanceV2FetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postLeadFinancialBalanceV2Path = () => `/v2/lead/financial-balance`;

export const postLeadFinancialBalanceV2 = (requestContract: FinancialBalanceLeadRequestDTO, options?: FetchArgsOptions):
  Promise<PostLeadFinancialBalanceV2FetchResponse> => {
    const requestData = getApiRequestData<FinancialBalanceLeadRequestDTO>(requestContract, false);

    return apiPost(`${getApiUrl()}${postLeadFinancialBalanceV2Path()}`, requestData, options) as Promise<PostLeadFinancialBalanceV2FetchResponse>;
}

export type GetNotificationsCountV2FetchResponse = 
| FetchResponse<NotificationCountResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getNotificationsCountV2Path = () => `/v2/notifications/count`;

export const getNotificationsCountV2 = (filterOnlyunread?: boolean, filterExcludetypes?: NotificationTypeEnum[], options?: FetchArgsOptions):
  Promise<GetNotificationsCountV2FetchResponse> => {
    const queryParams = {
      "filter[onlyUnread]": filterOnlyunread,
      "filter[excludeTypes][]": filterExcludetypes
    }
    return apiGet(`${getApiUrl()}${getNotificationsCountV2Path()}`, options, queryParams) as Promise<GetNotificationsCountV2FetchResponse>;
}

export type DeleteNotificationsIdV2FetchResponse = 
| FetchResponse<NotificationDeleteResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const deleteNotificationsIdV2Path = (id: number) => `/v2/notifications/${id}`;

export const deleteNotificationsIdV2 = (id: number, options?: FetchArgsOptions):
  Promise<DeleteNotificationsIdV2FetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteNotificationsIdV2Path(id)}`, options, {}) as Promise<DeleteNotificationsIdV2FetchResponse>;
}

export type DeleteNotificationsDeleteAllV2FetchResponse = 
| FetchResponse<NotificationDeleteResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const deleteNotificationsDeleteAllV2Path = () => `/v2/notifications/delete-all`;

export const deleteNotificationsDeleteAllV2 = (filterLastnotificationid?: number, options?: FetchArgsOptions):
  Promise<DeleteNotificationsDeleteAllV2FetchResponse> => {
    const queryParams = {
      "filter[lastNotificationId]": filterLastnotificationid
    }
    return apiDelete(`${getApiUrl()}${deleteNotificationsDeleteAllV2Path()}`, options, queryParams) as Promise<DeleteNotificationsDeleteAllV2FetchResponse>;
}

export type GetNotificationsV2FetchResponse = 
| FetchResponse<NotificationListResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getNotificationsV2Path = () => `/v2/notifications`;

export const getNotificationsV2 = (filterOnlyunread?: boolean, filterExcludetypes?: NotificationTypeEnum[], filterGroups?: NotificationGroupEnum[], filterDaygroupactive?: boolean, limit?: number, offset?: number, options?: FetchArgsOptions):
  Promise<GetNotificationsV2FetchResponse> => {
    const queryParams = {
      "filter[onlyUnread]": filterOnlyunread,
      "filter[excludeTypes][]": filterExcludetypes,
      "filter[groups][]": filterGroups,
      "filter[dayGroupActive]": filterDaygroupactive,
      "limit": limit,
      "offset": offset
    }
    return apiGet(`${getApiUrl()}${getNotificationsV2Path()}`, options, queryParams) as Promise<GetNotificationsV2FetchResponse>;
}

export type GetNotificationsGroupedV2FetchResponse = 
| FetchResponse<NotificationListResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getNotificationsGroupedV2Path = () => `/v2/notifications/grouped`;

export const getNotificationsGroupedV2 = (filterOnlyunread?: boolean, filterExcludetypes?: NotificationTypeEnum[], filterGroups?: NotificationGroupEnum[], filterDaygroupactive?: boolean, limit?: number, offset?: number, options?: FetchArgsOptions):
  Promise<GetNotificationsGroupedV2FetchResponse> => {
    const queryParams = {
      "filter[onlyUnread]": filterOnlyunread,
      "filter[excludeTypes][]": filterExcludetypes,
      "filter[groups][]": filterGroups,
      "filter[dayGroupActive]": filterDaygroupactive,
      "limit": limit,
      "offset": offset
    }
    return apiGet(`${getApiUrl()}${getNotificationsGroupedV2Path()}`, options, queryParams) as Promise<GetNotificationsGroupedV2FetchResponse>;
}

export type GetNotificationsGroupedCountV2FetchResponse = 
| FetchResponse<NotificationCountResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getNotificationsGroupedCountV2Path = () => `/v2/notifications/grouped/count`;

export const getNotificationsGroupedCountV2 = (filterOnlyunread?: boolean, filterExcludetypes?: NotificationTypeEnum[], filterGroups?: NotificationGroupEnum[], filterDaygroupactive?: boolean, limit?: number, offset?: number, options?: FetchArgsOptions):
  Promise<GetNotificationsGroupedCountV2FetchResponse> => {
    const queryParams = {
      "filter[onlyUnread]": filterOnlyunread,
      "filter[excludeTypes][]": filterExcludetypes,
      "filter[groups][]": filterGroups,
      "filter[dayGroupActive]": filterDaygroupactive,
      "limit": limit,
      "offset": offset
    }
    return apiGet(`${getApiUrl()}${getNotificationsGroupedCountV2Path()}`, options, queryParams) as Promise<GetNotificationsGroupedCountV2FetchResponse>;
}

export type PatchNotificationsReadAllV2FetchResponse = 
| FetchResponse<NotificationReadResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const patchNotificationsReadAllV2Path = (filterLastnotificationid?: number, filterExcludetypes?: NotificationTypeEnum[], filterGroups?: NotificationGroupEnum[]) => `/v2/notifications/read-all`;

export const patchNotificationsReadAllV2 = (filterLastnotificationid?: number, filterExcludetypes?: NotificationTypeEnum[], filterGroups?: NotificationGroupEnum[], options?: FetchArgsOptions):
  Promise<PatchNotificationsReadAllV2FetchResponse> => {
    const queryParams = {
      "filter[lastNotificationId]": filterLastnotificationid,
      "filter[excludeTypes][]": filterExcludetypes,
      "filter[groups][]": filterGroups
    };
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPatch(`${getApiUrl()}${patchNotificationsReadAllV2Path()}`, requestData, options, queryParams) as Promise<PatchNotificationsReadAllV2FetchResponse>;
}

export type PatchNotificationsIdReadV2FetchResponse = 
| FetchResponse<NotificationReadResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const patchNotificationsIdReadV2Path = (id: number) => `/v2/notifications/${id}/read`;

export const patchNotificationsIdReadV2 = (id: number, options?: FetchArgsOptions):
  Promise<PatchNotificationsIdReadV2FetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPatch(`${getApiUrl()}${patchNotificationsIdReadV2Path(id)}`, requestData, options) as Promise<PatchNotificationsIdReadV2FetchResponse>;
}

export type PatchNotificationsReadV2FetchResponse = 
| FetchResponse<NotificationReadResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const patchNotificationsReadV2Path = () => `/v2/notifications/read`;

export const patchNotificationsReadV2 = (requestContract: MarkNotificationsAsReadRequestDTO, options?: FetchArgsOptions):
  Promise<PatchNotificationsReadV2FetchResponse> => {
    const requestData = getApiRequestData<MarkNotificationsAsReadRequestDTO>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchNotificationsReadV2Path()}`, requestData, options) as Promise<PatchNotificationsReadV2FetchResponse>;
}

export type PostNotificationsPushTokensSyncV2FetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postNotificationsPushTokensSyncV2Path = () => `/v2/notifications/push-tokens/sync`;

export const postNotificationsPushTokensSyncV2 = (requestContract: NotificationPushTokenSyncRequestDTO, options?: FetchArgsOptions):
  Promise<PostNotificationsPushTokensSyncV2FetchResponse> => {
    const requestData = getApiRequestData<NotificationPushTokenSyncRequestDTO>(requestContract, false);

    return apiPost(`${getApiUrl()}${postNotificationsPushTokensSyncV2Path()}`, requestData, options) as Promise<PostNotificationsPushTokensSyncV2FetchResponse>;
}

export type GetNotificationCenterDashboardV2FetchResponse = 
| FetchResponse<DashboardResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getNotificationCenterDashboardV2Path = () => `/v2/notification-center/dashboard`;

export const getNotificationCenterDashboardV2 = (limit?: number, options?: FetchArgsOptions):
  Promise<GetNotificationCenterDashboardV2FetchResponse> => {
    const queryParams = {
      "limit": limit
    }
    return apiGet(`${getApiUrl()}${getNotificationCenterDashboardV2Path()}`, options, queryParams) as Promise<GetNotificationCenterDashboardV2FetchResponse>;
}

export type GetNotificationCenterPilotStatusV2FetchResponse = 
| FetchResponse<PilotStatusResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getNotificationCenterPilotStatusV2Path = () => `/v2/notification-center/pilot-status`;

export const getNotificationCenterPilotStatusV2 = (options?: FetchArgsOptions):
  Promise<GetNotificationCenterPilotStatusV2FetchResponse> => {
    return apiGet(`${getApiUrl()}${getNotificationCenterPilotStatusV2Path()}`, options, {}) as Promise<GetNotificationCenterPilotStatusV2FetchResponse>;
}

export type GetNotificationCenterRecentV2FetchResponse = 
| FetchResponse<TimelineResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getNotificationCenterRecentV2Path = () => `/v2/notification-center/recent`;

export const getNotificationCenterRecentV2 = (filterType?: RecentTimelineItemTypeFilterEnum, filterCategories?: TimelineItemCategoryEnum[], filterDatefrom?: string, filterDateto?: string, limit?: number, offset?: number, options?: FetchArgsOptions):
  Promise<GetNotificationCenterRecentV2FetchResponse> => {
    const queryParams = {
      "filter[type]": filterType,
      "filter[categories][]": filterCategories,
      "filter[dateFrom]": filterDatefrom,
      "filter[dateTo]": filterDateto,
      "limit": limit,
      "offset": offset
    }
    return apiGet(`${getApiUrl()}${getNotificationCenterRecentV2Path()}`, options, queryParams) as Promise<GetNotificationCenterRecentV2FetchResponse>;
}

export type GetNotificationCenterResolvingNowV2FetchResponse = 
| FetchResponse<TimelineResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getNotificationCenterResolvingNowV2Path = () => `/v2/notification-center/resolving-now`;

export const getNotificationCenterResolvingNowV2 = (filterType?: UpcomingTimelineItemTypeFilterEnum, filterCategories?: TimelineItemCategoryEnum[], limit?: number, offset?: number, options?: FetchArgsOptions):
  Promise<GetNotificationCenterResolvingNowV2FetchResponse> => {
    const queryParams = {
      "filter[type]": filterType,
      "filter[categories][]": filterCategories,
      "limit": limit,
      "offset": offset
    }
    return apiGet(`${getApiUrl()}${getNotificationCenterResolvingNowV2Path()}`, options, queryParams) as Promise<GetNotificationCenterResolvingNowV2FetchResponse>;
}

export type GetNotificationCenterSettingsV2FetchResponse = 
| FetchResponse<SettingsResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getNotificationCenterSettingsV2Path = () => `/v2/notification-center/settings`;

export const getNotificationCenterSettingsV2 = (options?: FetchArgsOptions):
  Promise<GetNotificationCenterSettingsV2FetchResponse> => {
    return apiGet(`${getApiUrl()}${getNotificationCenterSettingsV2Path()}`, options, {}) as Promise<GetNotificationCenterSettingsV2FetchResponse>;
}

export type PutNotificationCenterSettingsV2FetchResponse = 
| FetchResponse<SettingsResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const putNotificationCenterSettingsV2Path = () => `/v2/notification-center/settings`;

export const putNotificationCenterSettingsV2 = (requestContract: SettingsUpdateRequestDTO, options?: FetchArgsOptions):
  Promise<PutNotificationCenterSettingsV2FetchResponse> => {
    const requestData = getApiRequestData<SettingsUpdateRequestDTO>(requestContract, false);

    return apiPut(`${getApiUrl()}${putNotificationCenterSettingsV2Path()}`, requestData, options) as Promise<PutNotificationCenterSettingsV2FetchResponse>;
}

export type GetNotificationCenterUpcomingV2FetchResponse = 
| FetchResponse<TimelineResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getNotificationCenterUpcomingV2Path = () => `/v2/notification-center/upcoming`;

export const getNotificationCenterUpcomingV2 = (filterHorizon?: TimelineHorizonEnum, filterType?: UpcomingTimelineItemTypeFilterEnum, filterCategories?: TimelineItemCategoryEnum[], filterDatefrom?: string, filterDateto?: string, limit?: number, offset?: number, options?: FetchArgsOptions):
  Promise<GetNotificationCenterUpcomingV2FetchResponse> => {
    const queryParams = {
      "filter[horizon]": filterHorizon,
      "filter[type]": filterType,
      "filter[categories][]": filterCategories,
      "filter[dateFrom]": filterDatefrom,
      "filter[dateTo]": filterDateto,
      "limit": limit,
      "offset": offset
    }
    return apiGet(`${getApiUrl()}${getNotificationCenterUpcomingV2Path()}`, options, queryParams) as Promise<GetNotificationCenterUpcomingV2FetchResponse>;
}

export type PostNsureQuestionnaireAccessV2FetchResponse = 
| FetchResponse<NsureQuestionnaireAccessResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postNsureQuestionnaireAccessV2Path = () => `/v2/nsure/questionnaire-access`;

export const postNsureQuestionnaireAccessV2 = (requestContract: NsureQuestionnaireAccessRequestDTO, options?: FetchArgsOptions):
  Promise<PostNsureQuestionnaireAccessV2FetchResponse> => {
    const requestData = getApiRequestData<NsureQuestionnaireAccessRequestDTO>(requestContract, false);

    return apiPost(`${getApiUrl()}${postNsureQuestionnaireAccessV2Path()}`, requestData, options) as Promise<PostNsureQuestionnaireAccessV2FetchResponse>;
}

export type PostPortfolioIdLeadV2FetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<void, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postPortfolioIdLeadV2Path = (id: number) => `/v2/portfolio/${id}/lead`;

export const postPortfolioIdLeadV2 = (requestContract: AlertBoxLeadRequestDTO, id: number, options?: FetchArgsOptions):
  Promise<PostPortfolioIdLeadV2FetchResponse> => {
    const requestData = getApiRequestData<AlertBoxLeadRequestDTO>(requestContract, false);

    return apiPost(`${getApiUrl()}${postPortfolioIdLeadV2Path(id)}`, requestData, options) as Promise<PostPortfolioIdLeadV2FetchResponse>;
}

export type GetPortfolioIdAlertBoxesV2FetchResponse = 
| FetchResponse<PortfolioAlertBoxListResponseDTO, 200> 
| FetchResponse<void, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getPortfolioIdAlertBoxesV2Path = (id: number) => `/v2/portfolio/${id}/alert-boxes`;

export const getPortfolioIdAlertBoxesV2 = (id: number, filterBypassdismissal?: boolean, filterEventtype?: PortfolioEventTypeEnum, filterEventdate?: string, options?: FetchArgsOptions):
  Promise<GetPortfolioIdAlertBoxesV2FetchResponse> => {
    const queryParams = {
      "filter[bypassDismissal]": filterBypassdismissal,
      "filter[eventType]": filterEventtype,
      "filter[eventDate]": filterEventdate
    }
    return apiGet(`${getApiUrl()}${getPortfolioIdAlertBoxesV2Path(id)}`, options, queryParams) as Promise<GetPortfolioIdAlertBoxesV2FetchResponse>;
}

export type PostPortfolioIdAlertBoxesV2FetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<void, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postPortfolioIdAlertBoxesV2Path = (id: number) => `/v2/portfolio/${id}/alert-boxes`;

export const postPortfolioIdAlertBoxesV2 = (requestContract: UpdatePortfolioAlertBoxDismissalRequestDTO, id: number, options?: FetchArgsOptions):
  Promise<PostPortfolioIdAlertBoxesV2FetchResponse> => {
    const requestData = getApiRequestData<UpdatePortfolioAlertBoxDismissalRequestDTO>(requestContract, false);

    return apiPost(`${getApiUrl()}${postPortfolioIdAlertBoxesV2Path(id)}`, requestData, options) as Promise<PostPortfolioIdAlertBoxesV2FetchResponse>;
}

export type PostPortfolioIdAlertBoxesActionV2FetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<void, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postPortfolioIdAlertBoxesActionV2Path = (id: number) => `/v2/portfolio/${id}/alert-boxes/action`;

export const postPortfolioIdAlertBoxesActionV2 = (requestContract: RecordPortfolioAlertBoxActionRequestDTO, id: number, options?: FetchArgsOptions):
  Promise<PostPortfolioIdAlertBoxesActionV2FetchResponse> => {
    const requestData = getApiRequestData<RecordPortfolioAlertBoxActionRequestDTO>(requestContract, false);

    return apiPost(`${getApiUrl()}${postPortfolioIdAlertBoxesActionV2Path(id)}`, requestData, options) as Promise<PostPortfolioIdAlertBoxesActionV2FetchResponse>;
}

export type PostPortfolioBankProductsV2FetchResponse = 
| FetchResponse<PortfolioDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postPortfolioBankProductsV2Path = () => `/v2/portfolio/bank-products`;

export const postPortfolioBankProductsV2 = (requestContract: ClientPortfolioBankProductCreateRequestDTO, options?: FetchArgsOptions):
  Promise<PostPortfolioBankProductsV2FetchResponse> => {
    const requestData = getApiRequestData<ClientPortfolioBankProductCreateRequestDTO>(requestContract, false);

    return apiPost(`${getApiUrl()}${postPortfolioBankProductsV2Path()}`, requestData, options) as Promise<PostPortfolioBankProductsV2FetchResponse>;
}

export type PatchPortfolioBankProductsIdV2FetchResponse = 
| FetchResponse<PortfolioDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const patchPortfolioBankProductsIdV2Path = (id: number) => `/v2/portfolio/bank-products/${id}`;

export const patchPortfolioBankProductsIdV2 = (requestContract: ClientPortfolioBankProductEditRequestDTO, id: number, options?: FetchArgsOptions):
  Promise<PatchPortfolioBankProductsIdV2FetchResponse> => {
    const requestData = getApiRequestData<ClientPortfolioBankProductEditRequestDTO>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchPortfolioBankProductsIdV2Path(id)}`, requestData, options) as Promise<PatchPortfolioBankProductsIdV2FetchResponse>;
}

export type PostPortfolioBuildingSavingsV2FetchResponse = 
| FetchResponse<PortfolioDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postPortfolioBuildingSavingsV2Path = () => `/v2/portfolio/building-savings`;

export const postPortfolioBuildingSavingsV2 = (requestContract: ClientPortfolioBuildingSavingsCreateRequestDTO, options?: FetchArgsOptions):
  Promise<PostPortfolioBuildingSavingsV2FetchResponse> => {
    const requestData = getApiRequestData<ClientPortfolioBuildingSavingsCreateRequestDTO>(requestContract, false);

    return apiPost(`${getApiUrl()}${postPortfolioBuildingSavingsV2Path()}`, requestData, options) as Promise<PostPortfolioBuildingSavingsV2FetchResponse>;
}

export type PatchPortfolioBuildingSavingsIdV2FetchResponse = 
| FetchResponse<PortfolioDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const patchPortfolioBuildingSavingsIdV2Path = (id: number) => `/v2/portfolio/building-savings/${id}`;

export const patchPortfolioBuildingSavingsIdV2 = (requestContract: ClientPortfolioBuildingSavingsEditRequestDTO, id: number, options?: FetchArgsOptions):
  Promise<PatchPortfolioBuildingSavingsIdV2FetchResponse> => {
    const requestData = getApiRequestData<ClientPortfolioBuildingSavingsEditRequestDTO>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchPortfolioBuildingSavingsIdV2Path(id)}`, requestData, options) as Promise<PatchPortfolioBuildingSavingsIdV2FetchResponse>;
}

export type PostPortfolioBusinessLoansV2FetchResponse = 
| FetchResponse<PortfolioDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postPortfolioBusinessLoansV2Path = () => `/v2/portfolio/business-loans`;

export const postPortfolioBusinessLoansV2 = (requestContract: ClientPortfolioLoansCreateRequestDTO, options?: FetchArgsOptions):
  Promise<PostPortfolioBusinessLoansV2FetchResponse> => {
    const requestData = getApiRequestData<ClientPortfolioLoansCreateRequestDTO>(requestContract, false);

    return apiPost(`${getApiUrl()}${postPortfolioBusinessLoansV2Path()}`, requestData, options) as Promise<PostPortfolioBusinessLoansV2FetchResponse>;
}

export type PatchPortfolioBusinessLoansIdV2FetchResponse = 
| FetchResponse<PortfolioDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const patchPortfolioBusinessLoansIdV2Path = (id: number) => `/v2/portfolio/business-loans/${id}`;

export const patchPortfolioBusinessLoansIdV2 = (requestContract: ClientPortfolioLoansEditRequestDTO, id: number, options?: FetchArgsOptions):
  Promise<PatchPortfolioBusinessLoansIdV2FetchResponse> => {
    const requestData = getApiRequestData<ClientPortfolioLoansEditRequestDTO>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchPortfolioBusinessLoansIdV2Path(id)}`, requestData, options) as Promise<PatchPortfolioBusinessLoansIdV2FetchResponse>;
}

export type PostPortfolioCommoditiesV2FetchResponse = 
| FetchResponse<PortfolioDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postPortfolioCommoditiesV2Path = () => `/v2/portfolio/commodities`;

export const postPortfolioCommoditiesV2 = (requestContract: ClientPortfolioCommoditiesCreateRequestDTO, options?: FetchArgsOptions):
  Promise<PostPortfolioCommoditiesV2FetchResponse> => {
    const requestData = getApiRequestData<ClientPortfolioCommoditiesCreateRequestDTO>(requestContract, false);

    return apiPost(`${getApiUrl()}${postPortfolioCommoditiesV2Path()}`, requestData, options) as Promise<PostPortfolioCommoditiesV2FetchResponse>;
}

export type PatchPortfolioCommoditiesIdV2FetchResponse = 
| FetchResponse<PortfolioDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const patchPortfolioCommoditiesIdV2Path = (id: number) => `/v2/portfolio/commodities/${id}`;

export const patchPortfolioCommoditiesIdV2 = (requestContract: ClientPortfolioCommoditiesEditRequestDTO, id: number, options?: FetchArgsOptions):
  Promise<PatchPortfolioCommoditiesIdV2FetchResponse> => {
    const requestData = getApiRequestData<ClientPortfolioCommoditiesEditRequestDTO>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchPortfolioCommoditiesIdV2Path(id)}`, requestData, options) as Promise<PatchPortfolioCommoditiesIdV2FetchResponse>;
}

export type PostPortfolioCryptocurrenciesV2FetchResponse = 
| FetchResponse<PortfolioDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postPortfolioCryptocurrenciesV2Path = () => `/v2/portfolio/cryptocurrencies`;

export const postPortfolioCryptocurrenciesV2 = (requestContract: ClientPortfolioCryptocurrenciesCreateRequestDTO, options?: FetchArgsOptions):
  Promise<PostPortfolioCryptocurrenciesV2FetchResponse> => {
    const requestData = getApiRequestData<ClientPortfolioCryptocurrenciesCreateRequestDTO>(requestContract, false);

    return apiPost(`${getApiUrl()}${postPortfolioCryptocurrenciesV2Path()}`, requestData, options) as Promise<PostPortfolioCryptocurrenciesV2FetchResponse>;
}

export type PatchPortfolioCryptocurrenciesIdV2FetchResponse = 
| FetchResponse<PortfolioDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const patchPortfolioCryptocurrenciesIdV2Path = (id: number) => `/v2/portfolio/cryptocurrencies/${id}`;

export const patchPortfolioCryptocurrenciesIdV2 = (requestContract: ClientPortfolioCryptocurrenciesEditRequestDTO, id: number, options?: FetchArgsOptions):
  Promise<PatchPortfolioCryptocurrenciesIdV2FetchResponse> => {
    const requestData = getApiRequestData<ClientPortfolioCryptocurrenciesEditRequestDTO>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchPortfolioCryptocurrenciesIdV2Path(id)}`, requestData, options) as Promise<PatchPortfolioCryptocurrenciesIdV2FetchResponse>;
}

export type GetPortfolioIdV2FetchResponse = 
| FetchResponse<PortfolioDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getPortfolioIdV2Path = (id: number) => `/v2/portfolio/${id}`;

export const getPortfolioIdV2 = (id: number, options?: FetchArgsOptions):
  Promise<GetPortfolioIdV2FetchResponse> => {
    return apiGet(`${getApiUrl()}${getPortfolioIdV2Path(id)}`, options, {}) as Promise<GetPortfolioIdV2FetchResponse>;
}

export type DeletePortfolioIdV2FetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const deletePortfolioIdV2Path = (id: number) => `/v2/portfolio/${id}`;

export const deletePortfolioIdV2 = (id: number, options?: FetchArgsOptions):
  Promise<DeletePortfolioIdV2FetchResponse> => {
    return apiDelete(`${getApiUrl()}${deletePortfolioIdV2Path(id)}`, options, {}) as Promise<DeletePortfolioIdV2FetchResponse>;
}

export type GetPortfolioIdDocumentsV2FetchResponse = 
| FetchResponse<{data: PortfolioDocumentListItemDTO[];
	meta: DefaultListMetaDTO;}, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getPortfolioIdDocumentsV2Path = (id: number) => `/v2/portfolio/${id}/documents`;

export const getPortfolioIdDocumentsV2 = (id: number, options?: FetchArgsOptions):
  Promise<GetPortfolioIdDocumentsV2FetchResponse> => {
    return apiGet(`${getApiUrl()}${getPortfolioIdDocumentsV2Path(id)}`, options, {}) as Promise<GetPortfolioIdDocumentsV2FetchResponse>;
}

export type GetPortfolioIdInstrumentsInstrumentIdV2FetchResponse = 
| FetchResponse<ClientPortfolioDetailFundToolResponseDTO | ClientPortfolioDetailBondToolResponseDTO | ClientPortfolioDetailCommodityToolResponseDTO | ClientPortfolioDetailCryptocurrencyToolResponseDTO | ClientPortfolioDetailBankProductToolResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getPortfolioIdInstrumentsInstrumentIdV2Path = (id: number, instrumentId: number) => `/v2/portfolio/${id}/instruments/${instrumentId}`;

export const getPortfolioIdInstrumentsInstrumentIdV2 = (id: number, instrumentId: number, options?: FetchArgsOptions):
  Promise<GetPortfolioIdInstrumentsInstrumentIdV2FetchResponse> => {
    return apiGet(`${getApiUrl()}${getPortfolioIdInstrumentsInstrumentIdV2Path(id, instrumentId)}`, options, {}) as Promise<GetPortfolioIdInstrumentsInstrumentIdV2FetchResponse>;
}

export type PostPortfolioInvestmentV2FetchResponse = 
| FetchResponse<PortfolioDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postPortfolioInvestmentV2Path = () => `/v2/portfolio/investment`;

export const postPortfolioInvestmentV2 = (requestContract: ClientPortfolioInvestmentCreateRequestDTO, options?: FetchArgsOptions):
  Promise<PostPortfolioInvestmentV2FetchResponse> => {
    const requestData = getApiRequestData<ClientPortfolioInvestmentCreateRequestDTO>(requestContract, false);

    return apiPost(`${getApiUrl()}${postPortfolioInvestmentV2Path()}`, requestData, options) as Promise<PostPortfolioInvestmentV2FetchResponse>;
}

export type PatchPortfolioInvestmentIdV2FetchResponse = 
| FetchResponse<PortfolioDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const patchPortfolioInvestmentIdV2Path = (id: number) => `/v2/portfolio/investment/${id}`;

export const patchPortfolioInvestmentIdV2 = (requestContract: ClientPortfolioInvestmentEditRequestDTO, id: number, options?: FetchArgsOptions):
  Promise<PatchPortfolioInvestmentIdV2FetchResponse> => {
    const requestData = getApiRequestData<ClientPortfolioInvestmentEditRequestDTO>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchPortfolioInvestmentIdV2Path(id)}`, requestData, options) as Promise<PatchPortfolioInvestmentIdV2FetchResponse>;
}

export type PostPortfolioLeasingV2FetchResponse = 
| FetchResponse<PortfolioDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postPortfolioLeasingV2Path = () => `/v2/portfolio/leasing`;

export const postPortfolioLeasingV2 = (requestContract: ClientPortfolioLeasingCreateRequestDTO, options?: FetchArgsOptions):
  Promise<PostPortfolioLeasingV2FetchResponse> => {
    const requestData = getApiRequestData<ClientPortfolioLeasingCreateRequestDTO>(requestContract, false);

    return apiPost(`${getApiUrl()}${postPortfolioLeasingV2Path()}`, requestData, options) as Promise<PostPortfolioLeasingV2FetchResponse>;
}

export type PatchPortfolioLeasingIdV2FetchResponse = 
| FetchResponse<PortfolioDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const patchPortfolioLeasingIdV2Path = (id: number) => `/v2/portfolio/leasing/${id}`;

export const patchPortfolioLeasingIdV2 = (requestContract: ClientPortfolioLeasingEditRequestDTO, id: number, options?: FetchArgsOptions):
  Promise<PatchPortfolioLeasingIdV2FetchResponse> => {
    const requestData = getApiRequestData<ClientPortfolioLeasingEditRequestDTO>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchPortfolioLeasingIdV2Path(id)}`, requestData, options) as Promise<PatchPortfolioLeasingIdV2FetchResponse>;
}

export type PostPortfolioLifeInsuranceV2FetchResponse = 
| FetchResponse<ClientPortfolioDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postPortfolioLifeInsuranceV2Path = () => `/v2/portfolio/life-insurance`;

export const postPortfolioLifeInsuranceV2 = (requestContract: ClientPortfolioLifeInsuranceCreateRequestDTO, options?: FetchArgsOptions):
  Promise<PostPortfolioLifeInsuranceV2FetchResponse> => {
    const requestData = getApiRequestData<ClientPortfolioLifeInsuranceCreateRequestDTO>(requestContract, false);

    return apiPost(`${getApiUrl()}${postPortfolioLifeInsuranceV2Path()}`, requestData, options) as Promise<PostPortfolioLifeInsuranceV2FetchResponse>;
}

export type PatchPortfolioLifeInsuranceIdV2FetchResponse = 
| FetchResponse<ClientPortfolioDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const patchPortfolioLifeInsuranceIdV2Path = (id: number) => `/v2/portfolio/life-insurance/${id}`;

export const patchPortfolioLifeInsuranceIdV2 = (requestContract: ClientPortfolioLifeInsuranceEditRequestDTO, id: number, options?: FetchArgsOptions):
  Promise<PatchPortfolioLifeInsuranceIdV2FetchResponse> => {
    const requestData = getApiRequestData<ClientPortfolioLifeInsuranceEditRequestDTO>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchPortfolioLifeInsuranceIdV2Path(id)}`, requestData, options) as Promise<PatchPortfolioLifeInsuranceIdV2FetchResponse>;
}

export type GetPortfolioV2FetchResponse = 
| FetchResponse<{data: PortfolioListItemResponseDTO[];
	meta: DefaultListMetaDTO;}, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getPortfolioV2Path = () => `/v2/portfolio`;

export const getPortfolioV2 = (filterDatagroups?: PortfolioReportingOverviewTypeEnum[], filterOnlyreportingenabled?: boolean, filterArchived?: ArchivedFilterEnum, options?: FetchArgsOptions):
  Promise<GetPortfolioV2FetchResponse> => {
    const queryParams = {
      "filter[dataGroups][]": filterDatagroups,
      "filter[onlyReportingEnabled]": filterOnlyreportingenabled,
      "filter[archived]": filterArchived
    }
    return apiGet(`${getApiUrl()}${getPortfolioV2Path()}`, options, queryParams) as Promise<GetPortfolioV2FetchResponse>;
}

export type PostPortfolioLoansV2FetchResponse = 
| FetchResponse<PortfolioDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postPortfolioLoansV2Path = () => `/v2/portfolio/loans`;

export const postPortfolioLoansV2 = (requestContract: ClientPortfolioLoansCreateRequestDTO, options?: FetchArgsOptions):
  Promise<PostPortfolioLoansV2FetchResponse> => {
    const requestData = getApiRequestData<ClientPortfolioLoansCreateRequestDTO>(requestContract, false);

    return apiPost(`${getApiUrl()}${postPortfolioLoansV2Path()}`, requestData, options) as Promise<PostPortfolioLoansV2FetchResponse>;
}

export type PatchPortfolioLoansIdV2FetchResponse = 
| FetchResponse<PortfolioDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const patchPortfolioLoansIdV2Path = (id: number) => `/v2/portfolio/loans/${id}`;

export const patchPortfolioLoansIdV2 = (requestContract: ClientPortfolioLoansEditRequestDTO, id: number, options?: FetchArgsOptions):
  Promise<PatchPortfolioLoansIdV2FetchResponse> => {
    const requestData = getApiRequestData<ClientPortfolioLoansEditRequestDTO>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchPortfolioLoansIdV2Path(id)}`, requestData, options) as Promise<PatchPortfolioLoansIdV2FetchResponse>;
}

export type DeletePortfolioIdManualValueValueIdV2FetchResponse = 
| FetchResponse<ClientPortfolioManualValueListResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const deletePortfolioIdManualValueValueIdV2Path = (id: number, valueId: number) => `/v2/portfolio/${id}/manual-value/${valueId}`;

export const deletePortfolioIdManualValueValueIdV2 = (id: number, valueId: number, options?: FetchArgsOptions):
  Promise<DeletePortfolioIdManualValueValueIdV2FetchResponse> => {
    return apiDelete(`${getApiUrl()}${deletePortfolioIdManualValueValueIdV2Path(id, valueId)}`, options, {}) as Promise<DeletePortfolioIdManualValueValueIdV2FetchResponse>;
}

export type DeletePortfolioIdToolsToolIdManualValueValueIdV2FetchResponse = 
| FetchResponse<ClientPortfolioManualValueListResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const deletePortfolioIdToolsToolIdManualValueValueIdV2Path = (id: number, toolId: number, valueId: number) => `/v2/portfolio/${id}/tools/${toolId}/manual-value/${valueId}`;

export const deletePortfolioIdToolsToolIdManualValueValueIdV2 = (id: number, toolId: number, valueId: number, options?: FetchArgsOptions):
  Promise<DeletePortfolioIdToolsToolIdManualValueValueIdV2FetchResponse> => {
    return apiDelete(`${getApiUrl()}${deletePortfolioIdToolsToolIdManualValueValueIdV2Path(id, toolId, valueId)}`, options, {}) as Promise<DeletePortfolioIdToolsToolIdManualValueValueIdV2FetchResponse>;
}

export type GetPortfolioIdManualValueV2FetchResponse = 
| FetchResponse<ClientPortfolioManualValueListResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getPortfolioIdManualValueV2Path = (id: number) => `/v2/portfolio/${id}/manual-value`;

export const getPortfolioIdManualValueV2 = (id: number, options?: FetchArgsOptions):
  Promise<GetPortfolioIdManualValueV2FetchResponse> => {
    return apiGet(`${getApiUrl()}${getPortfolioIdManualValueV2Path(id)}`, options, {}) as Promise<GetPortfolioIdManualValueV2FetchResponse>;
}

export type PutPortfolioIdManualValueV2FetchResponse = 
| FetchResponse<ClientPortfolioManualValueResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const putPortfolioIdManualValueV2Path = (id: number) => `/v2/portfolio/${id}/manual-value`;

export const putPortfolioIdManualValueV2 = (requestContract: ClientPortfolioManualValueSaveRequestDTO, id: number, options?: FetchArgsOptions):
  Promise<PutPortfolioIdManualValueV2FetchResponse> => {
    const requestData = getApiRequestData<ClientPortfolioManualValueSaveRequestDTO>(requestContract, false);

    return apiPut(`${getApiUrl()}${putPortfolioIdManualValueV2Path(id)}`, requestData, options) as Promise<PutPortfolioIdManualValueV2FetchResponse>;
}

export type GetPortfolioIdToolsToolIdManualValueV2FetchResponse = 
| FetchResponse<ClientPortfolioManualValueListResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getPortfolioIdToolsToolIdManualValueV2Path = (id: number, toolId: number) => `/v2/portfolio/${id}/tools/${toolId}/manual-value`;

export const getPortfolioIdToolsToolIdManualValueV2 = (id: number, toolId: number, options?: FetchArgsOptions):
  Promise<GetPortfolioIdToolsToolIdManualValueV2FetchResponse> => {
    return apiGet(`${getApiUrl()}${getPortfolioIdToolsToolIdManualValueV2Path(id, toolId)}`, options, {}) as Promise<GetPortfolioIdToolsToolIdManualValueV2FetchResponse>;
}

export type PutPortfolioIdToolsToolIdManualValueV2FetchResponse = 
| FetchResponse<ClientPortfolioManualValueResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const putPortfolioIdToolsToolIdManualValueV2Path = (id: number, toolId: number) => `/v2/portfolio/${id}/tools/${toolId}/manual-value`;

export const putPortfolioIdToolsToolIdManualValueV2 = (requestContract: ClientPortfolioManualValueSaveRequestDTO, id: number, toolId: number, options?: FetchArgsOptions):
  Promise<PutPortfolioIdToolsToolIdManualValueV2FetchResponse> => {
    const requestData = getApiRequestData<ClientPortfolioManualValueSaveRequestDTO>(requestContract, false);

    return apiPut(`${getApiUrl()}${putPortfolioIdToolsToolIdManualValueV2Path(id, toolId)}`, requestData, options) as Promise<PutPortfolioIdToolsToolIdManualValueV2FetchResponse>;
}

export type PostPortfolioNonLifeInsuranceV2FetchResponse = 
| FetchResponse<ClientPortfolioDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postPortfolioNonLifeInsuranceV2Path = () => `/v2/portfolio/non-life-insurance`;

export const postPortfolioNonLifeInsuranceV2 = (requestContract: ClientPortfolioNonLifeInsuranceCreateRequestDTO, options?: FetchArgsOptions):
  Promise<PostPortfolioNonLifeInsuranceV2FetchResponse> => {
    const requestData = getApiRequestData<ClientPortfolioNonLifeInsuranceCreateRequestDTO>(requestContract, false);

    return apiPost(`${getApiUrl()}${postPortfolioNonLifeInsuranceV2Path()}`, requestData, options) as Promise<PostPortfolioNonLifeInsuranceV2FetchResponse>;
}

export type PatchPortfolioNonLifeInsuranceIdV2FetchResponse = 
| FetchResponse<ClientPortfolioDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const patchPortfolioNonLifeInsuranceIdV2Path = (id: number) => `/v2/portfolio/non-life-insurance/${id}`;

export const patchPortfolioNonLifeInsuranceIdV2 = (requestContract: ClientPortfolioNonLifeInsuranceEditRequestDTO, id: number, options?: FetchArgsOptions):
  Promise<PatchPortfolioNonLifeInsuranceIdV2FetchResponse> => {
    const requestData = getApiRequestData<ClientPortfolioNonLifeInsuranceEditRequestDTO>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchPortfolioNonLifeInsuranceIdV2Path(id)}`, requestData, options) as Promise<PatchPortfolioNonLifeInsuranceIdV2FetchResponse>;
}

export type PostPortfolioPensionProductsV2FetchResponse = 
| FetchResponse<PortfolioDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postPortfolioPensionProductsV2Path = () => `/v2/portfolio/pension-products`;

export const postPortfolioPensionProductsV2 = (requestContract: ClientPortfolioPensionProductsCreateRequestDTO, options?: FetchArgsOptions):
  Promise<PostPortfolioPensionProductsV2FetchResponse> => {
    const requestData = getApiRequestData<ClientPortfolioPensionProductsCreateRequestDTO>(requestContract, false);

    return apiPost(`${getApiUrl()}${postPortfolioPensionProductsV2Path()}`, requestData, options) as Promise<PostPortfolioPensionProductsV2FetchResponse>;
}

export type PatchPortfolioPensionProductsIdV2FetchResponse = 
| FetchResponse<PortfolioDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const patchPortfolioPensionProductsIdV2Path = (id: number) => `/v2/portfolio/pension-products/${id}`;

export const patchPortfolioPensionProductsIdV2 = (requestContract: ClientPortfolioPensionProductsEditRequestDTO, id: number, options?: FetchArgsOptions):
  Promise<PatchPortfolioPensionProductsIdV2FetchResponse> => {
    const requestData = getApiRequestData<ClientPortfolioPensionProductsEditRequestDTO>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchPortfolioPensionProductsIdV2Path(id)}`, requestData, options) as Promise<PatchPortfolioPensionProductsIdV2FetchResponse>;
}

export type GetPortfolioReportingOverviewV2FetchResponse = 
| FetchResponse<{data: ClientPortfolioReportingOverviewItemResponseDTO[];}, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getPortfolioReportingOverviewV2Path = () => `/v2/portfolio/reporting/overview`;

export const getPortfolioReportingOverviewV2 = (filterDatagroups?: PortfolioReportingOverviewTypeEnum[], filterOnlyreportingenabled?: boolean, filterArchived?: ArchivedFilterEnum, options?: FetchArgsOptions):
  Promise<GetPortfolioReportingOverviewV2FetchResponse> => {
    const queryParams = {
      "filter[dataGroups][]": filterDatagroups,
      "filter[onlyReportingEnabled]": filterOnlyreportingenabled,
      "filter[archived]": filterArchived
    }
    return apiGet(`${getApiUrl()}${getPortfolioReportingOverviewV2Path()}`, options, queryParams) as Promise<GetPortfolioReportingOverviewV2FetchResponse>;
}

export type GetPortfolioDomainProducersV2FetchResponse = 
| FetchResponse<{data: ProducerResponseDTO[];}, 200> 
| FetchResponse<void, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getPortfolioDomainProducersV2Path = (domain: string) => `/v2/portfolio/${domain}/producers`;

export const getPortfolioDomainProducersV2 = (domain: string, filterCategoryid?: number, options?: FetchArgsOptions):
  Promise<GetPortfolioDomainProducersV2FetchResponse> => {
    const queryParams = {
      "filter[categoryId]": filterCategoryid
    }
    return apiGet(`${getApiUrl()}${getPortfolioDomainProducersV2Path(domain)}`, options, queryParams) as Promise<GetPortfolioDomainProducersV2FetchResponse>;
}

export type GetPortfolioDomainProductCategoriesV2FetchResponse = 
| FetchResponse<{data: ProductCategoryResponseDTO[];}, 200> 
| FetchResponse<void, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getPortfolioDomainProductCategoriesV2Path = (domain: string) => `/v2/portfolio/${domain}/product-categories`;

export const getPortfolioDomainProductCategoriesV2 = (domain: string, options?: FetchArgsOptions):
  Promise<GetPortfolioDomainProductCategoriesV2FetchResponse> => {
    return apiGet(`${getApiUrl()}${getPortfolioDomainProductCategoriesV2Path(domain)}`, options, {}) as Promise<GetPortfolioDomainProductCategoriesV2FetchResponse>;
}

export type GetPortfolioDomainProductsV2FetchResponse = 
| FetchResponse<{data: ProductResponseDTO[];}, 200> 
| FetchResponse<void, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getPortfolioDomainProductsV2Path = (domain: string) => `/v2/portfolio/${domain}/products`;

export const getPortfolioDomainProductsV2 = (domain: string, filterProducerid?: number, options?: FetchArgsOptions):
  Promise<GetPortfolioDomainProductsV2FetchResponse> => {
    const queryParams = {
      "filter[producerId]": filterProducerid
    }
    return apiGet(`${getApiUrl()}${getPortfolioDomainProductsV2Path(domain)}`, options, queryParams) as Promise<GetPortfolioDomainProductsV2FetchResponse>;
}

export type PostPortfolioIdRelatedV2FetchResponse = 
| FetchResponse<ClientRelatedListResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postPortfolioIdRelatedV2Path = (id: number) => `/v2/portfolio/${id}/related`;

export const postPortfolioIdRelatedV2 = (requestContract: ClientRelatedPinRequestDTO, id: number, options?: FetchArgsOptions):
  Promise<PostPortfolioIdRelatedV2FetchResponse> => {
    const requestData = getApiRequestData<ClientRelatedPinRequestDTO>(requestContract, false);

    return apiPost(`${getApiUrl()}${postPortfolioIdRelatedV2Path(id)}`, requestData, options) as Promise<PostPortfolioIdRelatedV2FetchResponse>;
}

export type GetPortfolioIdRelatedOptionsV2FetchResponse = 
| FetchResponse<ClientRelatedOptionsResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getPortfolioIdRelatedOptionsV2Path = (id: number) => `/v2/portfolio/${id}/related/options`;

export const getPortfolioIdRelatedOptionsV2 = (id: number, options?: FetchArgsOptions):
  Promise<GetPortfolioIdRelatedOptionsV2FetchResponse> => {
    return apiGet(`${getApiUrl()}${getPortfolioIdRelatedOptionsV2Path(id)}`, options, {}) as Promise<GetPortfolioIdRelatedOptionsV2FetchResponse>;
}

export type DeletePortfolioIdRelatedRelatedIdV2FetchResponse = 
| FetchResponse<ClientRelatedListResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const deletePortfolioIdRelatedRelatedIdV2Path = (id: number, relatedId: number) => `/v2/portfolio/${id}/related/${relatedId}`;

export const deletePortfolioIdRelatedRelatedIdV2 = (id: number, relatedId: number, options?: FetchArgsOptions):
  Promise<DeletePortfolioIdRelatedRelatedIdV2FetchResponse> => {
    return apiDelete(`${getApiUrl()}${deletePortfolioIdRelatedRelatedIdV2Path(id, relatedId)}`, options, {}) as Promise<DeletePortfolioIdRelatedRelatedIdV2FetchResponse>;
}

export type GetPortfolioIdReportingV2FetchResponse = 
| FetchResponse<PortfolioReportingResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getPortfolioIdReportingV2Path = (id: number) => `/v2/portfolio/${id}/reporting`;

export const getPortfolioIdReportingV2 = (id: number, options?: FetchArgsOptions):
  Promise<GetPortfolioIdReportingV2FetchResponse> => {
    return apiGet(`${getApiUrl()}${getPortfolioIdReportingV2Path(id)}`, options, {}) as Promise<GetPortfolioIdReportingV2FetchResponse>;
}

export type GetPortfolioReportingSummaryV2FetchResponse = 
| FetchResponse<{data: PortfolioListReportingSummaryResponseDTO[];
	meta: DefaultListMetaDTO;}, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getPortfolioReportingSummaryV2Path = () => `/v2/portfolio/reporting/summary`;

export const getPortfolioReportingSummaryV2 = (filterPortfolioids?: number[], filterDatagroups?: PortfolioReportingOverviewTypeEnum[], options?: FetchArgsOptions):
  Promise<GetPortfolioReportingSummaryV2FetchResponse> => {
    const queryParams = {
      "filter[portfolioIds][]": filterPortfolioids,
      "filter[dataGroups][]": filterDatagroups
    }
    return apiGet(`${getApiUrl()}${getPortfolioReportingSummaryV2Path()}`, options, queryParams) as Promise<GetPortfolioReportingSummaryV2FetchResponse>;
}

export type PostPortfolioServicesV2FetchResponse = 
| FetchResponse<PortfolioDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postPortfolioServicesV2Path = () => `/v2/portfolio/services`;

export const postPortfolioServicesV2 = (requestContract: ClientPortfolioServicesCreateRequestDTO, options?: FetchArgsOptions):
  Promise<PostPortfolioServicesV2FetchResponse> => {
    const requestData = getApiRequestData<ClientPortfolioServicesCreateRequestDTO>(requestContract, false);

    return apiPost(`${getApiUrl()}${postPortfolioServicesV2Path()}`, requestData, options) as Promise<PostPortfolioServicesV2FetchResponse>;
}

export type PatchPortfolioServicesIdV2FetchResponse = 
| FetchResponse<PortfolioDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const patchPortfolioServicesIdV2Path = (id: number) => `/v2/portfolio/services/${id}`;

export const patchPortfolioServicesIdV2 = (requestContract: ClientPortfolioServicesEditRequestDTO, id: number, options?: FetchArgsOptions):
  Promise<PatchPortfolioServicesIdV2FetchResponse> => {
    const requestData = getApiRequestData<ClientPortfolioServicesEditRequestDTO>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchPortfolioServicesIdV2Path(id)}`, requestData, options) as Promise<PatchPortfolioServicesIdV2FetchResponse>;
}

export type PostPropertyArtV2FetchResponse = 
| FetchResponse<ClientPropertyArtDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postPropertyArtV2Path = () => `/v2/property/art`;

export const postPropertyArtV2 = (requestContract: ClientPropertyArtCreateRequestDTO, options?: FetchArgsOptions):
  Promise<PostPropertyArtV2FetchResponse> => {
    const requestData = getApiRequestData<ClientPropertyArtCreateRequestDTO>(requestContract, false);

    return apiPost(`${getApiUrl()}${postPropertyArtV2Path()}`, requestData, options) as Promise<PostPropertyArtV2FetchResponse>;
}

export type PatchPropertyArtIdV2FetchResponse = 
| FetchResponse<ClientPropertyArtDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const patchPropertyArtIdV2Path = (id: number) => `/v2/property/art/${id}`;

export const patchPropertyArtIdV2 = (requestContract: ClientPropertyArtEditRequestDTO, id: number, options?: FetchArgsOptions):
  Promise<PatchPropertyArtIdV2FetchResponse> => {
    const requestData = getApiRequestData<ClientPropertyArtEditRequestDTO>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchPropertyArtIdV2Path(id)}`, requestData, options) as Promise<PatchPropertyArtIdV2FetchResponse>;
}

export type PostPropertyCottageV2FetchResponse = 
| FetchResponse<ClientPropertyCottageDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postPropertyCottageV2Path = () => `/v2/property/cottage`;

export const postPropertyCottageV2 = (requestContract: ClientPropertyCottageCreateRequestDTO, options?: FetchArgsOptions):
  Promise<PostPropertyCottageV2FetchResponse> => {
    const requestData = getApiRequestData<ClientPropertyCottageCreateRequestDTO>(requestContract, false);

    return apiPost(`${getApiUrl()}${postPropertyCottageV2Path()}`, requestData, options) as Promise<PostPropertyCottageV2FetchResponse>;
}

export type PatchPropertyCottageIdV2FetchResponse = 
| FetchResponse<ClientPropertyCottageDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const patchPropertyCottageIdV2Path = (id: number) => `/v2/property/cottage/${id}`;

export const patchPropertyCottageIdV2 = (requestContract: ClientPropertyCottageEditRequestDTO, id: number, options?: FetchArgsOptions):
  Promise<PatchPropertyCottageIdV2FetchResponse> => {
    const requestData = getApiRequestData<ClientPropertyCottageEditRequestDTO>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchPropertyCottageIdV2Path(id)}`, requestData, options) as Promise<PatchPropertyCottageIdV2FetchResponse>;
}

export type GetPropertyIdV2FetchResponse = 
| FetchResponse<ClientPropertyVehicleDetailResponseDTO | ClientPropertyHouseDetailResponseDTO | ClientPropertyFlatDetailResponseDTO | ClientPropertyCottageDetailResponseDTO | ClientPropertyLandDetailResponseDTO | ClientPropertyArtDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getPropertyIdV2Path = (id: number) => `/v2/property/${id}`;

export const getPropertyIdV2 = (id: number, options?: FetchArgsOptions):
  Promise<GetPropertyIdV2FetchResponse> => {
    return apiGet(`${getApiUrl()}${getPropertyIdV2Path(id)}`, options, {}) as Promise<GetPropertyIdV2FetchResponse>;
}

export type DeletePropertyIdV2FetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const deletePropertyIdV2Path = (id: number) => `/v2/property/${id}`;

export const deletePropertyIdV2 = (id: number, options?: FetchArgsOptions):
  Promise<DeletePropertyIdV2FetchResponse> => {
    return apiDelete(`${getApiUrl()}${deletePropertyIdV2Path(id)}`, options, {}) as Promise<DeletePropertyIdV2FetchResponse>;
}

export type GetPropertyIdDocumentsV2FetchResponse = 
| FetchResponse<{data: PortfolioDocumentListItemDTO[];
	meta: DefaultListMetaDTO;}, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getPropertyIdDocumentsV2Path = (id: number) => `/v2/property/${id}/documents`;

export const getPropertyIdDocumentsV2 = (id: number, options?: FetchArgsOptions):
  Promise<GetPropertyIdDocumentsV2FetchResponse> => {
    return apiGet(`${getApiUrl()}${getPropertyIdDocumentsV2Path(id)}`, options, {}) as Promise<GetPropertyIdDocumentsV2FetchResponse>;
}

export type PostPropertyFlatV2FetchResponse = 
| FetchResponse<ClientPropertyFlatDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postPropertyFlatV2Path = () => `/v2/property/flat`;

export const postPropertyFlatV2 = (requestContract: ClientPropertyFlatCreateRequestDTO, options?: FetchArgsOptions):
  Promise<PostPropertyFlatV2FetchResponse> => {
    const requestData = getApiRequestData<ClientPropertyFlatCreateRequestDTO>(requestContract, false);

    return apiPost(`${getApiUrl()}${postPropertyFlatV2Path()}`, requestData, options) as Promise<PostPropertyFlatV2FetchResponse>;
}

export type PatchPropertyFlatIdV2FetchResponse = 
| FetchResponse<ClientPropertyFlatDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const patchPropertyFlatIdV2Path = (id: number) => `/v2/property/flat/${id}`;

export const patchPropertyFlatIdV2 = (requestContract: ClientPropertyFlatEditRequestDTO, id: number, options?: FetchArgsOptions):
  Promise<PatchPropertyFlatIdV2FetchResponse> => {
    const requestData = getApiRequestData<ClientPropertyFlatEditRequestDTO>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchPropertyFlatIdV2Path(id)}`, requestData, options) as Promise<PatchPropertyFlatIdV2FetchResponse>;
}

export type PostPropertyHouseV2FetchResponse = 
| FetchResponse<ClientPropertyHouseDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postPropertyHouseV2Path = () => `/v2/property/house`;

export const postPropertyHouseV2 = (requestContract: ClientPropertyHouseCreateRequestDTO, options?: FetchArgsOptions):
  Promise<PostPropertyHouseV2FetchResponse> => {
    const requestData = getApiRequestData<ClientPropertyHouseCreateRequestDTO>(requestContract, false);

    return apiPost(`${getApiUrl()}${postPropertyHouseV2Path()}`, requestData, options) as Promise<PostPropertyHouseV2FetchResponse>;
}

export type PatchPropertyHouseIdV2FetchResponse = 
| FetchResponse<ClientPropertyHouseDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const patchPropertyHouseIdV2Path = (id: number) => `/v2/property/house/${id}`;

export const patchPropertyHouseIdV2 = (requestContract: ClientPropertyHouseEditRequestDTO, id: number, options?: FetchArgsOptions):
  Promise<PatchPropertyHouseIdV2FetchResponse> => {
    const requestData = getApiRequestData<ClientPropertyHouseEditRequestDTO>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchPropertyHouseIdV2Path(id)}`, requestData, options) as Promise<PatchPropertyHouseIdV2FetchResponse>;
}

export type PostPropertyLandV2FetchResponse = 
| FetchResponse<ClientPropertyLandDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postPropertyLandV2Path = () => `/v2/property/land`;

export const postPropertyLandV2 = (requestContract: ClientPropertyLandCreateRequestDTO, options?: FetchArgsOptions):
  Promise<PostPropertyLandV2FetchResponse> => {
    const requestData = getApiRequestData<ClientPropertyLandCreateRequestDTO>(requestContract, false);

    return apiPost(`${getApiUrl()}${postPropertyLandV2Path()}`, requestData, options) as Promise<PostPropertyLandV2FetchResponse>;
}

export type PatchPropertyLandIdV2FetchResponse = 
| FetchResponse<ClientPropertyLandDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const patchPropertyLandIdV2Path = (id: number) => `/v2/property/land/${id}`;

export const patchPropertyLandIdV2 = (requestContract: ClientPropertyLandEditRequestDTO, id: number, options?: FetchArgsOptions):
  Promise<PatchPropertyLandIdV2FetchResponse> => {
    const requestData = getApiRequestData<ClientPropertyLandEditRequestDTO>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchPropertyLandIdV2Path(id)}`, requestData, options) as Promise<PatchPropertyLandIdV2FetchResponse>;
}

export type GetPropertyV2FetchResponse = 
| FetchResponse<{data: ClientPropertyItemResponseDTO[];
	meta: DefaultListMetaDTO;}, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getPropertyV2Path = () => `/v2/property`;

export const getPropertyV2 = (filterDatagroups?: PortfolioReportingOverviewTypeEnum[], filterOnlyreportingenabled?: boolean, filterArchived?: ArchivedFilterEnum, options?: FetchArgsOptions):
  Promise<GetPropertyV2FetchResponse> => {
    const queryParams = {
      "filter[dataGroups][]": filterDatagroups,
      "filter[onlyReportingEnabled]": filterOnlyreportingenabled,
      "filter[archived]": filterArchived
    }
    return apiGet(`${getApiUrl()}${getPropertyV2Path()}`, options, queryParams) as Promise<GetPropertyV2FetchResponse>;
}

export type PostPropertyIdRelatedV2FetchResponse = 
| FetchResponse<ClientRelatedListResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postPropertyIdRelatedV2Path = (id: number) => `/v2/property/${id}/related`;

export const postPropertyIdRelatedV2 = (requestContract: ClientRelatedPinRequestDTO, id: number, options?: FetchArgsOptions):
  Promise<PostPropertyIdRelatedV2FetchResponse> => {
    const requestData = getApiRequestData<ClientRelatedPinRequestDTO>(requestContract, false);

    return apiPost(`${getApiUrl()}${postPropertyIdRelatedV2Path(id)}`, requestData, options) as Promise<PostPropertyIdRelatedV2FetchResponse>;
}

export type GetPropertyIdRelatedOptionsV2FetchResponse = 
| FetchResponse<ClientRelatedOptionsResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getPropertyIdRelatedOptionsV2Path = (id: number) => `/v2/property/${id}/related/options`;

export const getPropertyIdRelatedOptionsV2 = (id: number, options?: FetchArgsOptions):
  Promise<GetPropertyIdRelatedOptionsV2FetchResponse> => {
    return apiGet(`${getApiUrl()}${getPropertyIdRelatedOptionsV2Path(id)}`, options, {}) as Promise<GetPropertyIdRelatedOptionsV2FetchResponse>;
}

export type DeletePropertyIdRelatedRelatedIdV2FetchResponse = 
| FetchResponse<ClientRelatedListResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const deletePropertyIdRelatedRelatedIdV2Path = (id: number, relatedId: number) => `/v2/property/${id}/related/${relatedId}`;

export const deletePropertyIdRelatedRelatedIdV2 = (id: number, relatedId: number, options?: FetchArgsOptions):
  Promise<DeletePropertyIdRelatedRelatedIdV2FetchResponse> => {
    return apiDelete(`${getApiUrl()}${deletePropertyIdRelatedRelatedIdV2Path(id, relatedId)}`, options, {}) as Promise<DeletePropertyIdRelatedRelatedIdV2FetchResponse>;
}

export type PostPropertyVehicleV2FetchResponse = 
| FetchResponse<ClientPropertyVehicleDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postPropertyVehicleV2Path = () => `/v2/property/vehicle`;

export const postPropertyVehicleV2 = (requestContract: ClientPropertyVehicleCreateRequestDTO, options?: FetchArgsOptions):
  Promise<PostPropertyVehicleV2FetchResponse> => {
    const requestData = getApiRequestData<ClientPropertyVehicleCreateRequestDTO>(requestContract, false);

    return apiPost(`${getApiUrl()}${postPropertyVehicleV2Path()}`, requestData, options) as Promise<PostPropertyVehicleV2FetchResponse>;
}

export type PatchPropertyVehicleIdV2FetchResponse = 
| FetchResponse<ClientPropertyVehicleDetailResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const patchPropertyVehicleIdV2Path = (id: number) => `/v2/property/vehicle/${id}`;

export const patchPropertyVehicleIdV2 = (requestContract: ClientPropertyVehicleEditRequestDTO, id: number, options?: FetchArgsOptions):
  Promise<PatchPropertyVehicleIdV2FetchResponse> => {
    const requestData = getApiRequestData<ClientPropertyVehicleEditRequestDTO>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchPropertyVehicleIdV2Path(id)}`, requestData, options) as Promise<PatchPropertyVehicleIdV2FetchResponse>;
}

export type GetClientIdentificationDocumentsIdRemindersV2FetchResponse = 
| FetchResponse<ReminderListResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<void, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getClientIdentificationDocumentsIdRemindersV2Path = (id: number) => `/v2/client/identification-documents/${id}/reminders`;

export const getClientIdentificationDocumentsIdRemindersV2 = (id: number, options?: FetchArgsOptions):
  Promise<GetClientIdentificationDocumentsIdRemindersV2FetchResponse> => {
    return apiGet(`${getApiUrl()}${getClientIdentificationDocumentsIdRemindersV2Path(id)}`, options, {}) as Promise<GetClientIdentificationDocumentsIdRemindersV2FetchResponse>;
}

export type PostClientIdentificationDocumentsIdRemindersV2FetchResponse = 
| FetchResponse<ReminderResponseDTO, 200> 
| FetchResponse<void, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<void, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postClientIdentificationDocumentsIdRemindersV2Path = (id: number) => `/v2/client/identification-documents/${id}/reminders`;

export const postClientIdentificationDocumentsIdRemindersV2 = (requestContract: CreateReminderRequestDTO, id: number, options?: FetchArgsOptions):
  Promise<PostClientIdentificationDocumentsIdRemindersV2FetchResponse> => {
    const requestData = getApiRequestData<CreateReminderRequestDTO>(requestContract, false);

    return apiPost(`${getApiUrl()}${postClientIdentificationDocumentsIdRemindersV2Path(id)}`, requestData, options) as Promise<PostClientIdentificationDocumentsIdRemindersV2FetchResponse>;
}

export type GetPortfolioPortfolioIdRemindersV2FetchResponse = 
| FetchResponse<ReminderListResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<void, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getPortfolioPortfolioIdRemindersV2Path = (portfolioId: number) => `/v2/portfolio/${portfolioId}/reminders`;

export const getPortfolioPortfolioIdRemindersV2 = (portfolioId: number, filterStatuses?: ReminderStatusEnum[], filterSortby?: ReminderSortFieldEnum, filterSortdirection?: SortDirectionEnum, options?: FetchArgsOptions):
  Promise<GetPortfolioPortfolioIdRemindersV2FetchResponse> => {
    const queryParams = {
      "filter[statuses][]": filterStatuses,
      "filter[sortBy]": filterSortby,
      "filter[sortDirection]": filterSortdirection
    }
    return apiGet(`${getApiUrl()}${getPortfolioPortfolioIdRemindersV2Path(portfolioId)}`, options, queryParams) as Promise<GetPortfolioPortfolioIdRemindersV2FetchResponse>;
}

export type PostPortfolioPortfolioIdRemindersV2FetchResponse = 
| FetchResponse<ReminderResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<void, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postPortfolioPortfolioIdRemindersV2Path = (portfolioId: number) => `/v2/portfolio/${portfolioId}/reminders`;

export const postPortfolioPortfolioIdRemindersV2 = (requestContract: CreateReminderRequestDTO, portfolioId: number, options?: FetchArgsOptions):
  Promise<PostPortfolioPortfolioIdRemindersV2FetchResponse> => {
    const requestData = getApiRequestData<CreateReminderRequestDTO>(requestContract, false);

    return apiPost(`${getApiUrl()}${postPortfolioPortfolioIdRemindersV2Path(portfolioId)}`, requestData, options) as Promise<PostPortfolioPortfolioIdRemindersV2FetchResponse>;
}

export type GetPropertyPropertyIdRemindersV2FetchResponse = 
| FetchResponse<ReminderListResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<void, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getPropertyPropertyIdRemindersV2Path = (propertyId: number) => `/v2/property/${propertyId}/reminders`;

export const getPropertyPropertyIdRemindersV2 = (propertyId: number, filterStatuses?: ReminderStatusEnum[], filterSortby?: ReminderSortFieldEnum, filterSortdirection?: SortDirectionEnum, options?: FetchArgsOptions):
  Promise<GetPropertyPropertyIdRemindersV2FetchResponse> => {
    const queryParams = {
      "filter[statuses][]": filterStatuses,
      "filter[sortBy]": filterSortby,
      "filter[sortDirection]": filterSortdirection
    }
    return apiGet(`${getApiUrl()}${getPropertyPropertyIdRemindersV2Path(propertyId)}`, options, queryParams) as Promise<GetPropertyPropertyIdRemindersV2FetchResponse>;
}

export type PostPropertyPropertyIdRemindersV2FetchResponse = 
| FetchResponse<ReminderResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<void, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postPropertyPropertyIdRemindersV2Path = (propertyId: number) => `/v2/property/${propertyId}/reminders`;

export const postPropertyPropertyIdRemindersV2 = (requestContract: CreateReminderRequestDTO, propertyId: number, options?: FetchArgsOptions):
  Promise<PostPropertyPropertyIdRemindersV2FetchResponse> => {
    const requestData = getApiRequestData<CreateReminderRequestDTO>(requestContract, false);

    return apiPost(`${getApiUrl()}${postPropertyPropertyIdRemindersV2Path(propertyId)}`, requestData, options) as Promise<PostPropertyPropertyIdRemindersV2FetchResponse>;
}

export type DeleteRemindersIdV2FetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<void, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const deleteRemindersIdV2Path = (id: number) => `/v2/reminders/${id}`;

export const deleteRemindersIdV2 = (id: number, options?: FetchArgsOptions):
  Promise<DeleteRemindersIdV2FetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteRemindersIdV2Path(id)}`, options, {}) as Promise<DeleteRemindersIdV2FetchResponse>;
}

export type PatchRemindersIdV2FetchResponse = 
| FetchResponse<UpdateReminderResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<void, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const patchRemindersIdV2Path = (id: number) => `/v2/reminders/${id}`;

export const patchRemindersIdV2 = (requestContract: UpdateReminderRequestDTO, id: number, options?: FetchArgsOptions):
  Promise<PatchRemindersIdV2FetchResponse> => {
    const requestData = getApiRequestData<UpdateReminderRequestDTO>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchRemindersIdV2Path(id)}`, requestData, options) as Promise<PatchRemindersIdV2FetchResponse>;
}

export type GetRemindersTypesV2FetchResponse = 
| FetchResponse<ReminderTypeListResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getRemindersTypesV2Path = () => `/v2/reminders/types`;

export const getRemindersTypesV2 = (entity: ReminderEntityTypeEnum, entityId: number, options?: FetchArgsOptions):
  Promise<GetRemindersTypesV2FetchResponse> => {
    const queryParams = {
      "entity": entity,
      "entityId": entityId
    }
    return apiGet(`${getApiUrl()}${getRemindersTypesV2Path()}`, options, queryParams) as Promise<GetRemindersTypesV2FetchResponse>;
}

export type GetRightsV2FetchResponse = 
| FetchResponse<RightsResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getRightsV2Path = () => `/v2/rights`;

export const getRightsV2 = (options?: FetchArgsOptions):
  Promise<GetRightsV2FetchResponse> => {
    return apiGet(`${getApiUrl()}${getRightsV2Path()}`, options, {}) as Promise<GetRightsV2FetchResponse>;
}

export type GetTaskIdV2FetchResponse = 
| FetchResponse<TaskDetailResponse, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getTaskIdV2Path = (id: number) => `/v2/task/${id}`;

export const getTaskIdV2 = (id: number, options?: FetchArgsOptions):
  Promise<GetTaskIdV2FetchResponse> => {
    return apiGet(`${getApiUrl()}${getTaskIdV2Path(id)}`, options, {}) as Promise<GetTaskIdV2FetchResponse>;
}

export type GetTaskV2FetchResponse = 
| FetchResponse<{data: TaskListItemResponseDTO[];
	meta: DefaultListMetaDTO;}, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getTaskV2Path = () => `/v2/task`;

export const getTaskV2 = (filterDatefrom?: string, filterDateto?: string, filterOnlyunsolved?: boolean, filterOnlysolved?: boolean, limit?: number, offset?: number, filterSortdesc?: boolean, options?: FetchArgsOptions):
  Promise<GetTaskV2FetchResponse> => {
    const queryParams = {
      "filter[dateFrom]": filterDatefrom,
      "filter[dateTo]": filterDateto,
      "filter[onlyUnsolved]": filterOnlyunsolved,
      "filter[onlySolved]": filterOnlysolved,
      "limit": limit,
      "offset": offset,
      "filter[sortDesc]": filterSortdesc
    }
    return apiGet(`${getApiUrl()}${getTaskV2Path()}`, options, queryParams) as Promise<GetTaskV2FetchResponse>;
}

export type GetTaskIdWorkflowsV2FetchResponse = 
| FetchResponse<EntityListOfTaskWorkflowResponse, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<void, 404> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const getTaskIdWorkflowsV2Path = (id: number) => `/v2/task/${id}/workflows`;

export const getTaskIdWorkflowsV2 = (id: number, options?: FetchArgsOptions):
  Promise<GetTaskIdWorkflowsV2FetchResponse> => {
    return apiGet(`${getApiUrl()}${getTaskIdWorkflowsV2Path(id)}`, options, {}) as Promise<GetTaskIdWorkflowsV2FetchResponse>;
}

export type PostUsersLanguageV2FetchResponse = 
| FetchResponse<UserLanguageResponseDTO, 200> 
| FetchResponse<ExceptionDTO, 400> 
| FetchResponse<ExceptionDTO, 401> 
| FetchResponse<ExceptionDTO, 403> 
| FetchResponse<ExceptionDTO, 500> 
| ErrorResponse;

export const postUsersLanguageV2Path = () => `/v2/users/language`;

export const postUsersLanguageV2 = (requestContract: UserLanguageUpdateRequestDTO, options?: FetchArgsOptions):
  Promise<PostUsersLanguageV2FetchResponse> => {
    const requestData = getApiRequestData<UserLanguageUpdateRequestDTO>(requestContract, false);

    return apiPost(`${getApiUrl()}${postUsersLanguageV2Path()}`, requestData, options) as Promise<PostUsersLanguageV2FetchResponse>;
}
